const ar = {
  // ==========================================
  // HEADER
  // ==========================================
  header: {
    search_placeholder: "بحث...",
    filter: "تصفية",
    support: "الدعم",
    stock: "المخزون",
    payment: "الدفع",
    exchange: "التبادل",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
    role_admin: "مدير",
    role_assistant: "مساعد",
    role_confirmator: "مؤكد",
    role_livreur: "موصل",
    role_seller: "بائع",
  },

  // ==========================================
  // NAVBAR
  // ==========================================
  navbar: {
    section_general: "الرئيسية",
    section_operations: "العمليات",
    section_team: "الفريق والمدفوعات",
    section_settings: "الإعدادات",
    dashboard: "لوحة التحكم",
    orders: "الطلبات",
    all_orders: "جميع الطلبات",
    new_order: "جديد",
    delivered: "تم التسليم",
    confirmed: "مؤكد",
    waiting_confirmation: "في انتظار التأكيد",
    in_follow_up: "قيد المتابعة",
    in_delivery: "قيد التوصيل",
    returned: "مرتجع",
    refused: "مرفوض",
    cancelled: "ملغي",
    products: "المنتجات",
    categories: "الفئات",
    stock_management: "إدارة المخزون",
    variants: "المتغيرات",
    cities: "المدن",
    configurations: "الإعدادات",
    scan: "مسح",
    scan_return: "مسح المرتجعات",
    scan_ramassage: "مسح عند الاستلام",
    team: "الفريق",
    admins: "المديرون",
    sellers: "البائعون",
    confirmators: "المؤكدون",
    livreur: "الموصل",
    suppliers: "الموردون",
    roles: "الأدوار",
    black_list: "القائمة السوداء",
    payments_simple: "المدفوعات",
    payments: "المدفوعات",
    sallers: "البائعون",
    confirmators_pay: "المؤكدون",
    system: "النظام",
    integrations: "التكاملات",
    delivery: "التوصيل",
    applications: "التطبيقات",
    api_docs: "توثيق API",
    complaints: "الشكاوى",
    announcements: "الإعلانات",
    activity_logs: "سجل النشاطات",
    go_premium: "الترقية إلى بريميوم",
    go_premium_desc: "افتح المزيد من الميزات وطوّر عملك.",
    discover_premium: "اكتشف بريميوم",
  },

  // ==========================================
  // DASHBOARD - COMMON
  // ==========================================
  dashboard: {
    title: "لوحة التحكم",
    subtitle_seller: "مرحبًا بعودتك! إليك ما يحدث في عملك.",
    subtitle_admin: "إليك نظرة شاملة على أداء منصتك.",
    subtitle_confirmator: "مرحبًا! إليك نظرة على أداء التأكيدات الخاصة بك.",
    subtitle_livreur: "مرحبًا! إليك ملخص عمليات التوصيل الخاصة بك.",
    subtitle_account: "مرحبًا بعودتك! إليك ما يحدث في حسابك.",
    refresh: "تحديث",
    refreshing: "جاري التحديث...",
    loading: "جاري التحميل...",
    vs_last_month: "مقارنة بالشهر الماضي",
    all: "الكل",
    search_seller: "البحث عن بائع...",
    all_sellers: "جميع البائعين",
    filter_by_status: "تصفية بالحالة...",
    unknown: "غير معروف",
    no_store: "لا يوجد متجر",
    refrech: "تحديث",
    on_refrech: "تحديث...",
  },

  // ==========================================
  // STATS CARDS
  // ==========================================
  stats: {
    revenue: "رقم المعاملات",
    total_purchase: "إجمالي المشتريات",
    delivery_fees: "رسوم التوصيل",
    net_profit: "صافي الربح",
    total_orders: "إجمالي الطلبات",
    new_orders: "طلبات جديدة",
    pending_payments: "مدفوعات معلقة",
    pending_payment: "دفعة معلقة",
    sellers_profit: "ربح البائعين",
    confirmator_profit: "ربح المؤكد",
    delivery_rate: "نسبة التوصيل",
    delivery_profit: "ربح التوصيل",
    orders_today: "طلبات اليوم",
    in_delivery: "قيد التوصيل",
  },

  // ==========================================
  // ORDER STATUS
  // ==========================================
  status : {
    nouveau: "جديد",
    confirme: "مؤكد",
    paid: "مدفوع",
    reporte: "في انتظار التأكيد",
    nonconfirme: "غير مؤكد",
    indelivery: "قيد التوصيل",
    livre: "تم التسليم",
    "Livre(paye)": "تم التسليم (مدفوع)",
    pending_payment: "في انتظار الدفع",
    retour: "راجع",
    refuse: "مرفوض",
    "pre_a_ramasse": "جاهز للتسليم",
    "Refusé par livreur": "مرفوض من طرف الموزع",
    annule: "ملغي",
    suivi: "متابع",
    duplicated: "مكرر",
  
    "Attente De Ramassage": "في انتظار الاستلام",
    Ramassé: "تم الاستلام",
    Expédié: "تم الإرسال",
    "Prèt pour expédition": "جاهز للشحن",
    "Mise en distribution": "قيد التوزيع",
    Programmé: "مجدول",
    Interessé: "مهتم",
    "Reçu par livreur": "تم الاستلام من طرف الموزع",
    "Envoyé à l'agence": "تم الإرسال إلى الوكالة",
    "Reçu En Agence De Livraison": "تم الاستلام في وكالة التوصيل",
    "Reporté par livreur": "مؤجل من طرف الموزع",
    "en voyage": "في الطريق",
    "En cours de livraison": "قيد التوصيل",
    "Pré ramassé": "قبل الاستلام",
    "en cours de preparation": "قيد التحضير",
    "en livraison": "قيد التوصيل",
    "En Transport": "قيد النقل",
    "Client disponible pour livraison": "العميل متاح للتسليم",
    "Recu sur agence casa": "تم الاستلام في وكالة الدار البيضاء",
  
    "Demande de retour": "طلب إرجاع",
    "Retour client expédié": "تم إرسال المرتجع من العميل",
    "Retour vers agence casa": "إرجاع إلى وكالة الدار البيضاء",
    "Retour vers Agence Casa": "إرجاع إلى وكالة الدار البيضاء",
    "Retour Reçu Agence casa": "تم استلام المرتجع في الوكالة",
    "Retour reçu agence casa": "تم استلام المرتجع في الوكالة",
    "Retour reçu par agence": "تم استلام المرتجع من الوكالة",
    "Retour reçu par livreur": "تم استلام المرتجع من الموزع",
    "Retour client Reçu": "تم استلام مرتجع العميل",
    "Retour prêt pour l'expedition": "مرتجع جاهز للشحن",
    "A retourner vers agence principal casa": "إرجاع إلى الوكالة الرئيسية الدار البيضاء",
    "Retour expédié": "تم إرسال المرتجع",
    "Retour reçu par {{city}}": "تم استلام المرتجع في {{city}}",
    "Colis prêt pour le retour": "الطرد جاهز للإرجاع",
    "Retour en cours de la livraison": "مرتجع قيد التوصيل",
    "Retour débarrasse": "تم تفريغ المرتجع",
    "Retour en stock": "تم إرجاعه للمخزون",
    retour_recu: "تم استلام المرتجع",
    "Retour client reçu": "تم استلام مرتجع العميل",
  
    "sans adresse": "بدون عنوان",
    Injoignable: "غير قابل للاتصال",
    "Boite Vocal": "البريد الصوتي",
    "Pas de réponse": "لا يوجد رد",
    "pas de réponse 2 fois": "لم يتم الرد مرتين",
    "Pas de réponse 3 fois": "لم يتم الرد 3 مرات",
    "Pas de réponse J+2": "لم يتم الرد خلال يومين",
    "Pas de réponse J+3": "لم يتم الرد خلال 3 أيام",
    "pas réponse + déplacement J+2": "لا رد + تنقل خلال يومين",
    "pas réponse + déplacement J+3": "لا رد + تنقل خلال 3 أيام",
    "pas réponse +déplacement": "لا رد + تنقل",
    "Pas de reponse ( SUIVI )": "لا رد (متابعة)",
    "Injoignable ( SUIVI )": "غير قابل للاتصال (متابعة)",
    "Reporté ( SUIVI )": "مؤجل (متابعة)",
    "Boite Vocal ( SUIVI )": "البريد الصوتي (متابعة)",
    "Faux destination": "عنوان خاطئ",
    "Hors zone": "خارج التغطية",
    "Hors-zone": "خارج التغطية",
    "Pas Interessé": "غير مهتم",
    "Produit endommagé": "منتج تالف",
    Perdu: "ضائع",
  
    "Demande de suivi": "طلب متابعة",
    "Annulé ( SUIVI )": "ملغي (متابعة)",
    "Annulé par livreur": "ملغي من طرف الموزع",
    "Changement adresse": "تغيير العنوان",
    "Changement d'adresse": "تغيير العنوان",
    "Reçu par erreur": "تم الاستلام عن طريق الخطأ",
    "Non reçu": "لم يتم الاستلام",
    "Colis archivé": "طرد مؤرشف",
    "reportée indéfiniment": "مؤجل بدون مدة",
    "reporté aujourd hui": "مؤجل اليوم",
    "Erreur Numero": "خطأ في الرقم",
    Remboursé: "تم استرجاع المبلغ",
  },

  // ==========================================
  // ORDER  MODEL
  // ==========================================

  order_modal: {
    page_title: "نظام الطلب",
    page_subtitle: "إضافة عدة عملاء وطلباتهم",
    grand_total: "المجموع الكلي",
    saving: "جاري الحفظ...",
    save_all: "حفظ الكل",
    client_title: "العميل #{index}",
    in_stock: "متوفر",
    out_of_stock: "غير متوفر",
    percent_off: "-{value}% خصم",
    article_title: "المنتج #{index}",
    label_name: "الاسم",
    label_phone: "الهاتف",
    label_city: "المدينة",
    label_selling_price: "سعر البيع",
    label_address: "العنوان",
    label_quantity: "الكمية",
    label_comment: "تعليق",
    label_change: "تغيير",
    label_unlock: "فتح الطرد",
    label_confirmed: "مؤكد بالفعل",
    total_client: "إجمالي العميل:",
    profit: "الربح :",
    enter_address: "أدخل العنوان...",
    enter_comment: "أدخل التعليق...",
    enter_selling_price: "أدخل سعر البيع...",
    at_least_one_client: "يجب أن يكون لديك عميل واحد على الأقل.",
    fill_client_info: "يرجى ملء جميع معلومات العميل (الاسم، الهاتف، المدينة، العنوان).",
    min_quantity: "يجب على العميل طلب كمية واحدة على الأقل.",
    valid_selling_price: "يجب أن يكون للعميل سعر بيع صحيح (> {price}).",
    profit_min_error: "يجب أن يكون ربح الطلب 10 دراهم على الأقل.",
    select_variants: "المنتج #{index}: يرجى تحديد جميع المتغيرات المطلوبة. المفقود: {types}",
    orders_saved: "تم حفظ الطلبات بنجاح!",
    save_failed: "فشل حفظ الطلبات: {message}",
    validation_failed: "فشل التحقق. تحقق من مدخلاتك.",
    save_error: "خطأ أثناء الحفظ: {message}",
    error_generic: "خطأ: {message}",
    unexpected_city_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات المدن.",
    error_loading_cities: "خطأ أثناء تحميل المدن.",
  },

  // ==========================================
  // CHARTS & SECTIONS
  // ==========================================
  charts: {
    delivered_percentage: "نسبة التسليم",
    delivered_percentage_desc: "يشير إلى الطلبات التي تم تسليمها.",
    confirmed_percentage: "نسبة التأكيد",
    confirmed_percentage_desc: "يشير إلى الطلبات المؤكدة.",
    orders_by_city: "توزيع الطلبات حسب المدينة",
    orders_by_city_desc: "عدد الطلبات حسب المنطقة الجغرافية",
    last_payments: "آخر خمس مدفوعات",
    last_payments_desc: "نظرة عامة على آخر خمس مدفوعات",
    top_products: "أفضل 5 منتجات",
    top_products_desc: "المنتجات الأكثر أداءً",
    top_sellers: "أفضل 5 بائعين",
    top_sellers_desc: "البائعون الأكثر أداءً",
    top_cities: "أفضل 5 مدن",
    top_cities_desc: "المدن الأكثر طلباتاً",
    ville: "المدينة",
    delivered: "تم التوصيل",
    rate: "المعدل",
    top_confirmators: "أفضل المؤكدين",
    top_confirmators_desc: "يشير إلى المؤكدين.",
    top_confirmators_alt: "أفضل المؤكدين",
    top_confirmators_alt_desc: "أداء المؤكدين.",
    paid_on: "تم الدفع في",
    sales: "مبيعات",
    orders: "طلبات",
    revenue_label: "إيرادات",
    live_activity: "النشاط المباشر",
    realtime_engagement: "التفاعل في الوقت الحقيقي",
    active_users: "المستخدمون النشطون",
    page_views: "مشاهدات الصفحات",
    bounce_rate: "معدل الارتداد",
    shortcuts: "اختصارات",
    orders_par_days: "الطلبات حسب اليوم",
    nomber_orders_par_days: "عدد الطلبات اليومية",
    total_orders: "إجمالي الطلبات",
    daily_average: "المتوسط اليومي",
    per_day: "في اليوم",
    day: "يوم",
    revenue_per_day: "الإيرادات حسب اليوم",
    monthly_daily_revenue: "الإيرادات اليومية للشهر",
    total_revenue: "إجمالي الإيرادات",
    confirmed_orders: "الطلبات المؤكدة",
    percentage: "النسبة المئوية",
    out_of_100: "من 100%",
    no_data_available: "لا توجد بيانات متاحة",
    delivery_time: "وقت التوصيل",
    delivery_time_desc: "توزيع الوقت بين الشحن والتسليم",

  },

  common: {
    sort: "ترتيب",
    sort_by: "ترتيب حسب",
    filters: "الفلاتر",
    alphabetical: "أبجدي",
    newest_first: "الأحدث أولاً",
    oldest_first: "الأقدم أولاً",
    showing: "عرض",
    of: "من",
    page: "صفحة",
    found: "تم العثور عليها",
    results: "نتائج",
    retry: "إعادة المحاولة",
    previous: "السابق",
    next: "التالي",
    sorted_by: "مرتبة حسب",
    adjust_search: "حاول تعديل كلمات البحث أو الفلاتر.",
    refresh_page_hint: "يرجى محاولة تحديث الصفحة.",
    last_updated: "آخر تحديث",
    not_available: "غير متوفر",
    currency: "د.م",
    this_month: "هذا الشهر",
    updated_live: "مباشر",
    needs_attention: "يحتاج متابعة",
    view: "عرض",
    delete: "حذف",
  },

  filter_orders: {
    all_sellers: "جميع البائعين",
    all_livreurs: "جميع الموصلين",
    all_products: "جميع المنتجات",
    unknown: "غير معروف",
    no_store: "لا يوجد متجر",
    error_loading_sellers: "خطأ أثناء تحميل البائعين",
    error_loading_livreurs: "خطأ أثناء تحميل الموصلين",
    error_loading_products: "خطأ أثناء تحميل المنتجات",
    select_company: "يرجى اختيار شركة",
    import_google_sheets: "استيراد Google Sheets",
    send: "إرسال ({count})",
    send_to_livreur: "إرسال إلى الموصل ({count})",
    confirm: "تأكيد ({count})",
    confirming: "جاري التأكيد...",
    select_company_title: "اختيار شركة",
    confirm_send: "تأكيد الإرسال",
    scan_orders: "مسح طلب",
    scan_orders_title: "مسح الطلب",
    scan_orders_description: "امسح رمز QR الخاص بالطلب للبحث بواسطة code_api",
    scan_code_found: "تم مسح الكود: {code}",
    scan_camera_error: "تعذر الوصول إلى الكاميرا",
    scan_camera_permission: "يرجى السماح بالوصول إلى الكاميرا في المتصفح",
    scan_camera_https: "يتطلب الوصول إلى الكاميرا اتصالاً آمناً (HTTPS أو localhost)",
    scan_retry: "إعادة المحاولة",
    scan_manual_hint: "الكاميرا لا تعمل؟ أدخل الكود يدوياً:",
    scan_manual_placeholder: "أدخل code_api",
    scan_manual_search: "بحث",
    scan_enter_code: "يرجى إدخال رمز",
  },

  products: {
    title: "المنتجات",
    subtitle: "قم بإدارة كتالوج المنتجات بكفاءة مع البحث والترتيب وخيارات العرض.",
    add_product: "إضافة منتج",
    search_placeholder: "البحث عن المنتجات...",
    products_lowercase: "منتجات",
    product: "المنتج",
    status: "الحالة",
    rating: "التقييم",
    stock: "المخزون",
    price: "السعر",
    purchase_price: "سعر الشراء",
    seller_price: "سعر البائع",
    suggested_price: "السعر المقترح",
    actions: "الإجراءات",
    fetching_more: "جاري تحميل منتجات أخرى...",
    all_loaded: "تم تحميل جميع المنتجات",
    no_products_found: "لم يتم العثور على منتجات",
    create_first: "أنشئ أول منتج",
    unexpected_format: "تنسيق بيانات غير متوقع من واجهة المنتجات.",
    loading_error: "خطأ أثناء تحميل المنتجات.",
    pinned_success: "تم تثبيت المنتج",
    unpinned_success: "تم إلغاء تثبيت المنتج",
    pin_error: "خطأ أثناء التثبيت أو الإلغاء",
    unavailable_now: "غير متوفر حاليا",
    limited_stock: "مخزون محدود",
    limited: "محدود",
    new: "جديد",
    new_short: "جديد",
    recommended_sale: "موصى به للبيع",
    order_now: "اطلب الآن",
    out_of_stock: "نفد المخزون",
    delete_success: "تم حذف المنتج بنجاح",
    delete_failed: "فشل حذف المنتج",
    delete_title: "حذف المنتج",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا المنتج؟",
    create_title: "إنشاء منتج جديد",
    create_subtitle: "أضف منتجاً جديداً إلى الكتالوج مع التفاصيل والمتغيرات وتعيينات العملاء.",
    update_title: "تعديل المنتج",
    update_subtitle: "قم بتعديل تفاصيل المنتج.",
    fetch_failed: "فشل جلب بيانات المنتج.",
    id_missing: "معرف المنتج مفقود.",
    error_loading: "خطأ أثناء تحميل المنتج",
    not_found: "المنتج غير موجود",
    not_found_desc: "تعذر تحميل المنتج بالمعرف أو أنه غير موجود.",
    not_found_public: "المنتج الذي تبحث عنه غير موجود أو غير متاح.",
    browse_other: "تصفح منتجات أخرى",
    unit: "وحدة",
    select_required_variants: "يرجى اختيار جميع المتغيرات المطلوبة. الناقص:",
    variant_not_available: "تركيبة المتغيرات المختارة غير متاحة",
    added_to_cart: "تمت إضافته إلى السلة!",
    in_stock: "متوفر",
    product_id: "معرف المنتج",
    off: "تخفيض",
    offer_valid_until: "العرض صالح إلى",
    other_images: "صور أخرى",
    quantity: "الكمية",
    select_variants: "اختر المتغيرات",
    item: "عنصر",
    details: "تفاصيل المنتج",
    units: "وحدات",
    product_name: "اسم المنتج *",
    status_active: "نشط",
    status_inactive: "غير نشط",
    global_product: "منتج عام",
    available_all_clients: "متاح لجميع العملاء افتراضياً",
    product_expired_soon: "منتج وشيك الانتهاء",
    apply_discount: "تطبيق خصم",
    select_clients_hint: "اختر العملاء الذين يمكنهم الوصول إلى هذا المنتج:",
    no_clients_found: "لم يتم العثور على عملاء",
    drop_primary_image: "أسقط صورتك الرئيسية هنا",
    drop_additional_images: "أسقط صورك الإضافية هنا",
    image_formats_primary: "PNG, JPG, GIF حتى 10 ميجابايت",
    image_formats_additional: "PNG, JPG, GIF حتى 10 ميجابايت لكل منها",
    no_rating: "لا يوجد تقييم",
    star_singular: "نجمة",
    star_plural: "نجوم",
    additional_image_urls: "عناوين URL للصور الإضافية (مفصولة بفاصلة)",
    no_category: "لا توجد فئة",
    // --- مفاتيح جديدة لصفحة تفاصيل المنتج المعاد تصميمها ---
    orders: "الطلبات",
    revenue: "الإيرادات",
    conversion_rate: "معدل التحويل",
    available_stock: "المخزون المتاح",
    average_rating: "متوسط التقييم",
    specifications: "المواصفات",
    reviews: "التقييمات",
    reviews_label: "تقييم",
    no_reviews: "لا توجد تقييمات حتى الآن",
    no_specifications: "لا توجد مواصفات متاحة",
    no_description: "لا يوجد وصف متاح",
    no_videos: "لا توجد فيديوهات متاحة",
    shipping_returns: "الشحن والإرجاع",
    shipping_info_1: "التوصيل المقدر خلال 24 إلى 48 ساعة في جميع أنحاء المغرب.",
    shipping_info_2: "الدفع عند الاستلام متاح.",
    shipping_info_3: "يُقبل الإرجاع خلال 7 أيام في حال وجود عيب.",
    videos: "الفيديوهات",
    delivery: "التوصيل",
    payment: "الدفع",
    cash_on_delivery: "عند الاستلام",
    returns: "الإرجاع",
    days: "أيام",
    warranty: "الضمان",
    quality: "الجودة",
    selling_price_label: "سعر البيع",
    estimated_profit: "ربحك المقدر",
    margin: "الهامش",
    calculate_profit: "احسب ربحك",
    recommended_selling_price: "سعر البيع الموصى به",
    facebook_cost: "تكلفة فيسبوك",
    delivery_cost: "التوصيل",
    price_range: "نطاق السعر",
    selling_price: "سعر البيع",
    confirmation_fee: "التأكيد",
    total_cost: "التكلفة الإجمالية",
    wishlist: "المفضلة",
    add_to_cart: "أضف إلى السلة",
    click_to_zoom: "انقر للتكبير",
    added_to_wishlist: "تمت الإضافة إلى المفضلة",
    removed_from_wishlist: "تمت الإزالة من المفضلة",
    view_product: "عرض المنتج",
    discount_banner_title: "عروض خاصة",
    discount_banner_subtitle: "استمتع بخصوماتنا الحصرية",
    discount_off: "تخفيض",
    special_offer: "عرض خاص",
    super_discounts: "خصومات مذهلة",
    on_selected_products: "على منتجات مختارة",
    discover_offers: "اكتشف العروض",
    up_to: "حتى",
    discount: "تخفيض",
    profit_margin: "الهامش",
  },

  categories: {
    title: "الفئات",
    subtitle: "قم بإدارة الفئات وتنظيم المنتجات.",
    add_category: "إضافة فئة",
    search_placeholder: "البحث عن الفئات...",
    most_items: "الأكثر عناصر",
    category: "فئة",
    categories_lowercase: "فئات",
    items: "عناصر",
    last_update: "آخر تحديث",
    no_categories_found: "لم يتم العثور على فئات",
    create_first: "أنشئ أول فئة",
    unexpected_format: "تنسيق بيانات غير متوقع من واجهة الفئات.",
    loading_error: "خطأ أثناء تحميل الفئات.",
    delete_success: "تم حذف الفئة بنجاح",
    delete_failed: "فشل حذف الفئة",
    delete_title: "حذف الفئة",
    delete_message: "هل أنت متأكد أنك تريد حذف هذه الفئة؟",
    create_title: "إنشاء فئة جديدة",
    create_subtitle: "أضف فئة جديدة لتنظيم منتجاتك. املأ التفاصيل أدناه للبدء.",
    update_title: "تعديل الفئة",
    update_subtitle: "قم بتعديل تفاصيل هذه الفئة.",
    fetch_failed: "فشل جلب الفئة",
    id_missing: "معرف الفئة مفقود.",
    error_loading: "خطأ أثناء تحميل الفئة",
    not_found: "الفئة غير موجودة",
    not_found_desc: "تعذر تحميل الفئة بالمعرف أو أنها غير موجودة.",
    label_title: "عنوان الفئة *",
    label_slug: "رابط URL *",
    label_image: "صورة الفئة",
    placeholder_title: "أدخل عنوان الفئة...",
    placeholder_slug: "رابط-الفئة-الخاص-بك",
    slug_auto_generated: "يتم إنشاء الرابط تلقائياً من العنوان، ولكن يمكنك تخصيصه.",
    drop_image_here: "أسقط صورتك هنا",
    or_click_to_browse: "أو انقر لتصفح الملفات",
    accepted_formats: "PNG, JPG, GIF, WebP حتى 2 ميجابايت",
    error_title_required: "عنوان الفئة مطلوب.",
    error_title_minlength: "يجب أن يحتوي العنوان على 3 أحرف على الأقل.",
    error_slug_required: "رابط URL مطلوب.",
    error_slug_minlength: "يجب أن يحتوي الرابط على 3 أحرف على الأقل.",
    error_form_validation: "يرجى تصحيح الأخطاء في النموذج.",
    error_id_missing: "تعذر التحديث: معرف الفئة مفقود.",
    error_auth_required: "المصادقة مطلوبة. يرجى تسجيل الدخول.",
    error_image_invalid: "يجب أن يكون الملف المرفوع صورة (PNG, JPG, GIF, WebP).",
    error_image_invalid_toast: "يرجى تحميل صورة صالحة (PNG, JPG, GIF, WebP).",
    error_image_size: "يجب ألا يتجاوز حجم الصورة {maxSize} ميجابايت.",
    image_removed: "تمت إزالة الصورة. سيتم تحديث الفئة بدون صورة إذا قمت بالحفظ.",
    update_success: "تم تحديث الفئة بنجاح!",
    error_validation_failed: "فشل التحقق. يرجى التحقق من النموذج.",
    error_update: "حدث خطأ أثناء تحديث الفئة.",
    error_network: "خطأ في الشبكة أو حدث خطأ غير متوقع.",
    button_cancel: "إلغاء",
    button_updating: "جاري التحديث...",
    button_update: "تحديث",
    live_preview: "معاينة مباشرة",
    zero_items: "0 عناصر",
    category_title_placeholder: "عنوان الفئة",
    aria_upload_image: "تحميل صورة الفئة",
    aria_edit_image: "تعديل الصورة",
    aria_delete_image: "حذف الصورة",
    aria_select_new_image: "اختيار صورة جديدة",
    errors: {
      image_not_image: "يجب أن يكون الملف المرفوع صورة.",
      title_required: "عنوان الفئة مطلوب.",
      title_min_length: "يجب أن يحتوي العنوان على 3 أحرف على الأقل.",
      slug_required: "رابط URL مطلوب.",
      slug_min_length: "يجب أن يحتوي الرابط على 3 أحرف على الأقل.",
    },
    labels: {
      title: "عنوان الفئة *",
      slug: "رابط URL *",
      image: "صورة الفئة",
    },
    placeholders: {
      title: "أدخل عنوان الفئة...",
      slug: "رابط-الفئة-الخاص-بك",
    },
    help: {
      slug_auto_generated: "يتم إنشاء الرابط تلقائياً من العنوان، ولكن يمكنك تخصيصه.",
    },
    preview: {
      title: "معاينة مباشرة",
      zero_items: "0 عناصر",
      category_title: "عنوان الفئة",
    },
    success_created: "تم إنشاء الفئة بنجاح!",
    success_description: "تمت إضافة فئتك الجديدة.",
    validation_failed: "فشل التحقق. يرجى التحقق من النموذج.",
    error_occurred: "حدث خطأ.",
    network_error: "خطأ في الشبكة أو حدث خطأ غير متوقع.",
    click_to_browse: "أو انقر لتصفح الملفات",
    file_limits: "PNG, JPG, GIF, WebP حتى 2 ميجابايت",
  },

  // ==========================================
  // CONFIGS
  // ==========================================
  configs: {
    title: "تكوين الموقع",
    subtitle: "قم بإدارة معلومات الاتصال الخاصة بموقعك الإلكتروني وروابط وسائل التواصل الاجتماعي.",
    loading: "جاري التحميل...",
    form_reset: "تم إعادة تعيين النموذج.",
    success_title: "تم تحديث التهيئة بنجاح!",
    success_description: "تم تحديث تهيئتك.",
    success_updated: "تم تحديث التهيئة بنجاح!",
    sections: {
      contact_info: "معلومات الاتصال",
      phone_numbers: "أرقام الهاتف",
      social_media: "وسائل التواصل الاجتماعي",
    },
    labels: {
      email: "البريد الإلكتروني",
      address: "العنوان",
      support_phone: "هاتف الدعم",
      payment_phone: "هاتف الدفع",
      stock_phone: "هاتف المخزون",
      exchange_phone: "هاتف التبادل",
      facebook_url: "رابط فيسبوك",
      instagram_url: "رابط إنستغرام",
      telegram_url: "رابط تيليغرام",
    },
    placeholders: {
      email: "contact@example.com",
      address: "أدخل العنوان...",
      facebook: "https://facebook.com/صفحتك",
      instagram: "https://instagram.com/حسابك",
      telegram: "https://t.me/حسابك",
    },
    preview: {
      title: "معاينة التهيئة",
      contact_info: "معلومات الاتصال",
      specialized_phones: "الهواتف المتخصصة",
      support: "الدعم",
      payment: "الدفع",
      stock: "المخزون",
      exchange: "التبادل",
      social_media: "وسائل التواصل الاجتماعي",
      no_social: "لم يتم تكوين أي وسائل تواصل اجتماعي.",
    },
    errors: {
      load_failed: "خطأ في تحميل التهيئة.",
      email_invalid: "يرجى إدخال بريد إلكتروني صالح.",
      facebook_invalid: "يرجى إدخال رابط فيسبوك صالح.",
      instagram_invalid: "يرجى إدخال رابط إنستغرام صالح.",
      telegram_invalid: "يرجى إدخال رابط تيليغرام صالح.",
      update_failed: "فشل تحديث التهيئة.",
      generic_error: "حدث خطأ أثناء التحديث.",
    },
  },

  sellers: {
    title: "إدارة البائعين",
    subtitle: "قم بإدارة البائعين ونشاطهم",
    total_sellers: "إجمالي البائعين",
    active_today: "نشطون اليوم",
    new_this_month: "جدد هذا الشهر",
    active_sellers: "البائعون النشطون",
    inactive_sellers: "البائعون غير النشطين",
    search_placeholder: "البحث عن البائعين بالاسم أو البريد أو المتجر...",
    sort_name: "الاسم (أ-ي)",
    sort_email: "البريد (أ-ي)",
    sellers_found: "بائعين تم العثور عليهم",
    name: "الاسم",
    email: "البريد",
    no_sellers_found: "لم يتم العثور على بائعين",
    no_search_match: "لا يوجد بائع يطابق معايير البحث.",
    none_in_system: "لا يوجد حالياً أي بائع في النظام.",
    loading_error: "خطأ أثناء تحميل البائعين.",
    refresh_success: "تم تحديث قائمة البائعين",
    status_update_failed: "فشل تحديث الحالة",
    status_updated: "تم تحديث الحالة",
    status_update_error: "خطأ أثناء تحديث الحالة",
    delete_success: "تم الحذف بنجاح",
    delete_failed: "فشل الحذف",
    never: "أبداً",
    not_provided: "غير متوفر",
    never_connected: "لم يتصل أبداً",
    never_connected_tooltip: "هذا البائع لم يتصل أبداً",
    online: "متصل",
    online_now: "متصل الآن",
    online_one_day: "متصل (يوم)",
    inactive: "غير نشط",
    updating: "جار التحديث...",
    active: "نشط",
    disabled: "معطل",
    total_sales: "إجمالي المبيعات",
    registered_on: "مسجل في",
    edit_seller: "تعديل",
    view_details: "عرض التفاصيل",
    delete_title: "حذف البائع",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا البائع؟",
    bank: "البنك",
    total_profit: "إجمالي الربح",
    delivered_orders: "الطلبات المسلمة",
    in_delivery: "قيد التوصيل",
    edit_profile: "تعديل الملف الشخصي",
    update_success: "تم تحديث الملف الشخصي بنجاح!",
    update_failed: "فشل تحديث الملف الشخصي",
    no_data: "لا توجد بيانات بائع",
    load_error: "خطأ في تحميل البيانات",
    store_label: "المتجر :",
    trust_score: "درجة الثقة",
    personal_information: "المعلومات الشخصية",
    full_name: "الاسم الكامل",
    email_address: "البريد الإلكتروني",
    phone_number_label: "رقم الهاتف",
    address_label: "العنوان",
    store_logo: "شعار المتجر (اختياري)",
    current_logo: "الشعار الحالي",
    no_logo: "لم يتم تحميل شعار",
    business_information: "معلومات تجارية",
    store_name: "اسم المتجر",
    seller_level: "مستوى البائع",
    bank_name: "اسم البنك",
    rib_label: "الحساب البنكي",
    beginner: "مبتدئ",
    intermediate: "متوسط",
    advanced: "متقدم",
    save_changes: "تحديث",
    sort_last_login: "آخر تسجيل دخول",
    orders: "الطلبات",
    revenue: "إجمالي الإيرادات",
    products: "المنتجات",
  },

  // ==========================================
  // BUTTONS
  // ==========================================
  buttons: {
    save: "حفظ",
    cancel: "إلغاء",
    add: "إضافة",
    delete: "حذف",
    edit: "تحرير",
    back: "رجوع",
    submit: "إرسال",
    search: "بحث",
    updating: "جاري التحديث...",
    update_product: "تحديث المنتج",
    saving: "جاري الحفظ...",
    reset: "إعادة تعيين",
    creating: "جاري الإنشاء...",
    confirm: "تأكيد",
  },

  // ==========================================
  // TABLES
  // ==========================================
  tables: {
    headers: {
      phone: "الهاتف",
      city: "المدينة",
      status: "الحالة",
      crbt: "الرقم الضريبي",
      fee: "الرسوم",
      net: "الصافي",
      name: "الاسم",
      email: "البريد الإلكتروني",
      action: "الإجراء",
      date: "التاريخ",
      total: "الإجمالي",
    },
  },

  // ==========================================
  // MESSAGES
  // ==========================================
  messages: {
    updating_orders: "جاري تحديث الطلبات…",
    success: "نجاح!",
    error: "خطأ",
    warning: "تحذير",
    confirm: "هل أنت متأكد؟",
    network_error: "خطأ في الشبكة",
    product_created_successfully: "تم إنشاء المنتج بنجاح!",
    new_product_added: "تمت إضافة منتجك الجديد إلى الكتالوج.",
    product_updated: "تم تحديث المنتج بنجاح!",
    product_updated_desc: "تم تحديث منتجك في الكتالوج.",
    update_error: "خطأ أثناء تحديث المنتج. يرجى التحقق من النموذج.",
    validation_failed: "فشل التحقق. يرجى التحقق من النموذج.",
    update_product_error: "خطأ أثناء تحديث المنتج: {message}",
    unexpected_error: "حدث خطأ غير متوقع.",
    correct_form_errors: "يرجى تصحيح الأخطاء في النموذج.",
    no_permission: "ليس لديك الصلاحيات اللازمة!",
    network_error_desc: "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  },

  // ==========================================
  // FORMS
  // ==========================================
  forms: {
    sections: {
      basic_information: "المعلومات الأساسية",
      pricing_inventory: "السعر والمخزون",
      product_images: "صور المنتج",
      user_role: "دور المستخدم",
      admin_info: "معلومات المسؤول",
      delivery_info: "معلومات التوصيل",
      assistant_role_specific: "دور مساعد محدد",
      role_examples: "مثال: مسؤول، محرر، مدير المنتجات",
      client_assignment: "تعيين العملاء",
      product_rating: "تقييم المنتج",
    },
    labels: {
      product_name: "اسم المنتج *",
      description: "الوصف",
      primary_image: "الصورة الرئيسية *",
      additional_image_urls: "URLs صور إضافية (مفصولة بفواصل)",
      fournisseur: "المورد *",
      category: "الفئة *",
      status: "الحالة",
      email: "عنوان البريد الإلكتروني *",
      password: "كلمة المرور *",
      confirm_password: "تأكيد كلمة المرور *",
      role_type: "نوع الدور *",
      gender: "الجنس *",
      phone: "رقم الهاتف *",
      achat_price: "سعر الشراء *",
      purchase_price: "سعر الشراء *",
      seller_price: "سعر البائع *",
      selling_price: "سعر البيع *",
      stock_quantity: "كمية المخزون *",
      supplier_name: "اسم المورد *",
      contact_name: "اسم جهة الاتصال *",
      delivery_person_name: "اسم الموصل *",
      delivery_price: "سعر التوصيل (درهم) *",
      rib: "الحساب البنكي (اختياري)",
      role_name: "اسم الدور *",
      contact_person_name: "اسم شخص جهة الاتصال *",
      discount: "الخصم (%)",
      discount_percent: "الخصم (%)",
      discount_start_date: "تاريخ بداية الخصم *",
      discount_end_date: "تاريخ نهاية الخصم *",
      rating: "التقييم (1 إلى 5 نجوم)",
    },
    placeholders: {
      enter_name: "أدخل الاسم...",
      enter_phone: "أدخل رقم الهاتف...",
      enter_email: "أدخل البريد الإلكتروني...",
      enter_address: "أدخل العنوان...",
      enter_comment: "أدخل التعليق...",
      choose_city: "اختر مدينة...",
      describe_postpone_reason: "اوصف سبب التأجيل...",
      describe_cancellation_reason: "اوصف سبب الإلغاء...",
      add_additional_details: "أضف تفاصيل إضافية...",
      search_orders: "البحث عن الطلبات...",
      search_seller: "البحث عن بائع...",
      search_delivery_person: "البحث عن موصل...",
      search_products: "البحث عن المنتجات...",
      search_roles: "البحث عن الأدوار حسب الاسم...",
      search_variants: "البحث عن المتغيرات...",
      search_confirmators: "البحث عن المؤكدين...",
      search_by_order_code: "البحث حسب رمز الطلب...",
      drag_drop_invoice: "اسحب ملف الفاتورة بصيغة PDF هنا",
      enter_product_name: "أدخل اسم المنتج...",
      enter_product_description: "أدخل وصف المنتج...",
      select_fournisseur: "اختر مورداً",
      select_category: "اختر فئة",
      drop_primary_image: "أسقط صورتك الرئيسية هنا",
      or_click_to_browse: "أو انقر لتصفح الملفات",
      drop_additional_images: "أسقط صورك الإضافية هنا",
      enter_additional_image_urls: "أدخل URLs صور إضافية، مثال: url1.jpg, url2.png",
      enter_discount: "أدخل الخصم",
      search_clients: "البحث عن العملاء واختيارهم...",
    },
    variant: {
      variant_product: "منتج ذو متغيرات",
      available_default: "متاح لجميع العملاء افتراضياً",
      dimensions: "أبعاد المتغيرات",
      color: "اللون",
      size: "الحجم",
      choose_hint: "اختر اللون فقط، أو الحجم فقط، أو كليهما.",
      select_option: "كل خيار محدد هو متغير قابل للبيع؛ جميع الصفوف تستخدم نفس الأبعاد.",
      no_colors: "لم يتم تحديد ألوان في إعدادات المتغيرات.",
      no_sizes: "لم يتم تحديد أحجام في إعدادات المتغيرات.",
      add_color_size: "أضف لوناً واحداً على الأقل وحجماً واحداً على الأقل في إعدادات المتغيرات لاستخدام شبكة اللون × الحجم.",
      color_size: "اللون / الحجم",
      include: "تضمين",
    },
    global_product: "منتج عام",
    available_all_default: "متاح لجميع العملاء افتراضياً",
    client_assignment: "تعيين العملاء",
    select_clients: "اختر العملاء الذين يمكنهم الوصول إلى هذا المنتج:",
    search_clients: "ابحث واختر العملاء...",
    no_clients_found: "لم يتم العثور على عملاء",
    product_rating: "تقييم المنتج",
    rating_stars: "التقييم (1 إلى 5 نجوم)",
    no_rating: "لا يوجد تقييم",
    product_expired_soon: "منتج وشيك الانتهاء",
    apply_discount: "تطبيق خصم",
  },

  // ==========================================
  // SELECT DATE
  // ==========================================
  date: {
    today: "اليوم",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    last_6_months: "آخر 6 أشهر",
    last_12_months: "آخر 12 شهر",
    all_period: "كل الفترة",
    custom_period: "فترة مخصصة",
    select_period: "اختر فترة",
    cancel: "إلغاء",
    apply: "تطبيق",
    months_short: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
    months_long: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
    days_short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  },

  // ==========================================
  // ERROR MESSAGES
  // ==========================================
  errors: {
    unexpected_format: "تنسيق بيانات غير متوقع من الخادم.",
    loading_stats: "خطأ في تحميل الإحصائيات.",
    loading_sellers: "خطأ في تحميل البائعين",
    auth_token_missing: "لم يتم العثور على رمز المصادقة",
    request_timeout: "انتهت مهلة الطلب - يرجى المحاولة مرة أخرى",
    no_active_announcements: "لا توجد إعلانات نشطة",
    fetching_announcements: "خطأ في جلب الإعلانات",
  },
  // ==========================================
  // ORDERS PAGE
  // ==========================================
  orders: {
    delivery_tickets: "تذاكر التوصيل",
    no_order_selected: "لم يتم تحديد أي طلب",
    assigned_success: "تم تعيين الطلب (الطلبات) للموصل بنجاح",
    assign_error: "خطأ في تعيين الطلبات",
    network_error: "خطأ في الشبكة أثناء تعيين الطلبات",
    send_error: "خطأ أثناء إرسال الطلبات",
    send_network_error: "خطأ في الشبكة أثناء إرسال الطلبات",
    confirm_success: "تم تأكيد الطلب (الطلبات) بنجاح",
    confirm_error: "خطأ أثناء تأكيد الطلبات",
    confirm_modal_title: "تأكيد الطلبات",
    confirm_modal_message: "أنت على وشك تأكيد {count} طلب. هذا الإجراء لا يمكن التراجع عنه.",
    preparing_orders: "جاري تجهيز الطلبات...",
    sending_orders: "جاري الإرسال...",
    sending_completed: "اكتمل الإرسال!",
    error_sending: "خطأ أثناء الإرسال",
    processing: "معالجة...",
    progress: "التقدم",
    orders_processed: "طلبات تمت معالجتها",
    orders_not_sent: "طلب (طلبات) لم يتم إرسالها",
    order_id: "رقم الطلب:",
    other_products: "أكثر",
    unknown_reason: "سبب غير معروف",
    close: "إغلاق",
    all_orders: "جميع الطلبات",
    orders: "الطلبات",
    manage_track_orders: "إدارة وتتبع طلباتك",
    orders_list: "قائمة الطلبات",
    showing: "عرض",
    to: "إلى",
    of: "من",
    orders_lowercase: "طلبات",
    orders_selected: "طلب (طلبات) محددة",
    code: "الرمز",
    affiliate: "المسوق",
    client: "العميل",
    products: "المنتجات",
    status: "الحالة",
    total: "المجموع",
    profit: "الربح",
    actions: "الإجراءات",
    no_order_found: "لم يتم العثور على أي طلب",
    no_order_found_desc: "لا توجد طلبات تطابق الفلتر المحدد.",
    all_sent_success: "تم إرسال جميع الطلبات بنجاح",
    sent_success_count: "تم إرسال الطلب (الطلبات) بنجاح",
    failed_count: "فشلت",
    fetch_failed: "فشل جلب الطلب",
    fetch_updated_failed: "فشل جلب الطلب المحدث",
    update_failed: "فشل التحديث",
    update_success: "تم تحديث الطلب بنجاح!",
    load_failed: "فشل تحميل تفاصيل الطلب",
    order_label: "طلب",
    created_at: "تم الإنشاء في",
    order_details: "تفاصيل الطلب",
    name: "الاسم",
    phone: "الهاتف",
    city: "المدينة",
    address: "العنوان",
    select_city: "اختر مدينة",
    articles: "المنتجات",
    add_product: "إضافة منتج...",
    summary: "الملخص",
    subtotal: "المجموع الفرعي",
    delivery: "التوصيل",
    confirmation_agent: "وكيل التأكيد",
    available: "متاح",
    contact: "اتصال",
    no_agent: "لا يوجد وكيل تأكيد معين",
    phone_label: "الهاتف:",
    order_status: "حالة الطلب",
    change: "تغيير",
    unlockable: "فتح الطرد",
    comment: "تعليق الطلب",
    add_comment: "إضافة تعليق...",
    no_comment: "لا يوجد تعليق",
    history: "السجل",
    reason: "السبب:",
    postponed_to: "مؤجل إلى:",
    comment_label: "تعليق:",
    yes: "نعم",
    no: "لا",
    variant_required: "يرجى تحديد جميع المتغيرات المطلوبة. المفقود:",
    variant_not_available: "تركيبة المتغيرات المحددة غير متاحة",
    profit_min_error: "يجب أن يكون ربح الطلب 10 دراهم على الأقل.",
    delete_success: "تم حذف الطلب بنجاح",
    delete_failed: "فشل حذف الطلب",
    change_label: "تغيير",
    cost_label: "التكلفة",
    change_status_title: "تغيير الحالة",
    history_title: "السجل",
    view_title: "عرض",
    edit_title: "تعديل",
    delete_title: "حذف",
    delete_modal_title: "حذف الطلب",
    delete_modal_message: "هل أنت متأكد أنك تريد حذف هذا الطلب؟",
  },

  // ==========================================
  // PAYMENTS
  // ==========================================
  payments: {
    sellers_title: "مدفوعات البائعين",
    subtitle: "قم بإدارة وإنشاء المدفوعات لجميع البائعين على منصتك.",
    import_ozon: "استيراد فاتورة Ozon",
    export_excel: "تصدير إكسل",
    generate: "إنشاء المدفوعات",
    total_invoices: "إجمالي الفواتير",
    pending_invoices: "فواتير معلقة",
    paid_invoices: "فواتير مدفوعة",
    total_amount: "المبلغ الإجمالي",
    search_placeholder: "البحث بالاسم أو المتجر أو رقم الفاتورة أو البريد...",
    invoice: "الفاتورة",
    seller: "البائع",
    bank: "البنك",
    orders: "الطلبات",
    amount: "المبلغ",
    payment_date: "تاريخ الدفع",
    status: "الحالة",
    actions: "الإجراءات",
    not_found: "لم يتم العثور على فواتير",
    not_found_desc: "حاول تعديل كلمات البحث أو إنشاء فواتير جديدة.",
    generate_invoices: "إنشاء الفواتير",
    invoice_singular: "فاتورة واحدة",
    invoice_plural: "فواتير",
    per_page: "لكل صفحة",
    showing: "عرض",
    to: "إلى",
    on: "من",
    results: "نتائج",
    error_occurred: "حدث خطأ",
    not_available: "غير متاح",
    status_paid: "مدفوع",
    status_pending: "معلق",
    status_cancelled: "ملغي",
    status_unknown: "غير معروف",
    payment_cash: "نقداً",
    payment_cheque: "شيك",
    payment_bank_transfer: "تحويل بنكي",
    payment_credit_card: "بطاقة ائتمان",
    payment_not_specified: "غير محدد",
    seller_unknown: "بائع غير معروف",

    confirmators: {
      title: "مدفوعات المؤكدين",
      subtitle: "قم بإدارة وإنشاء المدفوعات لجميع المؤكدين على منصتك.",
      export_excel: "تصدير إلى إكسل",
      salary_payments: "مدفوعات الرواتب",
      generate_payments: "إنشاء المدفوعات",
      modal_title: "اختيار المؤكدين لدفع الرواتب",
      x_of_y_selected: "{count} من {total} محدد",
      select_all: "تحديد الكل",
      deselect_all: "إلغاء تحديد الكل",
      unpaid_orders: "{count} طلب",
      no_confirmators_found: "لم يتم العثور على مؤكدين لدفع الرواتب",
      cancel: "إلغاء",
      generating: "جاري الإنشاء...",
      generate_invoices_count: "إنشاء الفواتير ({count})",
      total_invoices: "إجمالي الفواتير",
      pending_invoices: "فواتير معلقة",
      paid_invoices: "فواتير مدفوعة",
      total_amount: "المبلغ الإجمالي",
      search_placeholder: "البحث باسم المؤكد أو البريد أو رقم الفاتورة...",
      invoice_found: "{count} فاتورة",
      table_invoice: "الفاتورة",
      table_confirmator: "المؤكد",
      table_orders: "الطلبات",
      table_amount: "المبلغ",
      table_payment_date: "تاريخ الدفع",
      table_status: "الحالة",
      table_actions: "الإجراءات",
      no_invoices: "لم يتم العثور على فواتير",
      no_invoices_desc: "حاول تعديل كلمات البحث أو إنشاء فواتير جديدة.",
      generate_invoices_btn: "إنشاء الفواتير",
      pagination: "عرض {from} إلى {to} من {total} نتيجة",
      payment_cash: "نقداً",
      payment_cheque: "شيك",
      payment_bank_transfer: "تحويل بنكي",
      payment_credit_card: "بطاقة ائتمان",
      payment_not_specified: "غير محدد",
      status_paid: "مدفوع",
      status_pending: "معلق",
      status_cancelled: "ملغي",
      status_unknown: "غير معروف",
      not_available: "غير متاح",
      no_email: "لا يوجد بريد إلكتروني",
      orders: "الطلبات",
      fetch_failed: "فشل في جلب الفواتير",
      fetch_failed_confirmators: "فشل في جلب المؤكدين",
      fetch_error: "حدث خطأ أثناء جلب المؤكدين",
      select_required: "يرجى اختيار مؤكد واحد على الأقل",
      generate_success: "تم إنشاء الفواتير بنجاح",
      generate_failed: "فشل إنشاء الفواتير",
      generate_error: "حدث خطأ أثناء إنشاء الفواتير",
      error_occurred: "حدث خطأ",
    },

    livreurs: {
      title: "مدفوعات الموصلين",
      subtitle: "قم بإدارة وإنشاء المدفوعات لجميع الموصلين على منصتك.",
      generate_payments: "إنشاء المدفوعات",
      total_invoices: "إجمالي الفواتير",
      pending_invoices: "فواتير معلقة",
      paid_invoices: "فواتير مدفوعة",
      total_amount: "المبلغ الإجمالي",
      search_placeholder: "البحث باسم الموصل أو البريد أو رقم الفاتورة...",
      invoice_found: "{count} فاتورة",
      table_invoice: "الفاتورة",
      table_livreur: "الموصل",
      table_orders: "الطلبات",
      table_amount: "المبلغ",
      table_payment_date: "تاريخ الدفع",
      table_status: "الحالة",
      table_actions: "الإجراءات",
      no_invoices: "لم يتم العثور على فواتير",
      no_invoices_desc: "حاول تعديل كلمات البحث أو إنشاء فواتير جديدة.",
      generate_invoices_btn: "إنشاء الفواتير",
      pagination: "عرض {from} إلى {to} من {total} نتيجة",
      payment_cash: "نقداً",
      payment_cheque: "شيك",
      payment_bank_transfer: "تحويل بنكي",
      payment_credit_card: "بطاقة ائتمان",
      payment_not_specified: "غير محدد",
      status_paid: "مدفوع",
      status_pending: "معلق",
      status_cancelled: "ملغي",
      status_unknown: "غير معروف",
      not_available: "غير متاح",
      orders: "الطلبات",
      fetch_failed: "فشل في جلب الفواتير",
      fetch_error: "حدث خطأ أثناء جلب الفواتير",
      error_occurred: "حدث خطأ",
    },

    system: {
      title: "مدفوعات النظام",
      subtitle: "رسوم النظام",
      refresh: "تحديث",
      confirm_payment: "تأكيد الدفع",
      confirm_message: "هل أنت متأكد أنك تريد وضع علامة على هذا الدفع كمسدد؟",
      amount_label: "المبلغ:",
      cancel: "إلغاء",
      confirm_button: "تأكيد",
      paid_success: "تم تسديد الدفع",
      update_failed: "فشل التحديث",
      unpaid: "غير مسدد",
      total_amount: "المبلغ الإجمالي",
      pay_button: "تسديد",
      payment_completed: "تم الدفع",
      no_payments: "لم يتم العثور على مدفوعات",
      paid_status: "مسدد",
      pay_full: "دفع الكل",
      pay_partial: "دفع مبلغ",
      enter_amount: "أدخل المبلغ...",
      invalid_amount: "مبلغ غير صالح",
    },
  },

  // ==========================================
  // RECLAMATIONS
  // ==========================================
  reclamations: {
    title: "الشكاوى",
    subtitle: "إدارة الشكاوى",
    search_placeholder: "البحث برمز الطلب...",
    fetch_failed: "فشل في جلب الشكاوى",
    refresh_failed: "فشل في تحديث الشكاوى",
    error_title: "خطأ في تحميل الشكاوى",
    retry: "إعادة المحاولة",
    filter_all: "الكل",
    filter_not_seen: "غير مفتوح",
    filter_seen: "مفتوح",
    results_count: "{count} شكوى",
    not_found: "لم يتم العثور على شكاوى",
    not_found_desc: "حاول تعديل كلمات البحث أو الفلاتر.",
    order_label: "الطلب",
    client_label: "العميل",
    total_label: "الإجمالي",
    created_at: "تاريخ الإنشاء",
    last_message: "آخر رسالة",
    no_messages: "لا توجد رسائل",
    open: "فتح",
  },

  // ==========================================
  // API DOCUMENTATION
  // ==========================================
  api_docs: {
    hero_badge: "API آمنة",
    hero_title: "توثيق API",
    hero_subtitle: "قم بدمج طلباتك مع تطبيقاتك وأدواتك الخاصة. تتيح لك واجهة برمجة التطبيقات (API) الخاصة بنا جلب وإدارة بيانات مبيعاتك بشكل آلي وآمن.",
    base_url: "الرابط الأساسي",
    secured_label: "اتصال آمن",
    tab_documentation: "التوثيق",
    tab_keys: "مفاتيح API",
    tab_webhook: "Webhook",
    webhook_title: "Webhook تغييرات الحالة",
    webhook_subtitle: "استقبل طلب POST على رابطك الخاص عند أي تغيير في حالة الطلب (ادمن، مؤكد، أو موصل).",
    webhook_enabled: "نشط",
    webhook_disabled: "غير نشط",
    webhook_url_label: "رابط الاستدعاء (webhook)",
    webhook_url_placeholder: "https://your-app.com/webhook/order-status",
    webhook_save: "حفظ واختبار",
    webhook_save_only: "حفظ",
    webhook_check_label: "تفعيل / تعطيل الويب هوك",
    webhook_saving: "جارٍ الحفظ...",
    webhook_save_error: "فشل اختبار الرابط. تأكد أنه قابل للوصول ويعيد كود 2xx.",
    webhook_active_msg: "الرابط نشط: يتم إرسال تغييرات الحالة إليه.",
    webhook_inactive_msg: "تم حفظ الرابط لكن فشل الاختبار الأخير.",
    webhook_how_title: "كيف يعمل؟",
    webhook_how_desc: "عند أي تغيير في حالة طلباتك، تُرسل طلبات POST إلى الرابط أعلاه برأس X-API-Key يحتوي مفتاح API الخاص بك.",
    webhook_how_example: "أعد استجابة 200/2xx لتحديد الرابط كنشط.",
    webhook_api_key_title: "مفتاح API الخاص بك (مهم)",
    webhook_api_key_note: "يُرسل هذا المفتاح في رأس X-API-Key لكل webhook. احفظه في مكان آمن.",
    webhook_fields_title: "الحقول المُرسلة",
    webhook_field_order_id: "order_id / order_code / code_api",
    webhook_field_status: "old_status / new_status",
    webhook_field_meta: "updated_by / updated_at",
    webhook_field_other: "saller_id / total",
    webhook_save_success: "تم حفظ رابط الـ Webhook",
    webhook_status_true: "تم تفعيل Webhook",
    webhook_status_false: "تم تعطيل Webhook",
    webhook_not_found: "لا يوجد مفتاح API. اضغط \"حفظ واختبار\" لإنشاء واحد تلقائيًا.",
    overview_title: "نظرة عامة",
    overview_desc: "تتيح لك واجهة REST API الخاصة بالمبيعات الوصول البرمجي إلى طلباتك والمزيد. تستخدم صيغة JSON وطرق HTTP القياسية والمصادقة عبر مفتاح API في الترويسة.",
    auth_title: "المصادقة",
    auth_desc: "يجب أن تتضمن جميع الطلبات ترويسة X-API-Key مع مفتاح API الخاص بك. ستعيد الطلبات بدون مفتاح صالح خطأ 401 Unauthorized.",
    header_example: "مثال الترويسة",
    endpoints_title: "الواجهات",
    endpoint_orders: "جلب قائمة طلبات البائع.",
    endpoint_cities: "جلب قائمة المدن مع أسعار التوصيل.",
    endpoint_products: "جلب قائمة منتجات البائع (مع المتغيرات وSKU).",
    endpoint_create_order: "إنشاء طلب جديد وإرجاع الكود المولّد.",
    filter_category: "تصفية حسب معرف التصنيف.",
    filter_search: "البحث بالاسم أو الوصف.",
    order_name: "الاسم الكامل للعميل.",
    order_phone: "رقم هاتف العميل.",
    order_city: "مدينة العميل.",
    order_address: "عنوان العميل.",
    order_comment: "ملاحظة على الطلب.",
    order_sku: "SKU المنتج أو المتغير (مثال: NEXT-5 أو VAR-5-2).",
    order_sku_note: "إذا كان المنتج يحتوي على متغيرات، أرسل SKU مجموعة المتغيرات (VAR-...). إذا لم يكن للمنتج متغيرات، أرسل SKU المنتج مباشرة (NEXT-...).",
    order_quantity: "كمية الصنف.",
    filters: "تصفية حسب الحالة (nouveau, confirme, livre, retour, annule, refuse).",
    per_page: "عدد النتائج في الصفحة (الافتراضي 15، الحد الأقصى 100).",
    secured: "آمن",
    params_title: "المعاملات",
    responses_title: "رموز الاستجابة",
    optional: "اختياري",
    required: "إلزامي",
    examples_title: "أمثلة الكود",
    response_title: "مثال الاستجابة",
    errors_title: "رموز الخطأ",
    error_code: "الرمز",
    error_message: "الرسالة",
    error_desc: "الوصف",
    err_401_msg: "غير مصرح",
    err_401_desc: "مفتاح API مفقود أو غير صالح.",
    err_422_msg: "كيانات غير قابلة للمعالجة",
    err_422_desc: "معاملات طلب غير صالحة.",
    err_500_msg: "خطأ داخلي في الخادم",
    err_500_desc: "خطأ داخلي في الخادم.",
    cta_title: "هل أنت مستعد للبدء؟",
    cta_desc: "قم بتوليد مفتاح API الخاص بك لبدء دمج خدماتنا.",
    cta_btn: "توليد مفتاح",
    generate_title: "توليد مفتاح API",
    generate_subtitle: "أنشئ مفتاحًا جديدًا لتأمين الوصول إلى الواجهة.",
    generate_btn: "توليد",
    generating: "جارٍ التوليد...",
    generate_hint: "يظهر المفتاح مرة واحدة فقط بعد توليده. لن يكون مرئيًا مرة أخرى أبدًا.",
    key_name_placeholder: "اسم المفتاح (مثال: تطبيقي)",
    key_warning: "انسخ هذا المفتاح فورًا - لن يتم عرضه مرة أخرى أبدًا.",
    key_generated: "تم توليد مفتاح API بنجاح",
    key_revoked: "تم إبطال مفتاح API",
    active_keys: "مفتاح نشط",
    last_created: "آخر إنشاء",
    manage_keys: "إدارة مفاتيح API",
    no_keys: "لا توجد مفاتيح API",
    no_keys_desc: "قم بتوليد مفتاحك الأول للبدء.",
    created: "أنشئ في",
    last_used: "آخر استخدام",
    revoke: "إبطال",
    revoke_confirm: "هل أنت متأكد من رغبتك في إبطال مفتاح API هذا؟ لا يمكن التراجع عن هذا الإجراء.",
    copy: "نسخ",
    copied: "تم النسخ!",
    copy_failed: "فشل النسخ",
    error: "حدث خطأ، يرجى المحاولة مجددًا.",
    security_title: "أمان المفتاح",
    security_desc: "لا تشارك مفتاح API الخاص بك أبدًا. قم بتخزينه في مكان آمن وأبطله فورًا إذا تم اختراقه. يمكنك توليد مفاتيح متعددة لتطبيقات مختلفة.",
  },

  // ==========================================
  // INTEGRATION
  // ==========================================
  integration: {
    delivery: {
      title: "شركات التوصيل",
      loading: "جاري تحميل شركات التوصيل...",
      subtitle: "إدارة شركات التوصيل وتكاملات API الخاصة بها.",
      api_error: "خطأ في الاتصال بالـ API، عرض البيانات المحلية",
      refresh: "تحديث",
      stats: "الإجمالي: {total} شركة • نشطة: {active} • غير نشطة: {inactive}",
      data_may_be_outdated: "{error}. البيانات المعروضة قد لا تكون محدثة.",
      not_found: "لم يتم العثور على شركات",
      not_found_desc: "لم يتم تكوين أي شركة توصيل حالياً.",
      retry: "إعادة المحاولة",
      status_active: "نشط",
      status_inactive: "غير نشط",
      none: "لا يوجد",
      edit_info: "تعديل المعلومات",
      edit_info_for: "تعديل معلومات {name}",
      active_status: "الحالة النشطة",
      edit_hint: "سيتم تطبيق التغييرات فوراً.",
      connect: "اتصال",
      connect_to: "الاتصال بـ",
      enter_creds: "أدخل بيانات الاعتماد API",
      connect_hint: "قم بتكوين بيانات اعتماد API لتفعيل التكامل.",
      connecting: "جاري الاتصال...",
      client_id_label: "معرف العميل",
      token_label: "الرمز المميز",
      key_label: "المفتاح",
      api_client_id: "معرف API للعميل",
      api_token: "رمز API المميز",
      api_key: "مفتاح API",
      api_secret_token: "سر/رمز API المميز",
      placeholder_client_id: "أدخل معرف العميل",
      placeholder_api_key: "أدخل مفتاح API",
      placeholder_api_token: "أدخل رمز API المميز",
      update_success: "تم تحديث الشركة بنجاح!",
      update_failed: "فشل تحديث الشركة",
      connect_success: "تم الاتصال بنجاح!",
      connect_failed: "فشل الاتصال. يرجى التحقق من بيانات الاعتماد الخاصة بك.",
    },
    apps: {
      title: "تطبيقات التكامل",
      loading: "جاري تحميل تطبيقات التكامل...",
      subtitle: "قم بإدارة تكاملاتك مع Shopify و YouCan وتطبيقات التجارة الإلكترونية الأخرى.",
      api_error: "خطأ في الاتصال بالـ API، عرض البيانات المحلية",
      refresh: "تحديث",
      stats: "الإجمالي: {total} تطبيق • نشط: {active} • غير نشط: {inactive}",
      data_may_be_outdated: "{error}. البيانات المعروضة قد لا تكون محدثة.",
      not_found: "لم يتم العثور على تطبيقات",
      not_found_desc: "لم يتم تكوين أي تطبيق تكامل حالياً.",
      retry: "إعادة المحاولة",
      status_connected: "متصل",
      status_disconnected: "غير متصل",
      store_label: "المتجر :",
      token_label: "الرمز المميز :",
      none: "لا يوجد",
      shop_domain_label: "نطاق المتجر",
      shop_domain_placeholder: "مثال: my-store.myshopify.com",
      shop_domain_hint: "أدخل نطاق متجر التجارة الإلكترونية الخاص بك",
      connect: "اتصال",
      send_products: "إرسال المنتجات",
      connect_woocommerce: "اتصال ووكومرس",
      step1_download_plugin: "1. تحميل الإضافة",
      step1_desc: "قم بتحميل وتثبيت إضافة WordPress الخاصة بنا على موقع WooCommerce.",
      download_plugin: "تحميل الإضافة",
      step2_configure_plugin: "2. تكوين الإضافة",
      api_key: "مفتاح API",
      copy: "نسخ",
      api_secret: "سر API",
      webhook_endpoint: "نقطة نهاية Webhook",
      done: "تم",
      products_selected: "{count} منتج/منتجات محددة",
      send_products_to: "إرسال المنتجات إلى",
      sku_hint: "اختر المنتجات للإرسال. سيتم مزامنة المنتجات ذات رمز SKU فقط.",
      search_product_placeholder: "البحث عن المنتجات...",
      no_products_found: "لم يتم العثور على منتجات",
      all_products_loaded: "تم تحميل جميع المنتجات",
      disconnect_title: "قطع الاتصال",
      disconnect_message: "هل أنت متأكد أنك تريد قطع اتصال هذا التطبيق؟",
      landing_badge: "موصى به من فريقنا",
      landing_title: "أنشئ صفحة الهبوط الخاصة بمتجرك على Shopify باستخدام الذكاء الاصطناعي",      landing_desc: "أنشئ صفحة هبوط احترافية محسّنة للتحويل في دقائق، واربطها مباشرة بمتجرك على Shopify.",
      landing_feature_1: "مولّد صفحات هبوط متوافق 100% مع Shopify",
      landing_feature_2: "قوالب جاهزة محسّنة للتحويل",
      landing_feature_3: "بدون برمجة، التثبيت بنقرة واحدة",
      landing_cta: "أنشئ صفحة الهبوط على Shopify",
      landing_note: "أداة خارجية — Webi Landing Page Builder",
      error_http: "خطأ HTTP! الحالة: {status}",
      error_fetch: "فشل في جلب التكاملات.",
    },
  },

  // ==========================================
  // ANNONCES
  // ==========================================
  annonces: {
    success_title: "تم تحديث الإعلان بنجاح!",
    success_desc: "تم تعديل إعلانك بنجاح.",
    label_content: "محتوى الإعلان *",
    placeholder_content: "اكتب إعلانك هنا...",
    label_start_date: "تاريخ البداية *",
    label_end_date: "تاريخ النهاية *",
    label_color: "لون الإعلان *",
    color_teal: "تركواز",
    color_coral: "مرجاني",
    color_amber: "كهرماني",
    color_blue: "أزرق",
    color_purple: "بنفسجي",
    color_green: "أخضر",
    error_content_required: "محتوى الإعلان مطلوب.",
    error_content_minlength: "يجب أن يحتوي الإعلان على 10 أحرف على الأقل.",
    error_start_date_required: "تاريخ البداية مطلوب.",
    error_end_date_required: "تاريخ النهاية مطلوب.",
    error_end_date_after: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
    error_color_required: "اللون مطلوب.",
    error_form_validation: "يرجى تصحيح الأخطاء في النموذج.",
    error_update: "خطأ أثناء تحديث الإعلان",
    error_unexpected: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
    preview_title: "معاينة الإعلان",
    preview_placeholder: "سيظهر إعلانك هنا...",
    preview_start: "تاريخ البداية",
    preview_end: "تاريخ النهاية",
    preview_start_label: "البداية:",
    preview_end_label: "النهاية:",
    preview_duration_label: "المدة:",
    characters: "حرف",
    days: "يوم",
    button_cancel: "إلغاء",
    button_updating: "جاري التحديث...",
    button_update: "تحديث الإعلان",
    update_success: "تم تحديث الإعلان بنجاح!",
    status_active: "نشط",
    status_upcoming: "قادم",
    status_expired: "منتهي",
    start_label: "البداية :",
    end_label: "النهاية :",
    days_remaining: "{count} يوم متبقي",
    errors: {
      content_required: "محتوى الإعلان مطلوب.",
      min_length: "يجب أن يحتوي الإعلان على 10 أحرف على الأقل.",
      start_date_required: "تاريخ البداية مطلوب.",
      end_date_required: "تاريخ النهاية مطلوب.",
      end_date_after_start: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
      color_required: "اللون مطلوب.",
    },
    colors: {
      teal: "تركواز",
      coral: "مرجاني",
      amber: "كهرماني",
      blue: "أزرق",
      purple: "بنفسجي",
      green: "أخضر",
    },
    labels: {
      content: "محتوى الإعلان *",
      start_date: "تاريخ البداية *",
      end_date: "تاريخ النهاية *",
      color: "لون الإعلان *",
    },
    placeholders: {
      content: "اكتب إعلانك هنا...",
    },
    preview: {
      title: "معاينة الإعلان",
      placeholder: "سيظهر إعلانك هنا...",
      start_date: "تاريخ البداية",
      end_date: "تاريخ النهاية",
    },
    success_created: "تم إنشاء الإعلان بنجاح!",
    success_description: "تمت إضافة إعلانك الجديد إلى النظام.",
    days_plural: "أيام",
    buttons: {
      create: "إنشاء الإعلان",
    },

    page_title: "الإعلانات",
    page_subtitle: "قم بإدارة إعلاناتك واتصالاتك مع عملائك.",
    new_annonce: "إعلان جديد",
    search_placeholder: "البحث في الإعلانات...",
    sort_label: "ترتيب",
    sort_by: "ترتيب حسب",
    sort_date_start: "تاريخ البداية",
    sort_date_end: "تاريخ النهاية",
    sort_created_at: "تاريخ الإنشاء",
    sort_content: "المحتوى (أ-ي)",
    filter_all: "الكل ({count})",
    filter_active: "نشطة ({count})",
    filter_upcoming: "قادمة ({count})",
    filter_expired: "منتهية ({count})",
    results_count: "{count} إعلان",
    load_error: "خطأ في التحميل",
    retry: "إعادة المحاولة",
    not_found: "لم يتم العثور على إعلانات",
    not_found_short: "لا توجد إعلانات",
    not_found_desc_search: "حاول تعديل فلاتر البحث",
    not_found_desc_first: "ابدأ بإنشاء أول إعلان لك",
    create_button: "إنشاء إعلان",
    create_title: "إضافة إعلان جديد",
    create_subtitle: "أضف إعلاناً جديداً إلى شبكتك مع المعلومات والتكاليف المرتبطة.",
    id_missing: "معرف الإعلان مفقود.",
    auth_required: "أنت غير مصادق. يرجى تسجيل الدخول.",
    token_missing: "رمز المصادقة غير موجود. يرجى تسجيل الدخول.",
    fetch_failed: "فشل في جلب الإعلان",
    fetch_error_log: "خطأ أثناء جلب الإعلان:",
    fetch_unexpected_error: "حدث خطأ غير متوقع أثناء جلب الإعلان.",
    toast_error_prefix: "خطأ",
    load_failed: "فشل تحميل الإعلان.",
    fetch_error_title: "خطأ أثناء تحميل الإعلان",
    not_found_id: "الإعلان غير موجود",
    not_found_id_desc: "تعذر تحميل الإعلان بالمعرف \"{id}\" أو أنه غير موجود.",
    update_title: "تعديل الإعلان",
    update_subtitle: "قم بتعديل تفاصيل هذا الإعلان.",
    load_error_msg: "خطأ أثناء تحميل الإعلانات",
    error_prefix: "خطأ: {msg}",
  },

  // ==========================================
  // VALIDATION ERRORS
  // ==========================================
  validation: {
    product_name_required: "اسم المنتج مطلوب.",
    achat_price_required: "سعر الشراء مطلوب.",
    seller_price_required: "سعر البائع مطلوب.",
    selling_price_required: "سعر البيع مطلوب.",
    stock_required: "كمية المخزون مطلوبة.",
    category_required: "الفئة مطلوبة.",
    fournisseur_required: "المورد مطلوب.",
    primary_image_required: "الصورة الرئيسية مطلوبة.",
    price_logic: "يجب أن يكون سعر الشراء أقل من سعر البيع وسعر البائع.",
    clients_required: "يجب اختيار عميل واحد على الأقل عندما لا يكون المنتج عاماً.",
    discount_required: "الخصم مطلوب.",
    discount_start_date_required: "تاريخ بداية الخصم مطلوب.",
    discount_end_date_required: "تاريخ نهاية الخصم مطلوب.",
    end_date_after_start: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية.",
    image_type: "يجب أن يكون الملف المرفوع صورة.",
    image_type_toast: "يجب أن تكون الصورة الرئيسية صورة (PNG, JPG, GIF).",
    file_skipped: "الملف \"{fileName}\" ليس صورة وتم تخطيه.",
  },

  // ==========================================
  // ADMINS
  // ==========================================
  admins: {
    title_admin: "ملف المدير",
    title_assistant: "ملف المساعدين",
    subtitle: "إدارة الأدوار الإدارية",
    role_label: "الدور :",
    access_level: "مستوى الوصول",
    edit_profile: "تعديل الملف الشخصي",
    saving: "جاري التحديث...",
    personal_info: "المعلومات الشخصية",
    full_name_label: "الاسم الكامل *",
    name_placeholder: "أدخل الاسم الكامل...",
    select_gender: "اختر الجنس",
    male: "ذكر",
    female: "أنثى",
    not_specified: "غير محدد",
    phone_placeholder: "0612345678",
    admin_role_section: "الدور الإداري",
    no_role_available: "لا توجد أدوار متاحة",
    no_specific_role: "لا يوجد دور محدد",
    validation: {
      email_required: "عنوان البريد الإلكتروني إلزامي.",
      email_valid: "يجب أن يكون البريد الإلكتروني صالحاً.",
      name_required: "الاسم إلزامي.",
      gender_required: "الجنس إلزامي.",
      phone_required: "رقم الهاتف إلزامي.",
      phone_number: "يجب أن يكون رقم الهاتف رقماً.",
      role_required: "يرجى اختيار دور محدد للمساعد.",
    },
    success_update: "تم تحديث المستخدم بنجاح!",
    errors: {
      form_errors: "يرجى تصحيح الأخطاء في النموذج.",
      update_failed: "خطأ في تحديث المستخدم!",
    },
    server_connection_failed: "فشل الاتصال بالخادم",
    user_type_admin: "مدير",
    user_type_assistant: "مساعد",
    never: "أبداً",
    not_provided: "غير متوفر",
    never_connected: "لم يتصل أبداً",
    tooltip_never_connected: "هذا المدير لم يتصل أبداً",
    online_now: "متصل",
    tooltip_online_now: "هذا المدير متصل الآن",
    online_day: "متصل اليوم",
    tooltip_yesterday: "آخر اتصال أمس",
    inactive: "غير نشط",
    tooltip_last_activity_month: "آخر نشاط منذ أكثر من شهر",
    online_min: "منذ {minutes} دقيقة",
    tooltip_min_ago: "آخر نشاط قبل {minutes} دقيقة",
    online_hours: "منذ {hours} ساعة",
    tooltip_hours_ago: "آخر نشاط قبل {hours} ساعة",
    online_days: "منذ {days} يوم",
    tooltip_days_ago: "آخر نشاط قبل {days} يوم",
    online_weeks: "منذ {weeks} أسبوع",
    tooltip_weeks_ago: "آخر نشاط قبل {weeks} أسبوع",
    phone_label: "الهاتف :",
    last_login_label: "آخر تسجيل دخول :",
    created_label: "تاريخ الإنشاء :",
    error_fetch_msg: "فشل في جلب المستخدمين: {status}",
    error_unexpected_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات المستخدمين.",
    error_fetch_user: "فشل في جلب بيانات المستخدم.",
    error_fetch_roles: "فشل في جلب الأدوار.",
    page_title: "إدارة المديرين",
    page_subtitle: "إدارة المديرين والمساعدين ونشاطهم.",
    add: "إضافة المشرفين",
    total: "إجمالي المشرفين",
    active_today: "نشط اليوم",
    new_this_month: "جديد هذا الشهر",
    search_placeholder: "بحث عن المشرفين...",
    sort_name: "ترتيب أبجدي (الاسم)",
    sort_email: "ترتيب أبجدي (البريد)",
    sort_last_login: "آخر تسجيل دخول",
    sort_newest: "الأحدث أولاً",
    found_count: "تم العثور على المشرفين",
    no_results_title: "لم يتم العثور على المشرفين",
    no_results_desc: "حاول تعديل مصطلحات البحث أو الفلاتر.",
    add_first: "أضف أول المشرفين",
    load_error: "فشل تحميل بيانات المستخدمين",
  },

  // ==========================================
  // CONFIRMATORS
  // ==========================================
  confirmators: {
    title: "ملف المؤكد",
    subtitle: "إدارة المؤكدين",
    price_by_work: "السعر حسب العمل",
    price_by_confirm: "السعر حسب التأكيد",
    badge_title: "تأكيد",
    specialized_role: "دور متخصص",
    total_profit: "إجمالي الربح",
    total_orders: "إجمالي الطلبات",
    confirmation_percentage: "نسبة التأكيد",
    total_confirmed: "إجمالي المؤكد",
    total_sellers: "إجمالي البائعين",
    edit_profile: "تعديل الملف الشخصي",
    saving: "جاري التحديث...",
    personal_info: "المعلومات الشخصية",
    full_name_label: "الاسم الكامل *",
    name_placeholder: "أدخل الاسم الكامل...",
    select_gender: "اختر الجنس",
    male: "ذكر",
    female: "أنثى",
    not_specified: "غير محدد",
    phone_placeholder: "0612345678",
    rib_label: "رقم الحساب البنكي *",
    price_configuration: "تكوين الأسعار",
    active: "نشط",
    validation: {
      email_required: "عنوان البريد الإلكتروني إلزامي.",
      email_valid: "يجب أن يكون البريد الإلكتروني صالحاً.",
      name_required: "الاسم إلزامي.",
      gender_required: "الجنس إلزامي.",
      phone_required: "رقم الهاتف إلزامي.",
      phone_number: "يجب أن يكون رقم الهاتف رقماً.",
      rib_required: "الحساب البنكي إلزامي.",
      rib_number: "يجب أن يكون الحساب البنكي رقماً.",
      price_type_required: "يرجى اختيار نوع السعر.",
      price_confirm_required: "سعر التأكيد إلزامي.",
      price_confirm_positive: "يجب أن يكون سعر التأكيد رقماً موجباً.",
      price_work_required: "سعر العمل إلزامي.",
      price_work_positive: "يجب أن يكون سعر العمل رقماً موجباً.",
    },
    success_update: "تم تحديث المؤكد بنجاح!",
    errors: {
      form_errors: "يرجى تصحيح الأخطاء في النموذج.",
      update_failed: "خطأ في تحديث المؤكد!",
      unexpected: "حدث خطأ غير متوقع.",
      server_connection: "فشل الاتصال بالخادم. يرجى المحاولة مرة أخرى.",
    },
    no_name: "بدون اسم",
    no_phone: "بدون هاتف",
    never_connected: "لم يتصل أبداً",
    tooltip_never_connected: "هذا المؤكد لم يتصل أبداً",
    online_now: "متصل الآن",
    tooltip_online_now: "هذا المؤكد متصل الآن",
    online_day: "متصل اليوم",
    tooltip_yesterday: "آخر اتصال أمس",
    inactive: "غير نشط",
    tooltip_last_activity_month: "آخر نشاط منذ أكثر من شهر",
    online_min: "منذ {minutes} دقيقة",
    tooltip_min_ago: "آخر نشاط قبل {minutes} دقيقة",
    online_hours: "منذ {hours} ساعة",
    tooltip_hours_ago: "آخر نشاط قبل {hours} ساعة",
    online_days: "منذ {days} يوم",
    tooltip_days_ago: "آخر نشاط قبل {days} يوم",
    online_weeks: "منذ {weeks} أسبوع",
    tooltip_weeks_ago: "آخر نشاط قبل {weeks} أسبوع",
    confirmation_rate: "نسبة التأكيد",
    per_month: "شهرياً",
    per_confirmation: "لكل تأكيد",
    joined: "عضو منذ",
    error_fetch_msg: "فشل في جلب المؤكدين: {status}",
    error_fetch_user: "فشل في جلب بيانات المؤكد.",
    error_fetch_sellers: "فشل في جلب البائعين النشطين.",
    page_title: "إدارة المؤكدين",
    page_subtitle: "إدارة متخصصي التأكيد بكفاءة وتتبع أدائهم.",
    add: "إضافة مؤكد",
    total: "إجمالي المؤكدين",
    avg_rate: "متوسط السعر",
    highest_rate: "أعلى سعر",
    new_this_month: "جديد هذا الشهر",
    search_placeholder: "بحث عن مؤكدين...",
    sort_name: "ترتيب أبجدي (الاسم)",
    sort_email: "ترتيب أبجدي (البريد)",
    sort_rate_high: "السعر: من الأعلى إلى الأدنى",
    sort_rate_low: "السعر: من الأدنى إلى الأعلى",
    found_count: "تم العثور على {count} مؤكد(ين)",
    no_results_title: "لم يتم العثور على مؤكدين",
    add_first: "أضف أول مؤكد لك",
    load_error: "فشل تحميل بيانات المستخدم",
    load_sellers_error: "فشل تحميل بيانات البائعين",
    unexpected_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات المؤكدين.",
    loading_error: "خطأ أثناء تحميل المؤكدين.",
  },

  // ==========================================
  // BLACKLIST
  // ==========================================
  blacklist: {
    title: "القائمة السوداء",
    subtitle: "إدارة القائمة السوداء للعملاء أو الأرقام أو العناوين المحظورة لمنع الطلبات الخطرة أو الاحتيالية.",
    no_results: "لم يتم العثور على نتائج",
    empty: "القائمة السوداء فارغة",
    no_results_desc: "لا توجد إدخالات تطابق بحثك.",
    empty_desc: "ابدأ بإضافة عملاء أو أرقام إلى القائمة السوداء.",
    blocked_on: "تم الحظر في",
    unblock: "إلغاء الحظر",
    unblock_success: "تم إلغاء حظر العميل بنجاح",
    unblock_error: "خطأ أثناء إلغاء الحظر",
    unexpected_error: "حدث خطأ",
    unblock_modal_title: "إلغاء حظر العميل",
    unblock_modal_message: "هل أنت متأكد أنك تريد إزالته من القائمة السوداء؟",
  },

  // ==========================================
  // FOURNISSEURS
  // ==========================================
  fournisseurs: {
    auth_required: "المصادقة مطلوبة. يرجى تسجيل الدخول.",
    supplier_name_label: "اسم المورد",
    supplier_name_placeholder: "أدخل اسم المورد...",
    contact_person_label: "اسم جهة الاتصال",
    contact_person_placeholder: "أدخل اسم شخص جهة الاتصال...",
    email_label: "البريد الإلكتروني",
    email_placeholder: "أدخل عنوان البريد الإلكتروني...",
    phone_label: "الهاتف",
    phone_placeholder: "أدخل رقم الهاتف...",
    saving: "جاري الحفظ...",
    live_preview: "معاينة حية",
    contact: "جهة الاتصال :",
    email_display: "البريد الإلكتروني :",
    phone_display: "الهاتف :",
    supplier_name_default: "اسم المورد",
    contact_person_default: "شخص جهة الاتصال",
    email_default: "البريد الإلكتروني",
    phone_default: "الهاتف",
    success_created: "تم إنشاء المورد بنجاح!",
    success_description: "تمت إضافة موردك الجديد إلى النظام.",
    validation: {
      name_required: "اسم المورد مطلوب.",
      personnel_required: "اسم الموظف مطلوب.",
      email_required: "عنوان البريد الإلكتروني مطلوب.",
      email_valid: "يرجى إدخال بريد إلكتروني صالح.",
      phone_required: "رقم الهاتف مطلوب.",
      phone_valid: "يرجى إدخال رقم هاتف صالح.",
    },
    errors: {
      form_errors: "يرجى تصحيح الأخطاء في النموذج.",
      highlighted_fields: "يرجى تصحيح الحقول المظللة.",
      network_error: "حدث خطأ شبكة غير متوقع. يرجى التحقق من اتصالك.",
      unexpected: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
      unexpected_short: "حدث خطأ غير متوقع.",
      create_failed: "فشل إنشاء المورد. يرجى المحاولة مرة أخرى.",
      create_failed_short: "فشل الإنشاء.",
    },
    success_update: "تم تحديث المورد بنجاح!",
    delete_title: "حذف المورد",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا المورد؟",
    title: "الموردين",
    subtitle: "قم بإدارة مورديك، معلومات الاتصال الخاصة بهم وتفاصيلهم.",
    add: "إضافة مورد",
    search_placeholder: "البحث عن موردين...",
    sort_name: "الاسم",
    sort_contact: "اسم جهة الاتصال",
    sort_newest: "الأحدث",
    sort_oldest: "الأقدم",
    fournisseur_singular: "مورد",
    fournisseur_plural: "موردين",
    found: "تم العثور على",
    not_found: "لم يتم العثور على موردين",
    not_found_desc: "حاول تعديل كلمات البحث أو الفلاتر للعثور على ما تبحث عنه.",
    create_first: "إنشاء أول مورد لك",
    create_title: "إنشاء مورد",
    create_subtitle: "أضف خيار مورد جديد لمنتجاتك. حدد الألوان والأحجام والمواد أو أي سمة أخرى.",
    update_title: "تعديل المورد",
    update_subtitle: "قم بتعديل تفاصيل هذا المورد.",
    id_missing: "معرف المورد مفقود.",
    fetch_failed: "فشل في جلب المورد",
    fetch_error: "حدث خطأ غير متوقع أثناء جلب المورد.",
    load_failed: "فشل تحميل المورد.",
    error_loading: "خطأ أثناء تحميل المورد",
    not_found_id: "المورد غير موجود",
    not_found_id_desc: "تعذر تحميل المورد بالمعرف \"{id}\" أو أنه غير موجود.",
    error_fetch_msg: "فشل في جلب الموردين: {status}",
    error_unexpected_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات الموردين.",
  },

  // ==========================================
  // LIVREURS
  // ==========================================
  livreurs: {
    auth_required: "المصادقة مطلوبة. يرجى تسجيل الدخول.",
    subtitle: "إدارة الموصلين",
    badge_title: "موصل",
    trust_score: "درجة الثقة",
    total_delivered: "إجمالي التسليم",
    unit_price: "السعر الوحدوي",
    total_earnings: "إجمالي الأرباح المقدرة",
    personal_info: "المعلومات الشخصية",
    delivery_person_label: "اسم الموصل",
    name_placeholder: "أدخل اسم الموصل...",
    email_label: "البريد الإلكتروني",
    email_placeholder: "أدخل البريد الإلكتروني للموصل...",
    phone_label: "الهاتف",
    phone_placeholder: "أدخل رقم الهاتف...",
    delivery_payment_details: "تفاصيل التوصيل والدفع",
    delivery_price_label: "سعر التوصيل (درهم)",
    delivery_price_placeholder: "أدخل سعر التوصيل...",
    rib_label: "الحساب البنكي (اختياري)",
    rib_placeholder: "أدخل الحساب البنكي...",
    saving: "جاري الحفظ...",
    recent_activity: "النشاط الأخير",
    order: "الطلب",
    action_date: "تاريخ الإجراء",
    delivery_price_header: "سعر التوصيل",
    status: "الحالة",
    total: "المجموع",
    validation: {
      name_required: "اسم الموصل مطلوب.",
      email_required: "البريد الإلكتروني مطلوب.",
      email_valid: "البريد الإلكتروني غير صالح.",
      phone_required: "رقم الهاتف مطلوب.",
      phone_valid: "يرجى إدخال رقم هاتف صالح.",
      delivery_price_required: "سعر التوصيل مطلوب.",
      delivery_price_number: "يجب أن يكون سعر التوصيل رقماً.",
    },
    errors: {
      form_errors: "يرجى تصحيح الأخطاء في النموذج.",
      highlighted_fields: "يرجى تصحيح الحقول المظللة.",
      network_error: "حدث خطأ شبكة غير متوقع. يرجى التحقق من اتصالك.",
      unexpected: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
    },
    success_update: "تم تحديث الموصل بنجاح!",
    delete_title: "حذف الموصل",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا الموصل؟",
    title: "الموصلين",
    list_subtitle: "قم بإدارة الموصلين، معلومات الاتصال الخاصة بهم وأسعارهم.",
    add: "إضافة موصل",
    sort_name: "الاسم",
    sort_newest: "الأحدث",
    sort_oldest: "الأقدم",
    sort_price_asc: "السعر تصاعدياً",
    sort_price_desc: "السعر تنازلياً",
    livreur_singular: "موصل",
    livreur_plural: "موصلين",
    found: "تم العثور على",
    not_found: "لم يتم العثور على موصلين",
    not_found_desc: "حاول تعديل كلمات البحث أو الفلاتر.",
    create_first: "إنشاء أول موصل لك",
    id_missing: "معرف الموصل مفقود.",
    fetch_failed: "فشل في جلب الموصل",
    fetch_error: "حدث خطأ غير متوقع أثناء جلب الموصل.",
    load_failed: "فشل تحميل الموصل.",
    error_loading: "خطأ أثناء تحميل الموصل",
    not_found_id: "الموصل غير موجود",
    not_found_id_desc: "تعذر تحميل الموصل بالمعرف \"{id}\" أو أنه غير موجود.",
    error_fetch_msg: "فشل في جلب الموصلين: {status}",
    error_unexpected_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات الموصلين.",
  },

  // ==========================================
  // ROLES
  // ==========================================
  roles: {
    role_name_label: "اسم الدور *",
    role_name_placeholder: "مثال: مدير، محرر، مدير منتجات",
    success_update: "تم تعديل الدور بنجاح!",
    updated_with_permissions: "تم تحديث الدور بالصلاحيات المحددة.",
    assign_permissions: "تخصيص الصلاحيات",
    assign_permissions_desc: "اختر الإجراءات المحددة التي يمكن لهذا الدور القيام بها.",
    select_all: "الكل",
    select_none: "لا شيء",
    saving: "جاري التحديث...",
    update: "تحديث",
    role_preview: "معاينة الدور",
    role_name_default: "اسم الدور",
    permissions_label: "الصلاحيات :",
    permissions_total: "صلاحية إجمالاً",
    no_permissions_selected: "لم يتم تحديد أي صلاحية",
    and_others: "و",
    others: "أخرى",
    role_admin: "مدير",
    role_assistant: "مساعد",
    role_confirmator: "مؤكد",
    role_livreur: "موصل",
    errors: {
      update_failed: "خطأ أثناء تعديل الدور",
    },
    validation: {
      name_required: "اسم الدور مطلوب",
    },
    active_permissions: "الصلاحيات النشطة",
    no_permissions: "لا توجد صلاحيات",
    delete_title: "حذف الدور",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
    permissions: {
      product_management: "إدارة المنتجات",
      product_management_desc: "عرض وإدارة المنتجات",
      category_management: "إدارة الفئات",
      category_management_desc: "إدارة فئات المنتجات",
      variant_management: "إدارة المتغيرات",
      variant_management_desc: "إدارة متغيرات المنتجات",
      supplier_management: "إدارة الموردين",
      supplier_management_desc: "إدارة الموردين",
      order_management: "إدارة الطلبات",
      order_management_desc: "إدارة طلبات العملاء والتوصيل",
      confirmator_management: "إدارة المؤكدين",
      confirmator_management_desc: "إدارة مؤكدي الطلبات",
      seller_management: "إدارة البائعين",
      seller_management_desc: "إدارة حسابات البائعين",
      confirmator_invoices: "فواتير المؤكدين",
      confirmator_invoices_desc: "إدارة فواتير ومدفوعات المؤكدين",
      seller_invoices: "فواتير البائعين",
      seller_invoices_desc: "إدارة فواتير ومدفوعات البائعين",
      statistics: "الإحصائيات",
      statistics_desc: "عرض إحصائيات وتقارير النظام",
      announcement_management: "إدارة الإعلانات",
      announcement_management_desc: "إدارة إعلانات النظام",
      reclamation_management: "إدارة الشكاوى",
      reclamation_management_desc: "إدارة شكاوى العملاء وملاحظاتهم",
      system_configuration: "إعدادات النظام",
      system_configuration_desc: "تعديل إعدادات النظام",
      blacklist_management: "إدارة القائمة السوداء",
      blacklist_management_desc: "إدارة المستخدمين أو الكيانات في القائمة السوداء",
    },
    permission_groups: {
      product_management: "إدارة المنتجات",
      product_management_desc: "عرض وإدارة المنتجات",
      category_management: "إدارة الفئات",
      category_management_desc: "إدارة فئات المنتجات",
      variant_management: "إدارة المتغيرات",
      variant_management_desc: "إدارة متغيرات المنتجات",
      supplier_management: "إدارة الموردين",
      supplier_management_desc: "إدارة الموردين",
      order_management: "إدارة الطلبات",
      order_management_desc: "إدارة طلبات العملاء والتوصيل",
      confirmator_management: "إدارة المؤكدين",
      confirmator_management_desc: "إدارة مؤكدي الطلبات",
      seller_management: "إدارة البائعين",
      seller_management_desc: "إدارة حسابات البائعين",
      confirmator_invoices: "فواتير المؤكدين",
      confirmator_invoices_desc: "إدارة فواتير ومدفوعات المؤكدين",
      seller_invoices: "فواتير البائعين",
      seller_invoices_desc: "إدارة فواتير ومدفوعات البائعين",
      statistics: "الإحصائيات",
      statistics_desc: "عرض إحصائيات وتقارير النظام",
      announcement_management: "إدارة الإعلانات",
      announcement_management_desc: "إدارة إعلانات النظام",
      reclamation_management: "إدارة الشكاوى",
      reclamation_management_desc: "إدارة شكاوى العملاء وملاحظاتهم",
      system_configuration: "إعدادات النظام",
      system_configuration_desc: "تعديل إعدادات النظام",
      blacklist_management: "إدارة القائمة السوداء",
      blacklist_management_desc: "إدارة المستخدمين أو الكيانات في القائمة السوداء",
    },
    permission_labels: {
      view_products: "عرض المنتجات",
      add_product: "إضافة منتج",
      edit_product: "تعديل منتج",
      delete_product: "حذف منتج",
      view_categories: "عرض الفئات",
      add_category: "إضافة فئة",
      edit_category: "تعديل فئة",
      delete_category: "حذف فئة",
      view_variants: "عرض المتغيرات",
      add_variant: "إضافة متغير",
      edit_variant: "تعديل متغير",
      delete_variant: "حذف متغير",
      view_fournisseurs: "عرض الموردين",
      add_fournisseur: "إضافة مورد",
      edit_fournisseur: "تعديل مورد",
      delete_fournisseur: "حذف مورد",
      view_orders: "عرض الطلبات",
      update_order: "تعديل طلب",
      delete_order: "حذف طلب",
      scan_order: "مسح طلب",
      send_delivery: "إرسال توصيل",
      view_confirmator: "عرض المؤكدين",
      add_confirmator: "إضافة مؤكد",
      edit_confirmator: "تعديل مؤكد",
      delete_confirmator: "حذف مؤكد",
      change_confirmator_password: "تغيير كلمة مرور المؤكد",
      view_saller: "عرض البائعين",
      add_saller: "إضافة بائع",
      edit_saller: "تعديل بائع",
      delete_saller: "حذف بائع",
      change_saller_password: "تغيير كلمة مرور البائع",
      update_saller_status: "تحديث حالة البائع",
      view_confirmator_invoices: "عرض فواتير المؤكدين",
      generate_confirmator_invoices: "إنشاء فواتير المؤكدين",
      pay_confirmator_invoices: "دفع فواتير المؤكدين",
      delete_confirmator_invoices: "حذف فواتير المؤكدين",
      view_saller_invoices: "عرض فواتير البائعين",
      generate_saller_invoices: "إنشاء فواتير البائعين",
      pay_saller_invoices: "دفع فواتير البائعين",
      delete_saller_invoices: "حذف فواتير البائعين",
      view_statistics: "عرض الإحصائيات",
      view_annonces: "عرض الإعلانات",
      add_annonce: "إضافة إعلان",
      edit_annonce: "تعديل إعلان",
      delete_annonce: "حذف إعلان",
      view_reclamations: "عرض الشكاوى",
      reply_reclamation: "الرد على الشكاوى",
      delete_reclamation: "حذف شكوى",
      edit_config: "تعديل الإعدادات",
      view_blacklist: "عرض القائمة السوداء",
      add_blacklist: "إضافة إلى القائمة السوداء",
      remove_blacklist: "إزالة من القائمة السوداء",
    },
  },

  // ==========================================
  // CITIES
  // ==========================================
  cities: {
    title: "المدن",
    subtitle: "إدارة مدن التوصيل ورسوم الشحن المرتبطة بها.",
    search_placeholder: "البحث عن المدن...",
    sort_delivery_low: "سعر التوصيل: تصاعدي",
    sort_delivery_high: "سعر التوصيل: تنازلي",
    sort_return_low: "سعر الإرجاع: تصاعدي",
    sort_return_high: "سعر الإرجاع: تنازلي",
    found_count: "{count} مدينة",
    page_info: "الصفحة {page} من {total}",
    no_results_title: "لم يتم العثور على مدن",
    shipping_fee: "رسوم الشحن",
    shipping: "الشحن",
    return: "إرجاع",
    refusal: "رفض",
    exchange: "استبدال",
    error_fetch_msg: "فشل في جلب المدن: {status}",
    error_unexpected_format: "تم استلام تنسيق بيانات غير متوقع من واجهة برمجة تطبيقات المدن.",
    error_loading: "خطأ أثناء تحميل المدن.",
  },

  // ==========================================
  // VARIANTS (update form)
  // ==========================================
  variants: {
    create_title: "إنشاء متغير جديد",
    create_subtitle: "أضف خيار متغير جديد لمنتجاتك. حدد الألوان أو المقاسات أو الخامات أو أي سمة أخرى.",
    update_title: "تعديل المتغير",
    update_subtitle: "قم بتعديل تفاصيل هذا المتغير.",
    id_missing: "معرف المتغير مفقود.",
    fetch_failed: "فشل جلب المتغير",
    unexpected_format: "تنسيق بيانات غير متوقع من واجهة المتغيرات.",
    error_loading: "خطأ أثناء تحميل المتغير",
    error_loading_title: "خطأ أثناء تحميل المتغير",
    not_found: "المتغير غير موجود",
    not_found_desc: "تعذر تحميل المتغير بالمعرف \"{id}\" أو أنه غير موجود.",
    error_prefix: "خطأ:",
    variant_product: "منتج بمتغيرات",
    available_all_clients: "متاح لجميع العملاء افتراضياً",
    dimensions: "أبعاد المتغيرات",
    color: "لون",
    size: "مقاس",
    choose_dimensions_hint: "اختر اللون فقط، أو المقاس فقط، أو كليهما. كل خيار محدد هو متغير قابل للبيع؛ جميع الصفوف تستخدم نفس الأبعاد.",
    add_color_size_hint: "أضف لوناً واحداً على الأقل ومقاساً واحداً في إعدادات المتغيرات لاستخدام شبكة اللون × المقاس.",
    color_size_header: "اللون / المقاس",
    color_header: "اللون",
    size_header: "المقاس",
    include_header: "تضمين",
    no_colors_defined: "لم يتم تعريف ألوان في إعدادات المتغيرات.",
    no_sizes_defined: "لم يتم تعريف مقاسات في إعدادات المتغيرات.",
    error_select_types: "اختر اللون و/أو المقاس للمتغيرات.",
    error_select_one: "اختر خيار متغير واحد على الأقل.",
    list_title: "المتغيرات",
    list_subtitle: "قم بإدارة متغيرات المنتجات، بما في ذلك الألوان والمقاسات والخامات والسمات الأخرى.",
    add_variant: "إضافة متغير",
    search_placeholder: "البحث عن المتغيرات...",
    filter_by_type: "تصفية حسب النوع",
    all_types: "جميع الأنواع",
    sort_type: "النوع",
    found_count: "{count} متغير موجود",
    found_count_plural: "{count} متغيرات موجودة",
    no_variants_found: "لم يتم العثور على متغيرات",
    no_results_desc: "حاول تعديل كلمات البحث أو الفلاتر للعثور على ما تبحث عنه.",
    create_first: "أنشئ أول متغير",
    auth_required: "المصادقة مطلوبة. يرجى تسجيل الدخول.",
    warning: "تحذير: إذا قمت بتعديل متغير، فسيتغير في جميع الطلبات القديمة!",
    variant_type_label: "نوع المتغير *",
    type_color: "لون",
    type_size: "مقاس",
    type_material: "خامة",
    type_other: "أخرى",
    variant_name_label: "اسم المتغير *",
    name_placeholder: "مثال: صغير، أزرق، قطن",
    variant_value_label: "قيمة المتغير *",
    value_label: "القيمة",
    color_placeholder: "var(--color-primary-500) أو أحمر",
    choose_predefined_colors: "أو اختر من الألوان المحددة مسبقاً:",
    value_placeholder: "أدخل القيمة...",
    saving: "جاري الحفظ...",
    save_changes: "حفظ التغييرات",
    live_preview: "معاينة حية",
    no_value: "لا توجد قيمة",
    variant_name_default: "اسم المتغير",
    selected_color: "اللون المحدد",
    select_color: "اختر اللون",
    preview_color: "معاينة اللون",
    success_update: "تم تحديث المتغير بنجاح!",
    success_created: "تم إنشاء المتغير بنجاح!",
    success_description: "تمت إضافة المتغير الجديد إلى النظام.",
    validation: {
      name_required: "اسم المتغير مطلوب.",
      value_required: "قيمة المتغير مطلوبة.",
      color_invalid: "يرجى إدخال رمز لون سداسي عشري صالح (مثل: var(--color-primary-500)).",
    },
    errors: {
      highlighted_fields: "يرجى تصحيح الحقول المظللة.",
      network_error: "حدث خطأ شبكة غير متوقع. يرجى التحقق من اتصالك.",
      unexpected: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
      create_failed: "فشل إنشاء المتغير. يرجى المحاولة مرة أخرى.",
    },
    delete_title: "حذف المتغير",
    delete_message: "هل أنت متأكد أنك تريد حذف هذا المتغير؟",
  },

  // ==========================================
  // USERS
  // ==========================================
  users: {
    success_created: "تم إنشاء المستخدم بنجاح!",
    success_description: "تمت إضافة المستخدم الجديد إلى النظام.",
    server_error: "حدث خطأ غير متوقع.",
    server_connection_failed: "فشل الاتصال بالخادم. يرجى المحاولة مرة أخرى.",
    no_permission: "ليس لديك الصلاحيات اللازمة!",
    create_error: "خطأ في إنشاء المستخدم!",
    correct_form_errors: "يرجى تصحيح الأخطاء في النموذج.",
    no_store: "لا يوجد متجر",
    no_sellers_found: "لم يتم العثور على بائعين",
    create_user: "إنشاء المستخدم",
    create_title: "إنشاء مستخدم جديد",
    create_subtitle: "أضف مستخدماً جديداً إلى النظام مع صلاحيات قائمة على الأدوار ومعلومات إضافية.",
    error_fetch: "خطأ: {error}",
    no_token: "لم يتم العثور على رمز المصادقة",
    failed_roles: "فشل في جلب الأدوار",
    failed_sellers: "فشل في جلب البائعين",
    role_admin: "مدير",
    role_assistant: "مساعد",
    role_confirmator: "مؤكد",
    role_livreur: "موصل",
    sections: {
      livreur_info: "معلومات الموصل",
      confirmator_info: "معلومات المؤكد",
      assigned_sellers: "البائعون المعينون",
      assigned_sellers_desc: "اختر البائعين الذين يمكن لهذا المؤكد العمل معهم:",
    },
    labels: {
      confirmator_price: "السعر *",
      price_by_confirm: "السعر حسب التأكيد *",
      price_by_work: "السعر حسب العمل *",
    },
    placeholders: {
      email: "user@example.com",
      password: "أدخل كلمة المرور...",
      confirm_password: "تأكيد كلمة المرور...",
      rib: "12345678901234567890",
      confirmator_price: "25.00",
      work_price: "500.00",
      delivery_price: "20.00",
      select_sellers: "البحث عن البائعين واختيارهم...",
    },
    validation: {
      email_required: "عنوان البريد الإلكتروني إلزامي.",
      email_valid: "يجب أن يكون البريد الإلكتروني صالحاً.",
      password_required: "كلمة المرور إلزامية.",
      password_min_length: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
      password_mismatch: "كلمتا المرور غير متطابقتين.",
      role_required: "الدور إلزامي.",
      role_invalid: "يجب أن يكون الدور 1 (مدير)، 2 (مساعد)، 3 (مؤكد) أو 4 (موصل).",
      name_required: "الاسم إلزامي.",
      gender_required: "الجنس إلزامي.",
      phone_required: "رقم الهاتف إلزامي.",
      phone_number: "يجب أن يكون رقم الهاتف رقماً.",
      no_assistant_roles: "لا توجد أدوار مساعد متاحة. يرجى الاتصال بالمسؤول.",
      select_assistant_role: "يرجى اختيار دور محدد للمساعد.",
      rib_required: "الحساب البنكي إلزامي للأدوار 3.",
      rib_number: "يجب أن يكون الحساب البنكي رقماً.",
      price_type_required: "يرجى اختيار نوع السعر (حسب التأكيد أو حسب العمل).",
      confirm_price_required: "سعر التأكيد إلزامي.",
      confirm_price_positive: "يجب أن يكون سعر التأكيد رقماً موجباً.",
      work_price_required: "سعر العمل إلزامي.",
      work_price_positive: "يجب أن يكون سعر العمل رقماً موجباً.",
      livreur_price_required: "سعر التوصيل إلزامي.",
      livreur_price_number: "يجب أن يكون السعر رقماً.",
    },
  },

  // ==========================================
  // PERMISSION GROUPS (used in roles create/edit form)
  // ==========================================
  permission_groups: {
    product_management: "إدارة المنتجات",
    product_management_desc: "عرض وإدارة المنتجات",
    category_management: "إدارة الفئات",
    category_management_desc: "إدارة فئات المنتجات",
    variant_management: "إدارة المتغيرات",
    variant_management_desc: "إدارة متغيرات المنتجات",
    supplier_management: "إدارة الموردين",
    supplier_management_desc: "إدارة الموردين",
    order_management: "إدارة الطلبات",
    order_management_desc: "إدارة طلبات العملاء والتوصيل",
    confirmator_management: "إدارة المؤكدين",
    confirmator_management_desc: "إدارة مؤكدي الطلبات",
    seller_management: "إدارة البائعين",
    seller_management_desc: "إدارة حسابات البائعين",
    confirmator_invoices: "فواتير المؤكدين",
    confirmator_invoices_desc: "إدارة فواتير ومدفوعات المؤكدين",
    seller_invoices: "فواتير البائعين",
    seller_invoices_desc: "إدارة فواتير ومدفوعات البائعين",
    statistics: "الإحصائيات",
    statistics_desc: "عرض إحصائيات وتقارير النظام",
    announcement_management: "إدارة الإعلانات",
    announcement_management_desc: "إدارة إعلانات النظام",
    reclamation_management: "إدارة الشكاوى",
    reclamation_management_desc: "إدارة شكاوى العملاء وملاحظاتهم",
    system_configuration: "إعدادات النظام",
    system_configuration_desc: "تعديل إعدادات النظام",
    blacklist_management: "إدارة القائمة السوداء",
    blacklist_management_desc: "إدارة المستخدمين أو الكيانات في القائمة السوداء",
  },

  // ==========================================
  // CART
  // ==========================================
  cart: {
    your_cart: "سلتك",
    check_items: "تحقق من منتجاتك وأكمل عملية الشراء",
    items_in_cart: "المنتجات في السلة ({count})",
    cart_empty: "سلتك فارغة.",
    selling_price_label: "سعر البيع",
    selling_price_placeholder: "أدخل سعر البيع...",
    reduce_quantity: "تقليل الكمية",
    increase_quantity: "زيادة الكمية",
    remove_item: "إزالة المنتج",
    order_summary: "ملخص الطلب",
    subtotal_with_items: "المجموع الفرعي ({count} منتجات)",
    shipping: "الشحن",
    estimated_profit: "الربح المقدر",
    total_client: "إجمالي العميل",
    total_client_colon: "إجمالي العميل :",
    estimated_profit_colon: "الربح المقدر :",
    secure_payment: "دفع آمن",
    free_returns: "إرجاع مجاني",
    checkout_details: "تفاصيل الدفع",
    name_label: "الاسم",
    name_placeholder: "أدخل الاسم...",
    phone_label: "رقم الهاتف",
    phone_placeholder: "أدخل رقم الهاتف...",
    city_label: "المدينة",
    loading_cities: "جاري تحميل المدن...",
    choose_city: "اختر مدينة...",
    no_cities_found: "لم يتم العثور على مدن",
    address_label: "العنوان",
    address_placeholder: "أدخل العنوان...",
    change: "تغيير",
    unlockable: "فتح الطرد",
    already_confirmed: "مؤكد مسبقاً",
    comment_label: "تعليق",
    comment_placeholder: "أدخل التعليق...",
    submitting: "جاري الإرسال...",
    place_order: "تقديم الطلب",
    fill_required_fields: "يرجى ملء جميع الحقول الإلزامية.",
    cart_empty_order: "سلتك فارغة. أضف منتجات لتقديم الطلب.",
    check_selling_prices: "يرجى التحقق من أسعار البيع لجميع المنتجات.",
    profit_min_error: "يجب أن يكون ربح الطلب 10 دراهم على الأقل.",
    order_submitted: "تم تقديم الطلب بنجاح!",
    order_submit_error: "خطأ أثناء تقديم الطلب.",
    error_loading_cities: "خطأ أثناء تحميل المدن.",
    parse_cart_error: "خطأ في تحليل بيانات السلة.",
    items_label: "منتجات",
  },

  // ==========================================
  // PROFILE
  // ==========================================
  profile: {
    admin: {
      title_admin: "مدير",
      title_assistant: "مساعد",
      role_admin_desc: "مسؤول النظام",
      role_assistant_desc: "مساعد النظام",
      trust_score: "درجة الثقة",
      edit: "تعديل الملف الشخصي",
      saving: "جاري التحديث...",
      save: "حفظ",
      cancel: "إلغاء",
      personal_info: "المعلومات الشخصية",
      account_settings: "إعدادات الحساب",
      full_name: "الاسم الكامل",
      gender: "الجنس",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      not_specified: "غير محدد",
      male: "ذكر",
      female: "أنثى",
      update_success: "تم تحديث المستخدم بنجاح!",
      update_error: "خطأ في تحديث البيانات!",
      connection_error: "خطأ في الاتصال",
    },
    seller: {
      personal_info: "المعلومات الشخصية",
      edit_profile: "تعديل الملف الشخصي",
      saving: "جاري التحديث...",
      save: "حفظ",
      cancel: "إلغاء",
      loading: "جاري تحميل بيانات المستخدم...",
      full_name: "الاسم الكامل",
      store_name: "اسم المتجر",
      bank_name: "اسم البنك",
      rib: "رقم الحساب البنكي",
      logo: "شعار المتجر (اختياري)",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      address: "العنوان",
      seller_level: "مستوى البائع",
      not_specified: "غير محدد",
      current_logo: "الشعار الحالي",
      no_logo: "لم يتم تحميل شعار",
      delete_logo_aria: "حذف الشعار",
      level_prefix: "المستوى",
      level_badge: "مستوى البائع",
      update_success: "تم تحديث الملف الشخصي بنجاح!",
      update_error: "فشل تحديث الملف الشخصي",
      validation_error: "يرجى تصحيح الأخطاء في النموذج",
      server_error: "خطأ في التحقق",
      name_error: "يجب أن يحتوي الاسم على حرفين على الأقل",
      store_name_error: "يجب أن يحتوي اسم المتجر على حرفين على الأقل",
      bank_error: "يرجى اختيار بنك",
      rib_error: "يجب أن يحتوي رقم الحساب البنكي على 10 أحرف على الأقل",
      address_error: "يجب أن يحتوي العنوان على 5 أحرف على الأقل",
      phone_error: "يرجى إدخال رقم هاتف صالح",
      email_error: "يرجى إدخال بريد إلكتروني صالح",
      image_type_error: "يرجى اختيار ملف صورة",
      image_size_error: "يجب أن يكون حجم الصورة أقل من 5 ميغابايت",
      store_alt: "شعار المتجر",
      level_beginner: "مبتدئ",
      level_intermediate: "متوسط",
      level_advanced: "متقدم",
    },
    confirmator: {
      title: "ملف المؤكد",
      subtitle: "مؤكد الطلبات",
      badge: "مؤكد",
      trust_score: "درجة الثقة",
      edit: "تعديل الملف الشخصي",
      saving: "جاري التحديث...",
      save: "حفظ",
      cancel: "إلغاء",
      full_name: "الاسم الكامل",
      gender: "الجنس",
      rib: "رقم الحساب البنكي",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      not_specified: "غير محدد",
      male: "ذكر",
      female: "أنثى",
      not_available: "غير متاح",
      update_success: "تم تحديث الملف الشخصي بنجاح!",
      update_error: "خطأ أثناء تحديث الملف الشخصي!",
      validation_error: "يرجى تصحيح الأخطاء في النموذج!",
      loading: "جاري تحميل بيانات المستخدم...",
      validation_phone: "رقم الهاتف يجب أن يكون نصاً",
      validation_email: "البريد الإلكتروني غير صالح",
      validation_name: "يجب أن يحتوي الاسم على حرفين على الأقل",
    },
    livreur: {
      title: "ملف الموصل",
      badge: "موصل",
      delivery_price_label: "سعر التوصيل",
      edit: "تعديل الملف الشخصي",
      saving: "جاري التحديث...",
      save: "حفظ",
      cancel: "إلغاء",
      full_name: "الاسم الكامل",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      rib: "رقم الحساب البنكي (اختياري)",
      delivery_price: "سعر التوصيل (درهم)",
      not_specified: "غير محدد",
      loading: "جاري تحميل بيانات المستخدم...",
      not_found: "ملف الموصل غير موجود.",
      update_success: "تم تحديث الملف الشخصي بنجاح!",
      update_error: "فشل تحديث الملف الشخصي",
      validation_error: "يرجى تصحيح الأخطاء في النموذج",
      server_error: "خطأ في التحقق",
      info_not_found: "معلومات الموصل غير موجودة",
      name_error: "يجب أن يحتوي الاسم على حرفين على الأقل",
      email_error: "يرجى إدخال بريد إلكتروني صالح",
      phone_error: "يرجى إدخال رقم هاتف صالح",
      rib_error: "يجب أن يحتوي رقم الحساب البنكي على 10 أحرف على الأقل",
    },
  },

  // ==========================================
  // ROLES
  // ==========================================
  roles_page: {
    title: "إدارة الأدوار",
    subtitle: "قم بتعريف وإدارة الصلاحيات الدقيقة للأدوار المختلفة في تطبيقك.",
    add_new: "إضافة دور جديد",
    search_placeholder: "البحث عن الأدوار بالاسم...",
    filter: "تصفية",
    sort_name: "الاسم",
    sort_newest: "الأحدث",
    sort_oldest: "الأقدم",
    sort_permissions: "عدد الصلاحيات",
    role_found_singular: "دور واحد",
    role_found_plural: "أدوار",
    no_roles_found: "لم يتم العثور على أدوار",
    no_roles_desc: "حاول تعديل كلمات البحث أو الفلاتر، أو أنشئ دوراً جديداً.",
    create_first: "أنشئ دورك الأول",
    create_title: "إضافة دور مساعد جديد",
    create_subtitle: "أضف دوراً جديداً إلى شبكة التوصيل مع تكاليف الشحن المرتبطة.",
    update_title: "تعديل الدور",
    update_subtitle: "قم بتعديل تفاصيل هذا الدور.",
    update_error_id: "معرف الدور مفقود.",
    update_not_authenticated: "لم يتم المصادقة. يرجى تسجيل الدخول.",
    update_auth_error: "رمز المصادقة غير موجود. يرجى تسجيل الدخول.",
    update_invalid_format: "تنسيق بيانات غير صالح من الخادم.",
    update_fetch_error: "حدث خطأ غير متوقع أثناء جلب الدور.",
    update_load_error: "فشل تحميل الدور.",
    update_load_title: "خطأ أثناء تحميل الفئة",
    update_retry: "إعادة المحاولة",
    update_not_found_title: "الفئة غير موجودة",
    update_not_found_desc: "تعذر تحميل الفئة بالمعرف \"{id}\" أو أنها غير موجودة.",
    update_data_format_error: "تنسيق بيانات غير صالح من الخادم.",
    update_api_format_error: "تنسيق بيانات غير متوقع من واجهة الأدوار.",
    update_loading_error: "خطأ في تحميل الأدوار.",
  },

  // ==========================================
  // SCAN RETURN
  // ==========================================
  scan: {
    scanner_title_ramassage: "مسح الطلبات الجاهزة للاستلام",
    scanner_title_retour: "مسح الطلبات المرتجعة",
    scanner_description: "امسح الرمز الشريطي لتغيير حالة الطلب إلى «تم استلام المرتجع»",
    scanner_description_ramassage: "امسح الرمز الشريطي لتغيير حالة الطلب إلى «جاهز للاستلام»",
    scanning: "جاري المسح...",
    press_enter: "اضغط Enter للمسح",
    already_scanned: "الطلب تم مسحه بالفعل",
    scan_success: "تم مسح الطلب بنجاح",
    current_status: "الحالة الحالية :",
    scanned_on: "تم المسح في",
    scanned_order: "الطلب الممسوح",
    client: "العميل",
    delivery: "التوصيل",
    vendor: "البائع",
    products: "المنتجات",
    total: "الإجمالي :",
    per_unit: "درهم/وحدة",
    status_history: "سجل الحالات",
    reason: "السبب :",
    postponed_to: "مؤجل إلى :",
    comment: "تعليق :",
    history_title: "سجل المسح",
    history_cleared: "تم مسح السجل",
    history_subtitle: "طلبات ممسوحة",
    marked_as_received: "مرتجع(ات) مستلم(ة)",
    no_scans: "لا توجد عمليات مسح حالياً",
    no_scans_desc: "امسح طلباً للبدء",
    rescan: "إعادة المسح",
    code_copied: "تم نسخ الرمز",
    copy_code: "نسخ الرمز",
    clear: "مسح",
    not_found: "الطلب غير موجود",
    scan_error: "خطأ في المسح",
    marked_return: "تم وضع علامة الطلب {code} كمستلم",
    marked_pre_a_ramasse: "تم وضع علامة الطلب {code} جاهز للتسليم",

  },

  // ==========================================
  // AUTH
  // ==========================================
  auth: {
    my_platform: "منصّتي",
    welcome_back: "مرحبًا بعودتك",
    login_subtitle: "سجّل الدخول إلى حسابك للمتابعة",
    email_label: "البريد الإلكتروني",
    email_placeholder: "أدخل بريدك الإلكتروني",
    password_label: "كلمة المرور",
    password_placeholder: "أدخل كلمة المرور",
    confirm_password_label: "تأكيد كلمة المرور",
    confirm_password_placeholder: "أعد إدخال كلمة المرور",
    remember_me: "تذكرني",
    forgot_password: "نسيت كلمة المرور؟",
    login_button: "تسجيل الدخول",
    no_account: "لا تملك حسابًا؟",
    create_account_link: "أنشئ حسابًا مجانًا",
    login_error: "خطأ في تسجيل الدخول",
    server_error: "فشل الاتصال بالخادم",
    register_title: "تسجيل حساب جديد",
    register_step: "الخطوة {step} من 2",
    step1_title: "معلومات الحساب الأساسية",
    step2_title: "تفاصيل معلومات البائع",
    account_info_title: "معلومات الحساب",
    seller_info_title: "معلومات البائع",
    full_name_label: "الاسم الكامل",
    full_name_placeholder: "أدخل اسمك الكامل",
    store_name_label: "اسم المتجر (اختياري)",
    store_name_placeholder: "أدخل اسم المتجر (إن وجد)",
    bank_name_label: "اسم البنك",
    rib_label: "RIB (رقم الحساب البنكي)",
    rib_placeholder: "أدخل رقم الحساب البنكي (RIB)",
    address_label: "العنوان",
    address_placeholder: "أدخل عنوانك الكامل",
    phone_label: "رقم الهاتف",
    phone_placeholder: "أدخل رقم هاتفك",
    seller_level_label: "مستوى البائع",
    seller_level_placeholder: "اختر مستوى البائع",
    level_beginner: "مبتدئ (Beginner)",
    level_intermediate: "متوسط (Intermediate)",
    level_advanced: "متقدم (Advanced)",
    store_logo_label: "شعار المتجر (اختياري)",
    next_button: "التالي",
    back_button: "العودة",
    submit_button: "إنشاء الحساب",
    has_account: "لديك حساب بالفعل؟",
    login_link_text: "تسجيل الدخول",
    register_success: "تم إنشاء حسابك بنجاح!",
    register_success_title: "تم إنشاء حسابك !",
    register_success_wait: "يُرجى انتظار تواصل الدعم لتفعيل حسابك.",
    register_redirecting: "جارٍ التحويل إلى صفحة تسجيل الدخول...",
    register_success_desc: "تم إنشاء حسابك ومعلومات البائع بنجاح! سيتم تحويلك إلى صفحة تسجيل الدخول",
    register_creation_failed: "فشل في إنشاء الحساب الأساسي.",
    register_validation_failed: "الرجاء تصحيح أخطاء التسجيل",
    name_required: "الاسم الكامل مطلوب",
    email_required: "البريد الإلكتروني مطلوب.",
    email_invalid: "صيغة البريد الإلكتروني غير صالحة.",
    password_required: "كلمة المرور مطلوبة.",
    password_min_length: "كلمة المرور يجب أن تتكون من 6 أحرف على الأقل.",
    confirm_password_required: "تأكيد كلمة المرور مطلوب.",
    password_mismatch: "كلمة المرور وتأكيدها غير متطابقين.",
    bank_required: "اسم البنك مطلوب.",
    rib_required: "رقم الحساب البنكي (RIB) مطلوب.",
    rib_24_digits: "يجب أن يتكون رقم الحساب البنكي (RIB) من 24 رقماً بالضبط.",
    address_required: "العنوان مطلوب.",
    phone_required: "رقم الهاتف مطلوب.",
    level_required: "مستوى البائع مطلوب.",
    show_password: "إظهار كلمة المرور",
    hide_password: "إخفاء كلمة المرور",
    terms_and_conditions: "الشروط والأحكام",
    bank_placeholder: "اختر البنك",
    today_earnings: "أرباح اليوم",
    products_sold: "+ 38 منتج تم بيعه",
    weekly_growth: "نمو هذا الأسبوع",
    total_revenue: "إجمالي الأرباح",
    total_products: "إجمالي المنتجات",
    commissions: "العمولات",
    this_week: "هذا الأسبوع",
    reset_back_to_login: "العودة إلى تسجيل الدخول",
    reset_forgot_title: "نسيت كلمة المرور؟",
    reset_forgot_subtitle: "أدخل بريدك الإلكتروني وسنرسل لك رمزًا لإعادة تعيين كلمة المرور",
    reset_send_code: "إرسال الرمز",
    reset_code_title: "تأكيد الرمز",
    reset_code_sent_to: "تم إرسال رمز إلى",
    reset_code_label: "رمز التحقق (6 أرقام)",
    reset_verify_button: "تأكيد الرمز",
    reset_code_invalid: "الرمز غير صحيح أو منتهي الصلاحية",
    reset_change_email: "تغيير البريد الإلكتروني",
    reset_resend_code: "إعادة إرسال الرمز",
    reset_password_title: "كلمة مرور جديدة",
    reset_password_subtitle: "اختر كلمة مرور جديدة لحسابك",
    reset_change_password_button: "تغيير كلمة المرور",
    reset_failed: "فشل في إعادة تعيين كلمة المرور",
    reset_success_title: "تم تغيير كلمة المرور!",
    reset_success_desc: "تم تعديل كلمة المرور الخاصة بك بنجاح.",
    reset_redirecting: "جارٍ التحويل إلى صفحة تسجيل الدخول...",
  },

  // ==========================================
  // LAYOUT - PAGE TITLES
  // ==========================================
  layout: {
    dashboard: {
      page_title: "لوحة التحكم",
    },
    auth: {
      page_title: "تسجيل الدخول",
    },
    web: {
      page_title: "التسويق بالعمولة",
    },
  },

  // ==========================================
  // YOUCAN BANNER
  // ==========================================
  youcan: {
    new_badge: "ميزة جديدة — نتائج أفضل!",
    title_prefix: "اربط متجرك مع",
    title_highlight: "YouCan",
    title_suffix: "بسهولة في لوحتك!",
    description: "يمكنك الآن ربط متجرك على YouCan، ونقل منتجاتك بكل سهولة، والاستفادة من استقبال الطلبات بشكل تلقائي دون أي تدخل يدوي.",
    synced_orders: "طلب مزامن",
    error_reduction: "تقليل الأخطاء اليدوية",
    continuous_sync: "مزامنة مستمرة 100%",
    cta: "ابدأ الآن ←",
  },

  // ==========================================
  // MODALS
  // ==========================================
  modals: {
    livreur_selection: {
      title: "اختيار موصل",
      orders_selected: "{count} طلب (طلبات) محددة",
      no_livreur: "لا يوجد موصل متاح",
      cancel: "إلغاء",
      assigning: "جارٍ التعيين...",
      confirm_assign: "تأكيد التعيين",
    },
    ozon_invoice: {
      title: "استيراد فاتورة Ozon",
      select_pdf: "يرجى اختيار ملف PDF صالح.",
      reading_pdf: "جارٍ قراءة PDF...",
      drop_pdf: "اسحب فاتورة PDF الخاصة بك هنا",
      click_to_select: "أو انقر للاختيار",
      no_orders_selected: "لم يتم تحديد أي طلب.",
      updated: "تم التحديث",
      error: "خطأ",
      updated_success: "{count} طلب (طلبات) تم تحديثها بنجاح.",
      partial_success: "{ok} نجاح، {fail} فشل.",
      status_delivered: "مسلم",
      status_refused: "مرفوض",
      total_colis: "إجمالي الطرود :",
      delivered: "مسلم :",
      refused: "مرفوض :",
      selected: "محدد :",
      table_code: "الرمز",
      table_phone: "الهاتف",
      table_city: "المدينة",
      table_status: "الحالة",
      table_crbt: "CRBT",
      table_fees: "الرسوم",
      table_net: "الصافي",
      select_all_delivered: "تحديد كل المسلمة",
      info_only_delivered: "فقط الطلبات المسلمة يمكن تحديدها. سيتم تحديث الحالة إلى مسلم (مدفوع).",
      updating_orders: "جارٍ تحديث الطلبات...",
      please_wait: "يرجى الانتظار",
      success_count: "✓ نجاح :",
      fail_count: "✗ فشل :",
      result_code: "الرمز",
      result_city: "المدينة",
      result_status: "النتيجة",
      result_message: "الرسالة",
      result_updated: "✓ تم التحديث",
      result_failed: "✗ فشل",
      close: "إغلاق",
      change_file: "← تغيير الملف",
      import_count: "استيراد {count} طلب",
      new_import: "استيراد جديد",
    },
  },

  // ==========================================
  // PRINT - DELIVERY TICKET
  // ==========================================
  print: {
    delivery_ticket: {
      boutique: "المتجر: {store}",
      contact_info: "{name} - لمزيد من المعلومات اتصل: {phone}",
      hub: "المركز",
      open: "فتح",
      change: "تغيير",
      product_header: "المنتج",
      qty_header: "الكمية",
      total: "الإجمالي: {total} درهم",
      id_internal: "المعرف الداخلي:",
      comment: "تعليق:",
      send_date: "تاريخ الإرسال: {date}",
    },
  },

  // ==========================================
  // FOOTER
  // ==========================================
  footer: {
    description: "أكثر منصات التسويق بالعمولة موثوقية في العالم. تواصل مع العلامات التجارية المتميزة وحقق أقصى إمكاناتك في الأرباح.",
    platform: "المنصة",
    platform_home: "الرئيسية",
    platform_about: "من نحن",
    platform_contact: "اتصل بنا",
    platform_affiliate: "برنامج الشركاء",
    resources: "الموارد",
    resources_help: "مركز المساعدة",
    resources_blog: "المدونة",
    resources_tutorials: "الدروس",
    resources_case_studies: "دراسات الحالة",
    resources_api: "وثائق API",
    legal: "القانوني",
    legal_privacy: "سياسة الخصوصية",
    legal_terms: "شروط الخدمة",
    legal_cookies: "سياسة الكوكيز",
    legal_gdpr: "الامتثال للائحة GDPR",
    legal_affiliate_disclosure: "إفصاح الشركاء",
    bottom_rights: "© {year} {name} - جميع الحقوق محفوظة",
    bottom_privacy: "الخصوصية",
    bottom_terms: "الشروط",
    bottom_cookies: "الكوكيز",
    bottom_sitemap: "خريطة الموقع",
  },

  // ==========================================
  // PUBLIC HEADER
  // ==========================================
  public_header: {
    home: "الرئيسية",
    about: "من نحن",
    how_it_works: "كيف تعمل منصتنا؟",
    contact: "اتصل بنا",
    privacy: "سياسة الخصوصية",
    products: "المنتجات",
    login: "تسجيل الدخول",
  },

  // ==========================================
  // HOME PRODUCTS
  // ==========================================
  home: {
    products: {
      loading: "جارٍ التحميل...",
      no_products: "لا توجد منتجات متاحة",
      commission: "عمولة {commission}MAD",
      earn: "ارباح: {earnings}د.م",
      promote_now: "روج الآن",
    },
  },
  // ==========================================
  // CORS COMPONENTS
  // ==========================================
  cors_change_password: {
    account_security: 'أمان الحساب',
    cancel: 'إلغاء',
    change_password: 'تغيير كلمة المرور',
    confirm_password: 'تأكيد كلمة المرور الجديدة',
    confirm_placeholder: 'قم بتأكيد كلمة المرور الجديدة',
    enter_password: 'أدخل كلمة المرور الجديدة',
    new_password: 'كلمة المرور الجديدة',
    password_protected: 'كلمة المرور الخاصة بك محمية ومشفرة',
    password_too_short: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    passwords_mismatch: 'كلمتا المرور غير متطابقتين',
    secure_password: 'كلمة مرور آمنة',
    update: 'تحديث',
    update_failed: 'فشل تحديث كلمة المرور',
    update_success: 'تم تحديث كلمة المرور بنجاح!',
    updating: 'جارٍ التحديث...',
  },
  cors_change_status: {
    add_details: 'إضافة تفاصيل',
    back: 'رجوع',
    cancellation: 'إلغاء',
    cancel_desc: 'إلغاء الطلب مع ذكر السبب',
    cancelled: 'ملغي',
    change_status: 'تغيير الحالة',
    comment: 'تعليق (اختياري)',
    confirm_action: 'تأكيد: {action}',
    confirm_desc: 'تأكيد الطلب',
    confirmed: 'مؤكد',
    custom_reason: 'سبب مخصص',
    describe_cancel_reason: 'صف سبب الإلغاء',
    describe_postpone_reason: 'صف سبب التأجيل',
    loading: 'جارٍ التحميل...',
    order: 'طلب',
    optional: 'اختياري',
    perfect: 'ممتاز!',
    postpone: 'تأجيل',
    postpone_date: 'تاريخ التأجيل',
    postpone_desc: 'تأجيل الطلب',
    postpone_reason: 'سبب التأجيل',
    postponed: 'مؤجل',
    reason: 'السبب',
    reason_no_answer_1: 'المكالمة الأولى بدون رد',
    reason_no_answer_2: 'المكالمة الثانية بدون رد',
    reason_no_answer_3: 'المكالمة الثالثة بدون رد',
    reason_not_interested: 'غير مهتم',
    reason_other: 'أخرى',
    reason_retry_later: 'إعادة الاتصال لاحقاً',
    reason_traveling: 'في سفر',
    reason_unreachable: 'لا يمكن الوصول إليه',
    reason_voicemail: 'البريد الصوتي',
    reason_wrong_number: 'رقم خاطئ',
    select_reason: 'اختر سببًا',
    status_updated: 'تم تحديث الحالة بنجاح: {action}',
    success_with_action: 'تمت العملية بنجاح: {action}',
    update_error: 'خطأ في التحديث',
    updated: 'تم التحديث',
  },
  cors_chat: {
    admin: 'مدير',
    confirmator: 'مؤكد',
    no_messages: 'لا توجد رسائل حالياً.',
    order: 'طلب',
    seller: 'بائع',
    system: 'النظام',
    type_message: 'اكتب رسالة...',
  },
  cors_confirmator_export: {
    all_statuses: 'جميع الحالات',
    cancel: 'إلغاء',
    cancelled: 'ملغي',
    download_success: 'تم تحميل ملف Excel بنجاح',
    end_date: 'تاريخ النهاية',
    error_occurred: 'حدث خطأ',
    export: 'تصدير',
    export_count: 'فاتورة سيتم تصديرها',
    fetch_failed: 'فشل في جلب الفواتير',
    loading: 'جارٍ التحميل...',
    paid: 'مدفوع',
    pending: 'قيد الانتظار',
    sheet_name: 'فواتير المؤكد',
    start_date: 'تاريخ البداية',
    status: 'الحالة',
    title: 'تصدير إلى Excel',
  },
  cors_confirmator_invoice: {
    banking_info: 'معلومات البنك والأسعار',
    cancelled: 'ملغي',
    confirm_price: 'سعر التأكيد',
    confirmator_info: 'معلومات المؤكد',
    confirmed_orders: 'الطلبات المؤكدة',
    delivery: 'التوصيل',
    footer_text: 'تم إنشاء الفاتورة تلقائياً لخدمات التأكيد.',
    generated_on: 'تم الإنشاء في',
    invoice: 'فاتورة المؤكد',
    invoice_title: 'فاتورة المؤكد',
    invoice_total: 'إجمالي الفاتورة',
    issue_date: 'تاريخ الإصدار',
    not_found: 'لم يتم العثور على فاتورة المؤكد',
    number: 'رقم',
    order: 'الطلب',
    paid: 'مدفوع',
    payment_date: 'تاريخ الدفع',
    pending_payment: 'دفع قيد الانتظار',
    products: 'المنتجات',
    rib: 'RIB',
    seller: 'البائع',
    status: 'الحالة',
    total: 'الإجمالي',
    total_amount_desc: 'المبلغ الإجمالي للفاتورة',
    total_orders: 'إجمالي عدد الطلبات',
    work_price: 'سعر العمل',
  },
  cors_confirmator_rapport: {
    address: 'العنوان',
    bank: 'البنك',
    bank_label: 'البنك',
    cancelled: 'ملغي',
    code: 'الرمز',
    commission: 'العمولة',
    confirmator_info: 'معلومات المؤكد',
    confirmed_orders: 'الطلبات المؤكدة',
    confirmed_orders_count: 'طلب (طلبات) مؤكدة',
    delivery: 'التوصيل',
    invoice_title: 'فاتورة المؤكد',
    issued_on: 'صدرت في',
    loading_invoice: 'جارٍ تحميل الفاتورة...',
    method: 'الطريقة',
    name: 'الاسم',
    no_invoice_found: 'لم يتم العثور على فاتورة',
    number: 'رقم',
    paid: 'مدفوع',
    paid_on: 'تم الدفع في',
    pending_payment: 'دفع قيد الانتظار',
    phone: 'الهاتف',
    price: 'السعر',
    print_error: 'خطأ أثناء الطباعة',
    print_invoice: 'طباعة الفاتورة',
    products: 'المنتجات',
    seller: 'البائع',
    status: 'الحالة',
    thank_you: 'شكراً لعملك في التأكيد!',
    total: 'الإجمالي',
    total_commissions: 'إجمالي العمولات',
    unknown: 'غير معروف',
  },
  cors_delete_modal: {
    cancel: 'إلغاء',
    cannot_undo: 'لا يمكن التراجع عن هذا الإجراء.',
    close_modal: 'إغلاق النافذة',
    delete: 'حذف',
  },
  cors_duplicate_orders: {
    add_blacklist: 'إضافة إلى القائمة السوداء',
    address: 'العنوان',
    affiliate: 'التابع',
    amount: 'المبلغ',
    block: 'حظر',
    block_client: 'حظر العميل',
    block_reason_placeholder: 'سبب الحظر...',
    cancel: 'إلغاء',
    client: 'العميل',
    client_blocked: 'تم حظر العميل بنجاح!',
    client_unblocked: 'تم إلغاء حظر العميل بنجاح',
    code: 'الرمز',
    date: 'التاريخ',
    error: 'خطأ',
    error_occurred: 'حدث خطأ',
    no_orders_found: 'لم يتم العثور على طلبات',
    no_products: 'لا توجد منتجات',
    order_history: 'سجل الطلبات',
    orders: 'طلب (طلبات)',
    orders_will_appear: 'ستظهر الطلبات هنا',
    phone_unavailable: 'رقم غير متاح',
    processing: 'جارٍ المعالجة...',
    products: 'المنتجات',
    reason: 'السبب',
    status: 'الحالة',
    tel: 'الهاتف',
    unblock: 'إلغاء الحظر',
    unblock_error: 'خطأ أثناء إلغاء الحظر',
  },
  cors_edit_invoice: {
    bank_transfer: 'تحويل بنكي',
    cancel: 'إلغاء',
    cancelled: 'ملغي',
    cash: 'نقداً',
    cheque: 'شيك',
    credit_card: 'بطاقة بنكية',
    paid: 'مدفوع',
    payment_method: 'طريقة الدفع',
    pending_payment: 'قيد الانتظار',
    save: 'حفظ',
    saving: 'جارٍ الحفظ...',
    select: '-- اختر --',
    status: 'الحالة',
    title: 'تعديل الفاتورة',
  },
  cors_import: {
    accepted_formats: 'الصيغ المقبولة: .xlsx, .xls',
    and_more_errors: 'و {count} خطأ (أخطاء) أخرى',
    check_docs: 'راجع الوثائق لمعرفة التنسيق المطلوب.',
    click_to_upload: 'انقر للاستيراد',
    close: 'إغلاق',
    col_client_address: 'عنوان العميل',
    col_client_city: 'مدينة العميل',
    col_client_name: 'اسم العميل',
    col_client_phone: 'هاتف العميل',
    col_comment: 'تعليق',
    col_product_id: 'معرف المنتج',
    col_product_qty: 'الكمية',
    col_selling_price: 'سعر البيع',
    col_variants: 'المتغيرات',
    created_orders: 'طلب تم إنشاؤه',
    data_preview: 'معاينة البيانات',
    errors: 'أخطاء',
    failed_orders: 'طلب فشل',
    file_process_error: 'خطأ أثناء معالجة الملف',
    file_read_error: 'خطأ أثناء قراءة الملف',
    format_required_desc: 'يجب أن يحتوي الملف على الأعمدة التالية:',
    format_required_title: 'التنسيق المطلوب',
    import: 'استيراد',
    import_completed: 'اكتمل الاستيراد',
    import_error: 'خطأ أثناء الاستيراد',
    import_success: 'تم استيراد {count} طلب (طلبات) بنجاح!',
    importing: 'جارٍ الاستيراد...',
    note_text: 'ملاحظة: تأكد من أن ملف Excel يتبع التنسيق المطلوب.',
    select_excel: 'يرجى اختيار ملف Excel صالح.',
    select_file: 'يرجى اختيار ملف.',
    select_file_label: 'اختيار ملف Excel',
    showing_first_5: 'عرض أول 5 صفوف',
    subtitle: 'استيراد الطلبات من ملف Excel',
    title: 'استيراد الطلبات',
    total_lines: 'إجمالي الأسطر',
  },
  cors_invoice_modal: {
    bank: 'البنك',
    banking_info: 'معلومات بنكية',
    cancelled: 'ملغي',
    delivery: 'التوصيل',
    footer_text: 'شكراً لاستخدامك خدمتنا. هذه الفاتورة مولدة تلقائياً ولا تحتاج إلى توقيع.',
    generated_on: 'تم الإنشاء في',
    invoice: 'فاتورة',
    invoice_not_found: 'لم يتم العثور على الفاتورة',
    issue_date: 'تاريخ الإصدار',
    number: 'رقم',
    order: 'الطلب',
    order_details: 'تفاصيل الطلبات',
    paid: 'مدفوع',
    payment_date: 'تاريخ الدفع',
    pending_payment: 'دفع قيد الانتظار',
    product: 'المنتج',
    profit: 'الربح',
    quantity: 'الكمية',
    rib: 'RIB',
    seller_info: 'معلومات البائع',
    selling_price: 'سعر البيع',
    status: 'الحالة',
    total: 'الإجمالي',
    total_profit: 'إجمالي الربح',
    total_profit_desc: 'مجموع أرباح جميع الطلبات',
    unit_price: 'سعر الوحدة',
  },
  cors_livreur_invoice: {
    auto_generated: 'فاتورة مولدة تلقائياً.',
    bank_info: 'معلومات بنكية',
    cancelled: 'ملغي',
    city: 'المدينة',
    client: 'العميل',
    delivered: 'تم التوصيل',
    delivered_orders: 'الطلبات المسلمة',
    delivery_info: 'معلومات الموصل',
    delivery_rate: 'سعر التوصيل',
    fixed_delivery_rate: 'رسوم توصيل ثابتة',
    generated_on: 'تم الإنشاء في',
    invoice_heading: 'فاتورة الموصل',
    invoice_number_label: 'رقم:',
    invoice_title: 'فاتورة الموصل',
    invoice_total: 'إجمالي الفاتورة',
    issue_date: 'تاريخ الإصدار',
    na: 'غير متاح',
    not_found: 'لم يتم العثور على فاتورة الموصل',
    order: 'الطلب',
    order_total: 'إجمالي الطلب',
    orders_included: 'طلب (طلبات) مضمنة',
    paid: 'مدفوع',
    paid_on: 'تم الدفع في',
    pending_payment: 'دفع قيد الانتظار',
    rib: 'RIB',
    status: 'الحالة',
  },
  cors_livreur_report: {
    cancelled: 'ملغي',
    city: 'المدينة',
    client: 'العميل',
    code: 'الرمز',
    delivered_orders: 'الطلبات المسلمة',
    delivery_info: 'معلومات الموصل',
    delivery_rate: 'رسوم التوصيل',
    emitted_on: 'صدرت في',
    footer_thanks: 'شكراً لخدمة التوصيل!',
    invoice_title: 'فاتورة الموصل',
    loading_invoice: 'جارٍ تحميل الفاتورة...',
    method: 'الطريقة',
    name: 'الاسم',
    no_invoice: 'لم يتم العثور على فاتورة',
    order_total: 'الإجمالي',
    orders_delivered_count: 'طلب (طلبات) مسلمة',
    paid: 'مدفوع',
    paid_on: 'تم الدفع في',
    payment: 'الدفع',
    pending_payment: 'دفع قيد الانتظار',
    phone: 'الهاتف',
    print_error: 'خطأ أثناء الطباعة',
    print_invoice: 'طباعة الفاتورة',
    total_to_pay: 'الإجمالي المستحق',
    unknown: 'غير معروف',
    weight_vol: 'الوزن/الحجم',
  },
  cors_map: {
    casablanca: 'الدار البيضاء',
    loading_route: 'جارٍ تحميل المسار...',
    route_title: 'المسار',
  },
  cors_payment_method: {
    bank_transfer: 'تحويل بنكي',
    cancel: 'إلغاء',
    cash: 'نقداً',
    cheque: 'شيك',
    choose_method: 'اختيار طريقة الدفع',
    confirm_payment: 'تأكيد الدفع',
    credit_card: 'بطاقة ائتمان',
    processing: 'جارٍ المعالجة...',
    select_method: 'يرجى اختيار طريقة دفع',
    select_prompt: 'اختر طريقة الدفع المستخدمة لتسديد هذه الفاتورة:',
  },
  cors_permissions: {
    add_category: 'إضافة فئة',
    add_product: 'إضافة منتج',
    add_stock: 'إضافة مخزون',
    add_variant: 'إضافة متغير',
    confirm_compte: 'تأكيد الحسابات',
    confirm_orders: 'تأكيد الطلبات',
    delete_category: 'حذف فئة',
    delete_product: 'حذف منتج',
    delete_stock: 'حذف مخزون',
    delete_variant: 'حذف متغير',
    edit_config: 'تعديل الإعدادات',
    edit_users: 'تعديل المستخدمين',
    no_permissions: 'لا توجد صلاحيات ممنوحة',
    title: 'الصلاحيات والوصول',
  },
  cors_saller_export: {
    cancel: 'إلغاء',
    create_error: 'خطأ أثناء إنشاء ملف Excel',
    download_success: 'تم تحميل ملف Excel بنجاح!',
    fetch_error: 'خطأ أثناء جلب البيانات',
    invoices_count: 'فاتورة',
    invoices_sheet: 'الفواتير',
    no_data: 'لا توجد بيانات للتصدير لـ',
    no_invoices: 'لا توجد فواتير لـ',
    select_bank: 'اختيار البنك للتصدير',
  },
  cors_saller_rapport: {
    address: 'العنوان',
    bank: 'البنك',
    bank_label: 'البنك',
    cancelled: 'ملغي',
    delivery: 'التوصيل',
    invoice: 'الفاتورة',
    issued_on: 'صدرت في',
    loading_invoice: 'جارٍ تحميل الفاتورة...',
    method: 'الطريقة',
    no_invoice_found: 'لم يتم العثور على فاتورة',
    number: 'رقم',
    order: 'الطلب',
    order_details: 'تفاصيل الطلبات',
    orders_count: 'طلب (طلبات)',
    paid: 'مدفوع',
    paid_on: 'تم الدفع في',
    pending_payment: 'دفع قيد الانتظار',
    phone: 'الهاتف',
    print_error: 'خطأ أثناء الطباعة',
    print_invoice: 'طباعة الفاتورة',
    product: 'المنتج',
    profit: 'الربح',
    qty: 'الكمية',
    seller_info: 'معلومات البائع',
    selling_price: 'سعر البيع',
    status: 'الحالة',
    thank_you: 'شكراً لثقتكم!',
    total: 'الإجمالي',
    total_profit: 'إجمالي ربح الفاتورة',
    unit_price: 'سعر الوحدة',
    unknown: 'غير معروف',
  },
  cors_select_sallers: {
    cancel: 'إلغاء',
    description: 'اختر البائعين الذين يمكن لهذا المؤكد العمل معهم:',
    edit_sellers: 'تعديل البائعين',
    no_sellers_found: 'لم يتم العثور على بائعين',
    no_sellers_selected: 'لم يتم اختيار أي بائع',
    save: 'حفظ',
    search_placeholder: 'بحث واختيار البائعين...',
    title: 'بائعي هذا المؤكد',
    update_error: 'خطأ في تحديث المؤكد',
    update_success: 'تم تحديث المؤكد بنجاح!',
    updating: 'جارٍ التحديث...',
  },
  cors_status_history: {
    comment: 'تعليق',
    current_status: 'الحالة الحالية',
    last_update: 'آخر تحديث',
    postponed_to: 'مؤجل إلى',
    reason: 'السبب',
    status_count: 'تغيير (تغييرات) الحالة',
    subtitle: 'سجل تغييرات الحالة لـ',
    title: 'سجل الحالات',
  },
  cors_status_livreur: {
    add_details: 'إضافة تفاصيل',
    back: 'رجوع',
    back_delivery: 'إرجاع التوصيل',
    back_delivery_desc: 'تسجيل كإرجاع توصيل',
    back_delivery_success: ' تم تسجيل إرجاع التوصيل بنجاح',
    cancel_desc: 'إلغاء التوصيل مع ذكر السبب',
    cancelled: 'ملغي',
    change_status: 'تغيير الحالة',
    comment: 'تعليق (اختياري)',
    custom_reason: 'سبب مخصص',
    delivered: 'تم التوصيل',
    delivered_success: ' تم التوصيل بنجاح',
    describe_reason: 'صف السبب',
    loading: 'جارٍ التحميل...',
    mark_delivered: 'تسليم',
    no_answer: 'لا يوجد رد',
    no_answer_desc: 'العميل لم يرد',
    no_answer_success: ' تم تسجيل لا رد بنجاح',
    order: 'الطلب',
    perfect: 'ممتاز!',
    postpone_date: 'تاريخ التأجيل',
    postpone_desc: 'تأجيل التوصيل',
    postpone_reason: 'سبب التأجيل',
    postponed: 'مؤجل',
    reason_client_refused_package: 'العميل يرفض الطرد',
    reason_duplicate_order: 'طلب مكرر',
    reason_no_answer: 'لا يوجد رد',
    reason_not_interested: 'غير مهتم',
    reason_other: 'أخرى',
    reason_out_of_zone: 'خارج المنطقة',
    reason_traveling: 'في سفر',
    reason_unreachable: 'لا يمكن الوصول إليه',
    reason_wrong_number: 'رقم خاطئ',
    reason_wrong_price: 'سعر خاطئ',
    reason_wrong_product: 'منتج خاطئ',
    refused: 'مرفوض',
    refused_desc: 'العميل رفض الطلب',
    select_reason: 'اختر سببًا',
    status_success: 'تم تحديث الحالة بنجاح: {status}',
    update_error: 'خطأ في التحديث',
  },
  cors_saller_bank: {
    other: 'أخرى',
  },
  cors_status_map: {
    nouveau: 'جديد',
    confirme: 'مؤكد',
    paid: 'تم الدفع',
    reporte: 'تأجيل التأكيد',
    nonconfirme: 'غير مؤكد',
    indelivery: 'قيد التوصيل',
    livre: 'تم التسليم',
    livre_paye: 'تم التسليم (مدفوع)',
    pending_payment: 'دفع معلق',
    retour: 'مرتجع',
    refuse: 'مرفوض',
    refuse_par_livreur: 'مرفوض من الموصل',
    annule: 'ملغي',
    duplicated: 'مكرر',
    attente_de_ramassage: 'انتظار الاستلام',
    ramasse: 'تم الاستلام',
    expedie: 'تم الشحن',
    pret_pour_expedition: 'جاهز للشحن',
    mise_en_distribution: 'وضع في التوزيع',
    programme: 'مجدول',
    interesse: 'مهتم',
    recu_par_livreur: 'تم الاستلام من الموصل',
    envoye_a_l_agence: 'أُرسل إلى الوكالة',
    recu_en_agence_de_livraison: 'تم الاستلام في وكالة التوصيل',
    reporte_par_livreur: 'مؤجل من الموصل',
    en_voyage: 'في الطريق',
    en_cours_de_livraison: 'جاري التوصيل',
    pre_ramasse: 'ما قبل الاستلام',
    en_cours_de_preparation: 'جاري التجهيز',
    en_livraison: 'قيد التوصيل',
    en_transport: 'في النقل',
    client_disponible_pour_livraison: 'العميل متاح للتوصيل',
    recu_sur_agence_casa: 'تم الاستلام في وكالة الدار البيضاء',
    demande_de_retour: 'طلب إرجاع',
    retour_client_expedie: 'إرجاع العميل تم شحنه',
    retour_vers_agence_casa: 'إرجاع إلى وكالة الدار البيضاء',
    retour_vers_agence_casa_alt: 'إرجاع إلى وكالة الدار البيضاء',
    retour_recu_agence_casa: 'إرجاع مستلم وكالة الدار البيضاء',
    retour_recu_agence_casa_alt: 'إرجاع مستلم وكالة الدار البيضاء',
    retour_recu_par_agence: 'إرجاع مستلم من الوكالة',
    retour_recu_par_livreur: 'إرجاع مستلم من الموصل',
    retour_client_recu: 'إرجاع العميل مستلم',
    retour_pret_pour_expedition: 'إرجاع جاهز للشحن',
    a_retourner_vers_agence_principal_casa: 'لإرجاعه إلى وكالة الدار البيضاء الرئيسية',
    retour_expedie: 'تم شحن الإرجاع',
    retour_recu_par_city: 'إرجاع مستلم من {{city}}',
    colis_pret_pour_le_retour: 'طرد جاهز للإرجاع',
    retour_en_cours_de_la_livraison: 'إرجاع قيد التوصيل',
    retour_debarrasse: 'تم التخلص من الإرجاع',
    retour_en_stock: 'إرجاع في المخزون',
    retour_recu: 'تم استلام الإرجاع',
    retour_client_recu_alt: 'إرجاع العميل مستلم',
    sans_adresse: 'بدون عنوان',
    injoignable: 'لا يمكن الاتصال',
    boite_vocal: 'بريد صوتي',
    pas_de_reponse: 'لا يوجد رد',
    pas_de_reponse_2_fois: 'لا رد مرتين',
    pas_de_reponse_2_fois_alt: 'لا رد مرتين',
    pas_de_reponse_3_fois: 'لا رد 3 مرات',
    pas_de_reponse_3_fois_alt: 'لا رد 3 مرات',
    pas_de_reponse_j_2: 'لا رد J+2',
    pas_de_reponse_j_3: 'لا رد J+3',
    pas_reponse_deplacement_j_2: 'لا رد + انتقال J+2',
    pas_reponse_deplacement_j_3: 'لا رد + انتقال J+3',
    pas_reponse_deplacement: 'لا رد + انتقال',
    pas_de_reponse_suivi: 'لا رد (متابعة)',
    injoignable_suivi: 'لا يمكن الاتصال (متابعة)',
    reporte_suivi: 'مؤجل (متابعة)',
    boite_vocal_suivi: 'بريد صوتي (متابعة)',
    faux_destination: 'عنوان خاطئ',
    hors_zone: 'خارج المنطقة',
    hors_zone_alt: 'خارج المنطقة',
    pas_interesse: 'غير مهتم',
    produit_endommage: 'منتج تالف',
    perdu: 'مفقود',
    demande_de_suivi: 'طلب متابعة',
    annule_suivi: 'ملغي (متابعة)',
    annule_par_livreur: 'ملغي من الموصل',
    changement_adresse: 'تغيير العنوان',
    changement_d_adresse: 'تغيير العنوان',
    recu_par_erreur: 'مستلم بالخطأ',
    non_recu: 'لم يتم الاستلام',
    colis_archive: 'طرد مؤرشف',
    reportee_indefiniment: 'مؤجل لأجل غير مسمى',
    reporte_aujourd_hui: 'مؤجل اليوم',
    erreur_numero: 'خطأ في الرقم',
    rembourse: 'تم الاسترداد',
  },

  // ==========================================
  // WEBSITES - Nextlead & Topseller pages
  // ==========================================
  websites: {
    nextlead: {
      home: {
        badge_platform_rank: "المنصة رقم 1 للتسويق بالعمولة في الوطن العربي",
        hero_title_1: "اربح أكثر مع شركاء",
        hero_title_2: "التسويق المميزين",
        hero_desc: "انضم إلى أكثر من {count} مسوق عربي يحققون أرباحاً تصل إلى {amount} شهرياً من خلال ترويج منتجات عالمية بعمولات تصل إلى 80%",
        cta_start_earning: "ابدأ الربح المجاني الآن",
        cta_watch_demo: "شاهد العرض التوضيحي",
        stat_marketers: "مسوق نشط",
        stat_profits_distributed: "أرباح مُوزعة",
        stat_client_rating: "تقييم العملاء",
        why_choose_us: "لماذا نختار",
        why_choose_desc: "نوفر لك الحلول الشاملة لبناء أعمال تسويق بالعمولة ناجحة ومربحة",
        feat_commission_title: "عمولات تصل إلى 80%",
        feat_commission_desc: "أعلى معدلات عمولة في السوق مع دفع أسبوعي",
        feat_protection_title: "حماية متكاملة",
        feat_protection_desc: "نظام تتبع متقدم لمنع الاحتيال وتأكيد العمليات",
        feat_instant_title: "تحويلات فورية",
        feat_instant_desc: "سحب أرباحك مباشرة إلى حسابك البنكي خلال 24 ساعة",
        feat_analytics_title: "تحليلات ذكية",
        feat_analytics_desc: "تقارير أداء تفصيلية مع تنبؤات بالذكاء الاصطناعي",
        feat_support_title: "مجتمع الدعم",
        feat_support_desc: "انضم إلى مجتمع من المسوقين الناجحين والخبراء",
        feat_247_title: "دعم 24/7",
        feat_247_desc: "فريق دعم فني متاح على مدار الساعة طوال الأسبوع",
        how_it_works: "كيف تعمل المنصة؟",
        how_it_works_subtitle: "خطوات بسيطة لتحقيق الأرباح",
        how_it_works_desc: "6 خطوات فقط تفصلك عن أول عملية بيع وأرباحك الأولى",
        step1_title: "التسجيل المجاني",
        step1_desc: "أنشئ حسابك مجاناً في دقائق معدودة",
        step2_title: "اختر المنتجات",
        step2_desc: "تصفح آلاف المنتجات عالية الربحية",
        step3_title: "روّج واربح",
        step3_desc: "أنشئ روابط تسويقية وابدأ بجني الأرباح",
        step4_title: "تتبع المبيعات",
        step4_desc: "تابع أداءك في الوقت الحقيقي مع إحصائيات دقيقة",
        step5_title: "تأكيد الطلبات",
        step5_desc: "نحن نتولى تأكيد الطلبات والشحن والتوصيل",
        step6_title: "سحب الأرباح",
        step6_desc: "اسحب أرباحك أسبوعياً بكل سهولة وآمان",
        browse_by_category: "تصفح المنتجات حسب",
        browse_by_category_subtitle: "التصنيفات المميزة",
        browse_by_category_desc: "اختر من بين آلاف المنتجات في مختلف التصنيفات",
        cat_electronics: "الإلكترونيات",
        cat_beauty: "الجمال والعناية",
        cat_health: "الصحة والرياضة",
        cat_home: "المنزل والمطبخ",
        cat_fashion: "الموضة والإكسسوارات",
        cat_education: "التعليم والكتب",
        integrations_title: "تكامل كامل مع",
        integrations_subtitle: "أشهر المنصات العالمية",
        integrations_desc: "نوفر تكاملاً سلساً مع كل منصات التجارة الإلكترونية وأدوات التسويق",
        integration_status_active: "Active",
        integration_status_soon: "Soon",
        integration_youcan: "تكامل كامل مع منصة يوكان للتجارة الإلكترونية",
        integration_shopify: "ربط مباشر مع متاجر شوبيفاي",
        integration_woocommerce: "تكامل مع ووكوميرس ومتاجر ووردبريس",
        integration_sheets: "تكامل مع أدوات جوجل وتحليلاتها",
        integration_custom_api: "واجهات برمجة مخصصة لأي نظام",
        custom_platform_title: "هل لديك نظام خاص أو منصة مخصصة؟",
        custom_platform_desc: "نوفر واجهات برمجة (API) متكاملة للتكامل مع أي نظام خاص بك",
        custom_platform_cta: "اكتشف خيارات التكامل المتقدمة",
        products_title: "منتجاتنا",
        products_subtitle: "الأعلى ربحية وتحويلاً",
        products_desc: "اختر من بين آلاف المنتجات عالية التحويل بمعدلات ربحية مميزة",
        product_high_conversion: "أعلى معدلات تحويل",
        product_commission_80: "عمولات تصل إلى 80%",
        product_fast_shipping: "شحن سريع عالمي",
        featured_products: "منتجات مميزة",
        featured_products_desc: "منتجات حاصلة على أعلى تقييم من المسوقين",
        browse_all_products: "استعرض جميع المنتجات ({count})",
        testimonials_title: "ماذا يقول",
        testimonials_subtitle: "مسوقونا عنّا؟",
        testimonials_desc: "انضم إلى آلاف المسوقين الناجحين الذين يثقون بنا",
        testimonial1_name: "أحمد محمد",
        testimonial1_role: "مسوق على إنستجرام",
        testimonial1_content: "بدأت مع المنصة منذ 6 أشهر وحققت أرباحاً تجاوزت 25,000 ريال. المنصة غيرت حياتي المالية تماماً.",
        testimonial2_name: "سارة العتيبي",
        testimonial2_role: "مدونة في مجال الجمال",
        testimonial2_content: "أسهل منصة تعاملت معها. التحويلات سريعة والدعم ممتاز. أنصح كل من يريد بدء التسويق بالعمولة.",
        testimonial3_name: "خالد الزهراني",
        testimonial3_role: "صاحب متجر إلكتروني",
        testimonial3_content: "وصلت منتجاتي لآلاف العملاء الجدد من خلال مسوقي المنصة. زادت مبيعاتي بنسبة 300% في 3 أشهر.",
        choose_model: "اختر نموذجك",
        choose_model_subtitle: "وابدأ الربح اليوم",
        choose_model_desc: "سواء كنت مسوقاً أو بائعاً، لدينا الحل المثالي لاحتياجاتك",
        model_affiliate: "مسوق بالعمولة",
        model_affiliate_badge: "مثالي للمسوقين والمؤثرين والمدونين",
        model_affiliate_item1: "اربح حتى 80% عمولة على كل عملية بيع",
        model_affiliate_item2: "الوصول إلى أكثر من 10,000 منتج",
        model_affiliate_item3: "أدوات تتبع وتحليل متقدمة",
        model_affiliate_item4: "دعم فني متخصص 24/7",
        model_affiliate_item5: "سحب الأرباح أسبوعياً",
        model_affiliate_cta: "سجّل كمسوق مجاناً",
        model_vendor: "بائع/تاجر",
        model_vendor_badge: "مثالي للعلامات التجارية والشركات والمتاجر",
        model_vendor_item1: "وصل منتجاتك إلى آلاف المسوقين",
        model_vendor_item2: "إدارة طلبات وشحن مركزية",
        model_vendor_item3: "تكامل مع جميع المنصات",
        model_vendor_item4: "تقارير مبيعات مفصلة",
        model_vendor_item5: "حماية من الاحتيال",
        model_vendor_cta: "سجّل كبائع مجاناً",
        cta_final_badge: "المنصة الحاصلة على جائزة أفضل منصة تسويق 2024",
        cta_final_title: "ابدأ رحلتك نحو",
        cta_final_subtitle: "الاستقلال المالي اليوم",
        cta_final_desc: "انضم إلى مجتمع المسوقين الناجحين الذين حوّلوا شغفهم إلى دخل مستدام. لا تحتاج إلى خبرة سابقة - سنعلمك كل شيء من الصفر.",
        cta_final_register: "سجل حسابك المجاني الآن",
        cta_final_consult: "احجز استشارة مجانية مع خبير",
        cta_final_fees: "بدون رسوم إطلاقاً",
        cta_final_no_fees: "بدون رسوم إطلاقاً",
        cta_final_guarantee: "ضمان الأرباح",
        cta_final_support: "دعم عربي متخصص",
      },
      about: {
        hero_badge: "منذ 2019، نحن نغير مفهوم التسويق بالعمولة",
        hero_title_1: "قصة نجاح",
        hero_title_2: "غيرت حياة الآلاف",
        hero_desc: "انطلقنا برؤية واضحة: خلق منصة توفر شراكات حقيقية ومربحة بين المسوقين المبدعين والعلامات التجارية المتميزة. اليوم، نحن فخورون بأننا أصبحنا المنصة الرائدة في الوطن العربي للتسويق بالعمولة.",
        cta_join: "انضم إلى مجتمعنا",
        cta_contact: "تواصل مع فريقنا",
        story_badge: "رؤيتنا ورسالتنا",
        story_title: "لماذا نختلف عن الآخرين؟",
        story_p1: "بدأنا رحلتنا في 2019 بعد ملاحظة فجوة كبيرة في سوق التسويق بالعمولة. رأينا مسوقين موهوبين يكافحون مع عمولات منخفضة، ومدفوعات متأخرة، وعدم وجود شفافية.",
        story_p2: "في الجانب الآخر، كانت العلامات التجارية تواجه صعوبة في إيجاد شركاء موثوقين يروجون لمنتجاتهم بصدق واحترافية.",
        story_p3: "قررنا تغيير هذه الصورة من خلال بناء منصة تضع مصلحة الشركاء في المقام الأول. اليوم، نحن نربط أكثر من {count} مسوق مع أفضل العلامات التجارية، ونسهل ملايين العمولات سنوياً مع الحفاظ على أعلى معايير الجودة والشفافية.",
        story_check1: "عمولات تصل إلى 80%",
        story_check2: "دفعات أسبوعية",
        story_check3: "دعم فني 24/7",
        story_check4: "منتجات مضمونة الجودة",
        impact_title: "تأثيرنا بالأرقام",
        impact_subtitle: "نجاحات نفتخر بها",
        impact_desc: "أرقام حقيقية تعكس ثقة مجتمعنا ونجاح شراكاتنا",
        stat_marketers: "مسوق نشط",
        stat_marketers_desc: "ينضم إلينا مسوق جديد كل ساعة",
        stat_profits: "أرباح موزعة",
        stat_profits_desc: "عمولات دفعناها لشركائنا",
        stat_countries: "دولة",
        stat_countries_desc: "انتشار عالمي في 5 قارات",
        stat_rating: "تقييم العملاء",
        stat_rating_desc: "بناءً على 15,000+ تقييم",
        stat_products: "منتج مميز",
        stat_products_desc: "من أفضل العلامات التجارية",
        stat_support: "دعم فني",
        stat_support_desc: "دعم متواصل على مدار الساعة",
        values_title: "قيمنا الأساسية",
        values_subtitle: "التي تقودنا يومياً",
        values_desc: "هذه المبادئ هي التي تجعل منصتنا مختلفة وتضمن نجاح شراكاتنا",
        value1_title: "النزاهة والشفافية",
        value1_desc: "نؤمن بأن النزاهة هي أساس كل شراكة ناجحة",
        value2_title: "نجاح الشركاء أولاً",
        value2_desc: "نجاحنا يقاس بنجاح شركائنا من المسوقين والبائعين",
        value3_title: "الابتكار المستمر",
        value3_desc: "نطور أدوات مبتكرة لتسهيل عملك وزيادة أرباحك",
        value4_title: "الحماية والأمان",
        value4_desc: "نحمي أرباحك وبياناتك بأنظمة أمنية متطورة",
        timeline_title: "رحلة النجاح",
        timeline_subtitle: "من البداية إلى القمة",
        timeline_desc: "محطات مهمة في رحلة بناء المنصة الرائدة في التسويق بالعمولة",
        milestone1_year: "2019",
        milestone1_title: "تأسيس الشركة",
        milestone1_desc: "انطلاقتنا برؤية تغيير مفهوم التسويق بالعمولة",
        milestone2_year: "2020",
        milestone2_title: "أول 1000 مسوق",
        milestone2_desc: "تخطينا حاجز 1000 مسوق نشط في أقل من سنة",
        milestone3_year: "2021",
        milestone3_title: "توسعة الفريق",
        milestone3_desc: "توسع فريقنا إلى 50 موظفاً ومستشاراً",
        milestone4_year: "2022",
        milestone4_title: "منصة متكاملة",
        milestone4_desc: "إطلاق المنصة الشاملة بإدارة كاملة للعمليات",
        milestone5_year: "2023",
        milestone5_title: "عالمية المنصة",
        milestone5_desc: "وصولنا إلى 50 دولة حول العالم",
        milestone6_year: "2024",
        milestone6_title: "الجوائز والتكريم",
        milestone6_desc: "فوزنا بجائزة أفضل منصة تسويق في المنطقة",
        team_badge: "فريق القيادة",
        team_title: "العقول المبدعة",
        team_subtitle: "وراء نجاحك",
        team_desc: "فريق من الخبراء والمتحمسين يعملون ليل نهار لضمان نجاحك",
        team_member1_name: "أحمد الخالد",
        team_member1_title: "المؤسس والرئيس التنفيذي",
        team_member1_desc: "خبرة 15+ سنة في التسويق الرقمي، أسس 3 شركات ناشحة",
        team_member2_name: "سارة العتيبي",
        team_member2_title: "رئيسة قسم التكنولوجيا",
        team_member2_desc: "مهندسة برمجيات مع خبرة 12+ سنة في تطوير المنصات",
        team_member3_name: "محمد القحطاني",
        team_member3_title: "رئيس قسم التسويق",
        team_member3_desc: "خبير تسويق رقمي مع 10+ سنوات في بناء العلامات التجارية",
        team_member4_name: "فاطمة الزهراني",
        team_member4_title: "رئيسة قسم العمليات",
        team_member4_desc: "متخصصة في إدارة العمليات مع خبرة 8+ سنوات",
        team_cta_desc: "نؤمن بأن نجاحك هو نجاحنا. لذلك، نعمل كل يوم على تطوير أدوات وخدمات تساعدك على تحقيق أقصى استفادة من قدراتك.",
        team_cta: "انضم إلى فريقنا",
        cta_badge: "كن جزءاً من مستقبل التسويق",
        cta_title: "مستعد لبدء رحلتك معنا؟",
        cta_subtitle: "انضم إلى مجتمع الناجحين",
        cta_desc: "سواء كنت مسوقاً مبتدئاً أو محترفاً، أو تمتلك علامة تجارية تبحث عن شركاء موثوقين، فإننا نضمن لك تجربة استثنائية مع أعلى معدلات ربحية ودعم متواصل.",
        cta_start: "ابدأ الربح مجاناً",
        cta_consult: "تواصل مع مستشار",
        years_excellence: "سنوات من التميز",
        years_excellence_desc: "في قيادة صناعة التسويق",
      },
      contact: {
        hero_badge: "دعم سريع وفعال 24/7",
        hero_title: "نحن هنا لمساعدتك",
        hero_subtitle: "في كل خطوة",
        hero_desc: "فريق الدعم لدينا متاح على مدار الساعة للإجابة على استفساراتك وحل مشاكلك.",
        cta_call: "اتصل بنا الآن",
        cta_chat: "ابدا محادثة",
        section_title: "تواصل معنا",
        section_subtitle: "بالطريقة المناسبة",
        section_desc: "اختر الطريقة المناسبة للتواصل مع فريق الدعم",
        method_phone: "الاتصال الهاتفي",
        method_phone_desc: "متاح من الاثنين إلى السبت 9 ص - 6 م",
        method_email: "البريد الإلكتروني",
        method_email_desc: "رد خلال ساعتين",
        method_chat: "الدردشة الحية",
        method_chat_desc: "متاح على مدار الساعة",
        method_office: "المكتب الرئيسي",
        method_office_desc: "زيارة المكتب بموعد مسبق",
        stat_avg_time: "متوسط وقت الرد",
        stat_satisfaction: "رضا العملاء",
        stat_continuous: "دعم متواصل",
        stat_max_resolution: "أقصى وقت حل",
        form_title: "أرسل رسالتك إلينا",
        form_desc: "املأ النموذج وسيقوم فريقنا بالرد عليك في أقرب وقت",
        form_name: "الاسم الكامل *",
        form_name_placeholder: "أدخل اسمك الكامل",
        form_email: "البريد الإلكتروني *",
        form_email_placeholder: "example.domain.com",
        form_phone: "رقم الهاتف",
        form_phone_placeholder: "+212 663610738",
        form_subject_type: "نوع الاستفسار *",
        form_subject_type_placeholder: "اختر نوع الاستفسار",
        form_subject_type_technical: "دعم فني",
        form_subject_type_account: "استفسار عن الحساب",
        form_subject_type_payment: "استفسار مالي",
        form_subject_type_partnership: "شراكة تجارية",
        form_subject: "الموضوع *",
        form_subject_placeholder: "عنوان الرسالة",
        form_message: "الرسالة *",
        form_message_placeholder: "اكتب رسالتك...",
        form_newsletter: "أرغب في تلقي النشرات الإخبارية",
        form_submit: "إرسال الرسالة",
        quick_actions: "إجراءات سريعة",
        quick_action_ticket: "فتح تذكرة دعم",
        quick_action_ticket_desc: "أبلغنا عن مشكلة أو استفسار",
        quick_action_call: "جدولة مكالمة",
        quick_action_call_desc: "احجز مكالمة مع مستشار",
        quick_action_help: "زيارة مركز المساعدة",
        quick_action_help_desc: "استكشف المقالات والدروس",
        support_categories: "فئات الدعم",
        support_technical: "الدعم الفني",
        support_technical_desc: "مشاكل تقنية أو استفسارات عن المنصة",
        support_payments: "المستحقات المالية",
        support_payments_desc: "استفسارات حول المدفوعات والعمولات",
        support_accounts: "دعم الحسابات",
        support_accounts_desc: "تعديلات الحساب والتفعيل والمشاكل",
        support_faq: "الأسئلة الشائعة",
        support_faq_desc: "إجابات لأكثر الأسئلة تكراراً",
        faq_title: "أسئلة",
        faq_subtitle: "متكررة",
        faq_desc: "إجابات لأكثر الأسئلة شيوعاً حول الدعم",
        faq_q1: "كم تستغرق وقتاً للرد على استفسارات الدعم؟",
        faq_a1: "نرد على رسائل البريد الإلكتروني خلال 4 ساعات عمل، والدردشة الحية خلال دقائق.",
        faq_q2: "هل لديكم دعم باللغة العربية؟",
        faq_a2: "نعم، جميع فريق الدعم لدينا يتحدث العربية، ويمكنك التواصل معنا بالعربية في جميع القنوات.",
        faq_q3: "ما هي أوقات عمل الدعم الفني؟",
        faq_a3: "الدردشة الحية والدعم الفني متاحان 24/7، المكالمات الهاتفية من الأحد إلى الخميس من 9 ص حتى 6 م.",
        faq_browse_all: "تصفح جميع الأسئلة",
        office_badge: "معلومات المكتب",
        office_title: "زورونا في مكتبنا",
        office_subtitle: "نحن نرحب بكم دائماً",
        office_address: "درب عمر الدالر البيضاء",
        office_country: "المغرب",
        office_address_title: "العنوان",
        office_hours_title: "أوقات العمل",
        office_hours: "الاثنين - السبت: 9:00 ص - 6:00 م",
        office_visit_cta: "احجز زيارة للمكتب",
        cta_badge: "نحن هنا لخدمتك",
        cta_title: "هل لديك أي استفسار؟",
        cta_subtitle: "لا تتردد في التواصل معنا",
        cta_desc: "فريق الدعم لدينا جاهز للإجابة على جميع استفساراتك وحل أي مشكلة تواجهك.",
        cta_call_now: "اتصل بنا الآن",
        cta_email: "ارسل بريداً",
        cta_footer: "متوسط وقت الرد: 4 ساعات • نسبة الرضا: 98% • دعم متواصل 24/7",
      },
      policy: {
        hero_badge: "خصوصيتك أمانتنا",
        hero_title: "سياسة",
        hero_subtitle: "الخصوصية",
        hero_desc: "خصوصيتك مهمة بالنسبة لنا. تشرح هذه السياسة كيف نجمع معلوماتك ونستخدمها ونحميها.",
        last_updated: "آخر تحديث: 1 يناير 2024",
        section_collect_title: "المعلومات التي نجمعها",
        section_collect_subtitle: "المعلومات الشخصية",
        section_collect_desc: "نقوم بجمع المعلومات التي تقدمها لنا مباشرة، مثل إنشاء حساب، الانضمام إلى برنامج الشركاء، أو طلب الدعم.",
        collect_item1: "الاسم ومعلومات الاتصال (البريد الإلكتروني، رقم الهاتف)",
        collect_item2: "معلومات الدفع والضرائب لعمليات التحويل",
        collect_item3: "مواقع التواصل الاجتماعي لتوثيق الشراكة",
        collect_item4: "تفضيلات التواصل واختيارات التسويق",
        section_use_title: "كيف نستخدم معلوماتك",
        use_category1_title: "إدارة الحساب",
        use_category1_item1: "إنشاء وإدارة حساب الشريك",
        use_category1_item2: "معالجة المدفوعات",
        use_category1_item3: "تقديم الدعم الفني",
        use_category1_item4: "إرسال إشعارات الحساب الهامة",
        use_category2_title: "تحسين الخدمة",
        use_category2_item1: "تحليل الأداء والاستخدام",
        use_category2_item2: "تطوير ميزات وخدمات جديدة",
        use_category2_item3: "منع الاحتيال وسوء الاستخدام",
        use_category2_item4: "تعزيز أمان المنصة",
        section_share_title: "مشاركة المعلومات",
        section_share_subtitle: "لن نبيع بياناتك أبدًا",
        section_share_desc: "لا نقوم ببيع أو تأجير أو تبادل بياناتك الشخصية مع أطراف ثالثة لأغراض تسويقية. نشارك المعلومات في الحالات التالية فقط:",
        share_item1: "مع الشركاء التجاريين لتسهيل العلاقة",
        share_item2: "مع مقدمي الخدمات لتشغيل المنصة",
        share_item3: "إذا تطلب القانون أو لحماية حقوقنا",
        share_item4: "في حالة الاندماج أو نقل الأعمال",
        section_security_title: "أمان البيانات",
        section_security_subtitle: "حماية من مستوى المؤسسات",
        section_security_desc: "نقوم بتنفيذ إجراءات أمان معيارية لحماية معلوماتك الشخصية:",
        security_tech_title: "إجراءات تقنية",
        security_tech_item1: "تشفير SSL/TLS لنقل البيانات",
        security_tech_item2: "تشفير AES-256 للبيانات المخزنة",
        security_tech_item3: "اختبارات الأمان الدورية",
        security_tech_item4: "التحقق المتعدد العوامل",
        security_ops_title: "إجراءات تشغيلية",
        security_ops_item1: "وصول محدود للبيانات",
        security_ops_item2: "تدريب الأمان للموظفين",
        security_ops_item3: "إجراءات الاستجابة للحوادث",
        security_ops_item4: "نسخ احتياطي واختبار الاستعادة",
        section_rights_title: "حقوقك وخياراتك",
        right1_title: "الوصول والتحكم",
        right1_desc: "يمكنك الوصول إلى معلوماتك الشخصية أو تحديثها أو حذفها في أي وقت من خلال لوحة التحكم أو التواصل معنا.",
        right2_title: "الاتصالات التسويقية",
        right2_desc: "يمكنك إلغاء الاشتراك في رسائل البريد الإلكتروني في أي وقت من خلال رابط الإلغاء أو إعدادات الحساب.",
        right3_title: "قابلية نقل البيانات",
        right3_desc: "يمكنك طلب نسخة من بياناتك بصيغة قابلة للقراءة آليًا أو تحويلها إلى مزود آخر.",
        section_contact_title: "اتصل بنا",
        section_contact_desc: "إذا كان لديك أي استفسارات بخصوص سياسة الخصوصية أو ممارسات البيانات، يرجى التواصل معنا:",
        contact_privacy_officer: "مسؤول الخصوصية",
        contact_address_title: "العنوان البريدي",
        contact_address_company: "شركة Nextlead-Affiliate",
        contact_address_city: "الرياض، المملكة العربية السعودية",
        section_updates_title: "تحديثات السياسة",
        section_updates_desc: "قد نقوم بتحديث هذه السياسة من وقت لآخر لتعكس التغيرات. سنقوم بإعلامك بالتغييرات من خلال تحديث الصفحة وتاريخ 'آخر تحديث'.",
      },
      components: {
        homeProducts: {
          loading: "جاري التحميل...",
          no_products: "لا توجد منتجات متاحة",
          commission: "عمولة {commission}MAD",
          earn: "اربح: {earnings}د.م",
          promote_now: "روج الآن",
        },
        productSliders: {
          loading: "جاري التحميل...",
          new_arrival: "وصل حديثاً",
          most_requested: "المنتجات الأكثر طلباً",
          shop_now: "تسوق الان",
        },
      },
    },
    topseller: {
      home: {
        hero_badge: "منصة التسويق رقم 1",
        hero_title_1: "اربح أكثر مع شركاء",
        hero_title_2: "التسويق المميزين",
        hero_desc: "منصة متكاملة تجمع بين البائعين والمسوقين لخلق تجربة ربح استثنائية. ابدأ برحلة تحقيق الدخل مع أدوات محترفة وشبكة موثوقة.",
        cta_start: "ابدأ الآن مجاناً",
        cta_watch: "شاهد كيف تعمل",
        stat_marketers: "مسوق ناجح",
        stat_avg_profit: "متوسط الربح",
        features_badge: "لماذا تختارنا؟",
        features_title: "منصة مصممة لنجاح",
        features_subtitle: "مسوقي العصر الرقمي",
        feat1_title: "عمولات تنافسية",
        feat1_desc: "اربح حتى 70% عمولة على كل عملية بيع",
        feat2_title: "منتجات عالية التحويل",
        feat2_desc: "تروج لمنتجات مختارة بعناية من علامات تجارية موثوقة",
        feat3_title: "تحليلات متقدمة",
        feat3_desc: "رؤى مدعومة بالذكاء الاصطناعي لتحسين أدائك",
        feat4_title: "دفع آمن",
        feat4_desc: "مدفوعات منتظمة وآمنة مع شفافية كاملة",
        feat5_title: "مجتمع داعم",
        feat5_desc: "انضم إلى مجتمع من المسوقين الناجحين",
        feat6_title: "دعم 24/7",
        feat6_desc: "فريق دعم متاح على مدار الساعة",
        how_badge: "كيف تبدأ؟",
        how_title: "رحلة نجاح في",
        how_subtitle: "6 خطوات سهلة",
        step1_title: "إنشاء حساب",
        step1_desc: "سجل حسابك مجاناً في دقائق",
        step2_title: "اختر منتجاتك",
        step2_desc: "تصفح آلاف المنتجات عالية الربحية",
        step3_title: "ربط المتجر",
        step3_desc: "ربط منتجاتك مع منصتك بسهولة",
        step4_title: "ابدأ التسويق",
        step4_desc: "استخدم أدواتنا التسويقية المتقدمة",
        step5_title: "متابعة الطلبات",
        step5_desc: "تتبع جميع عمليات البيع في لوحة واحدة",
        step6_title: "استلم أرباحك",
        step6_desc: "تحويلات آمنة ومستمرة لأرباحك",
        model_title: "اختر مسارك",
        model_subtitle: "للنجاح",
        model_desc: "سواء كنت تريد تسويق منتجات الآخرين أو عرض منتجاتك الخاصة",
        model_partner_title: "شريك تسويق",
        model_partner_desc: "انضم إلى شبكتنا الواسعة من المسوقين واربح عمولات مميزة من ترويج منتجات عالية الجودة.",
        model_partner_item1: "عمولات تصل إلى 70%",
        model_partner_item2: "آلاف المنتجات المميزة",
        model_partner_item3: "أدوات تسويق متقدمة",
        model_partner_item4: "دفع أسبوعي",
        model_partner_item5: "دعم فني متكامل",
        model_partner_cta: "ابدأ كشريك",
        model_seller_title: "بائع",
        model_seller_desc: "اعرض منتجاتك على آلاف المسوقين المحترفين ووسع نطاق وصولك مع ضمان المبيعات.",
        model_seller_item1: "شبكة مسوقين واسعة",
        model_seller_item2: "إدارة كاملة للطلبات",
        model_seller_item3: "تتبع المبيعات",
        model_seller_item4: "دفع منتظم",
        model_seller_item5: "حماية المنتجات",
        model_seller_cta: "ابدأ كبائع",
        services_badge: "خدماتنا المتكاملة",
        services_title: "أكثر من مجرد منصة",
        services_subtitle: "شراكة شاملة",
        service1_title: "التعامل المباشر",
        service1_desc: "تعامل مباشر بدون وسيط مع تأمين كامل للمعاملات وضمان جودة المنتجات والخدمات المقدمة للعملاء النهائيين.",
        service1_feat1: "ضمان الجودة",
        service1_feat2: "تتبع مباشر",
        service1_feat3: "أمان كامل",
        service1_feat4: "شفافية",
        service2_title: "التدريب والإشراف",
        service2_desc: "برامج تدريبية متخصصة وإشراف مستمر من خبراء الصناعة لضمان نجاحك وتحقيق أقصى استفادة من المنصة.",
        service2_feat1: "دورات متخصصة",
        service2_feat2: "إشراف مباشر",
        service2_feat3: "تحديثات مستمرة",
        service2_feat4: "دعم الخبراء",
        service3_title: "مركز الاتصال",
        service3_desc: "خدمة عملاء متكاملة على مدار الساعة لتلبية جميع احتياجاتك وضمان رضا عملائك وتحقيق أفضل النتائج.",
        service3_feat1: "دعم فني 24/7",
        service3_feat2: "متابعة الطلبات",
        service3_feat3: "حل المشكلات",
        service3_feat4: "استشارات",
        products_badge: "المنتجات المميزة",
        products_title: "اكتشف المنتجات",
        products_subtitle: "الأعلى ربحاً",
        products_cta: "استكشف جميع المنتجات",
        cta_badge: "ابدأ رحلتك الآن",
        cta_title: "حان وقت",
        cta_subtitle: "تغيير حياتك",
        cta_desc: "انضم إلى آلاف الناجحين الذين حوّلوا شغفهم إلى مصدر دخل مستدام. لا تحتاج إلى خبرة، كل ما تحتاجه هو الإرادة للبدء.",
        cta_register: "سجل مجاناً الآن",
        cta_consult: "تواصل مع مستشار",
        cta_stat_marketers: "مسوق ناجح",
        cta_stat_profits: "أرباح موزعة",
        cta_stat_satisfaction: "رضا العملاء",
        cta_stat_support: "دعم فني",
      },
      about: {
        hero_title_1: "إعادة تعريف",
        hero_title_2: "التسويق بالعمولة",
        hero_desc: "نؤمن بأن نجاح مسوقينا هو نجاحنا. لذلك نبني منصة تجعل تحقيق الدخل أمراً سهلاً، شفافاً، ومجزياً للجميع.",
        vision_title: "رؤيتنا",
        vision_desc: "نطمح إلى خلق عالم حيث يمكن لأي شخص لديه شغف ومحتوى قيم تحقيق دخل مستدام من خلال التسويق بالعمولة، دون الحاجة إلى خبرة تقنية مسبقة.",
        vision_item1: "تمكين مليون مسوق بحلول 2025",
        vision_item2: "تصدير المواهب العربية عالمياً",
        vision_item3: "خلق اقتصاد رقمي مستدام",
        mission_title: "مهمتنا",
        mission_desc: "بناء الجسور بين العلامات التجارية الرائدة وصناع المحتوى الموهوبين، مع توفير الأدوات والتكنولوجيا التي تجعل الشراكة ناجحة للطرفين.",
        mission_item1: "تبسيط عمليات التسويق",
        mission_item2: "ضمان الشفافية الكاملة",
        mission_item3: "توفير أفضل المنتجات",
        story_badge: "قصتنا",
        story_title: "رحلة بدأت",
        story_subtitle: "بسؤال بسيط",
        story_quote: '"من فكرة صغيرة إلى منصة تغير حياة الآلاف"',
        story_p1: "في 2019، لاحظنا فجوة كبيرة بين العلامات التجارية التي تبحث عن مسوقين موثوقين وصناع المحتوى الذين يبحثون عن منتجات قيمة لترويجها. كان الجميع يخسر.",
        story_p2: "قررنا بناء الجسر الذي كان ينقص هذه الصناعة. بدأنا بفريق صغير من المتحمسين، ووضعنا نصب أعيننا هدفاً واحداً: جعل التسويق بالعمولة عادلاً للجميع.",
        story_p3: "اليوم، نحن فخورون بأننا قدمنا حلولاً غيرت حياة أكثر من 50,000 مسوق، وساعدنا آلاف العلامات التجارية على الوصول إلى جمهورها المناسب.",
        story_cta: "انضم إلى رحلتنا",
        stats_badge: "تأثيرنا بالأرقام",
        stats_title: "نجاحات تكلم",
        stats_subtitle: "عن نفسها",
        stat1_label: "مسوق ناجح",
        stat1_desc: "ينضم إلينا شهرياً",
        stat2_label: "عمولات مدفوعة",
        stat2_desc: "سنوياً للمسوقين",
        stat3_label: "علامة تجارية",
        stat3_desc: "مميزة معنا",
        stat4_label: "رضا العملاء",
        stat4_desc: "معدل الرضا العام",
        values_title: "قيمنا",
        values_subtitle: "الأساسية",
        values_desc: "المبادئ التي نعمل بها ونسير عليها في كل خطوة",
        value1_title: "الشفافية",
        value1_desc: "كل شيء واضح ومعلن، من العمولات إلى المدفوعات",
        value2_title: "العدالة",
        value2_desc: "نضمن حقوق الجميع ونعمل لصالح الطرفين",
        value3_title: "المجتمع",
        value3_desc: "نبني بيئة داعمة للتعلم والنمو المشترك",
        value4_title: "التطور",
        value4_desc: "نتطور باستمرار لنقدم الأفضل لشركائنا",
        team_badge: "العقول المبدعة",
        team_title: "قابل فريق",
        team_subtitle: "القادة",
        team_member1_role: "الرئيس التنفيذي",
        team_member1_bio: "15+ سنة في التسويق الرقمي، نائب رئيس سابق في جوجل",
        team_member2_role: "مدير التقنية",
        team_member2_bio: "مهندس سابق في فيسبوك، خريج MIT",
        team_member3_role: "مدير التسويق",
        team_member3_bio: "قائدة تسويق سابقة في أمازون، خبيرة النمو",
        team_member4_role: "مدير العمليات",
        team_member4_bio: "متخصص عمليات، ماجستير إدارة أعمال من ستانفورد",
        cta_badge: "مستقبل مشرق ينتظرك",
        cta_title: "كن جزءاً من",
        cta_subtitle: "قصة نجاحنا",
        cta_desc: "انضم إلى مجتمع من الناجحين الذين حولوا شغفهم إلى مصدر دخل. ابدأ رحلتك اليوم ودعنا نرافقك نحو النجاح.",
        cta_join: "انضم إلينا الآن",
        cta_consult: "تواصل مع مستشار",
      },
      contact: {
        hero_title: "لنبدأ",
        hero_subtitle: "محادثة",
        hero_desc: "لديك أسئلة؟ أفكار؟ نحن هنا للاستماع. فريق الدعم لدينا مستعد لمساعدتك في أي استفسار.",
        card_email_title: "البريد الإلكتروني",
        card_email_contact: "support.example.com",
        card_email_desc: "رد خلال 4 ساعات عمل",
        card_phone_title: "الهاتف",
        card_phone_contact: "+966 55 123 4567",
        card_phone_desc: "الأحد - الخميس 9ص - 5م",
        card_office_title: "المكتب",
        card_office_contact: "الدار البيضاء المغرب",
        card_office_desc: "مقابلات بتوافق مسبق",
        card_response_title: "وقت الاستجابة",
        card_response_contact: "24/7",
        card_response_desc: "دعم فني متواصل",
        form_success_title: "تم إرسال رسالتك!",
        form_success_desc: "شكراً لتواصلك معنا. سيقوم فريقنا بالرد عليك في أقرب وقت ممكن. عادةً ما نرد خلال 24 ساعة عمل.",
        form_success_another: "إرسال رسالة أخرى",
        form_title: "أرسل رسالتك",
        form_subtitle: "سنتواصل معك خلال 24 ساعة",
        form_name_label: "الاسم الكامل *",
        form_name_placeholder: "مثال: محمد أحمد",
        form_email_label: "البريد الإلكتروني *",
        form_email_placeholder: "email.example.com",
        form_subject_label: "الموضوع *",
        form_subject_placeholder: "ماذا تريد أن تناقش؟",
        form_message_label: "رسالتك *",
        form_message_placeholder: "أخبرنا بتفاصيل استفسارك...",
        form_submitting: "جاري الإرسال...",
        form_submit: "إرسال الرسالة",
        sidebar_why_title: "لماذا تتواصل معنا؟",
        sidebar_why_item1: "استفسارات حول برنامج الشراكة",
        sidebar_why_item2: "دعم فني للمنصة",
        sidebar_why_item3: "اقتراحات وتحسينات",
        sidebar_why_item4: "تعاون مع العلامات التجارية",
        sidebar_why_item5: "استشارات تسويقية",
        sidebar_why_item6: "مشاكل في المدفوعات",
        faq_title: "أسئلة شائعة",
        faq_q1: "كم يستغرق الرد؟",
        faq_a1: "نرد على جميع الاستفسارات خلال 24 ساعة عمل.",
        faq_q2: "هل الدعم مجاني؟",
        faq_a2: "نعم، جميع خدمات الدعم مجانية للمسوقين المسجلين.",
        faq_q3: "ما هي ساعات العمل؟",
        faq_a3: "الدعم الفني متاح 24/7 عبر التذاكر والبريد الإلكتروني.",
        faq_browse: "عرض جميع الأسئلة",
        social_proof_text: "دعم مذهل! فريق الدعم ساعدني في حل مشكلتي خلال ساعات قليلة. محترفون جداً.",
        social_proof_author: "- أحمد س، مسوق منذ 2020",
        location_title: "زورنا في",
        location_subtitle: "مكاتبنا",
        location_desc: "نحن دائماً سعداء باستقبالكم في مكاتبنا لمناقشة التعاونات والشراكات",
        location_name: "الدار البيضاء المغرب",
        office_hours_title: "ساعات العمل",
        office_hours_days: "الأحد - الخميس",
        office_hours_time: "9:00 ص - 5:00 م",
        office_direct_title: "الاتصال المباشر",
        office_direct_desc: "للشؤون العاجلة",
        office_email_title: "البريد السريع",
        office_email_desc: "للشؤون العامة",
        cta_badge: "مستعد للبدء؟",
        cta_title: "لنبدأ المحادثة",
        cta_subtitle: "اليوم",
        cta_desc: "فريقنا متحمس للتعرف عليك ومساعدتك في رحلتك. تواصل معنا الآن وابدأ في تحقيق أهدافك.",
        cta_start_chat: "ابدأ محادثة",
        cta_schedule: "جدولة مكالمة",
      },
      policy: {
        hero_title: "خصوصيتك",
        hero_subtitle: "أماننا",
        hero_desc: "نحن نؤمن بأن خصوصيتك هي حق أساسي. نقدم هنا شفافية كاملة حول كيفية حماية بياناتك.",
        nav_data: "بياناتك",
        nav_protection: "الحماية",
        nav_rights: "حقوقك",
        nav_contact: "الاتصال",
        nav_updates: "التحديثات",
        sidebar_key_title: "نقاط أساسية",
        sidebar_key_item1: "لا نبيع بياناتك لأي طرف ثالث",
        sidebar_key_item2: "شفافية كاملة في جمع البيانات",
        sidebar_key_item3: "حق الوصول والتحكم في بياناتك",
        sidebar_key_item4: "حماية تشفير من الدرجة الأولى",
        sidebar_questions_title: "أسئلة؟",
        sidebar_questions_desc: "لديك استفسار حول سياسة الخصوصية؟",
        sidebar_questions_cta: "تواصل معنا",
        section1_title: "البيانات التي نجمعها",
        section1_account_title: "معلومات الحساب",
        section1_account_desc: "نجمع المعلومات التي تقدمها عند إنشاء حساب أو تحديثه:",
        section1_basic_title: "معلومات أساسية",
        section1_basic_item1: "الاسم الكامل",
        section1_basic_item2: "البريد الإلكتروني",
        section1_basic_item3: "رقم الهاتف",
        section1_basic_item4: "العنوان",
        section1_payment_title: "معلومات الدفع",
        section1_payment_item1: "بيانات التحويل البنكي",
        section1_payment_item2: "معلومات الضرائب",
        section1_payment_item3: "سجل المدفوعات",
        section1_payment_item4: "تفضيلات الدفع",
        section1_usage_title: "معلومات الاستخدام",
        section1_usage_desc: "نجمع بيانات الاستخدام لتحسين خدماتنا:",
        section1_usage_text: "نشاط المنصة، تفاعلات المنتجات، بيانات الأداء، وتحليلات الاستخدام للمساعدة في تحسين تجربتك وتقديم توصيات مخصصة.",
        section2_title: "حماية بياناتك",
        section2_subtitle: "حماية متعددة الطبقات",
        section2_tech_title: "الأمان التقني",
        section2_tech_item1: "تشفير AES-256 للبيانات",
        section2_tech_item2: "SSL/TLS 1.3 للنقل",
        section2_tech_item3: "جدران حماية متقدمة",
        section2_tech_item4: "رصد مستمر للتهديدات",
        section2_ops_title: "إجراءات التشغيل",
        section2_ops_item1: "وصول محدود للبيانات",
        section2_ops_item2: "تدريب أمني للموظفين",
        section2_ops_item3: "فحوصات دورية للأمان",
        section2_ops_item4: "خطط استرداد الكوارث",
        section3_title: "حقوقك القانونية",
        right1_title: "حق الوصول",
        right1_desc: "طلب نسخة من بياناتك الشخصية",
        right2_title: "حق التصحيح",
        right2_desc: "تصحيح البيانات غير الدقيقة",
        right3_title: "حق الحذف",
        right3_desc: "طلب حذف بياناتك الشخصية",
        right4_title: "حق نقل البيانات",
        right4_desc: "نقل بياناتك إلى خدمة أخرى",
        section4_title: "مشاركة البيانات",
        section4_subtitle: "نحن لا نبيع بياناتك",
        section4_desc: "نحن لا نبيع أو نؤجر بياناتك الشخصية لأي طرف ثالث لأغراض تسويقية. نشارك البيانات فقط في الحالات التالية:",
        section4_item1: "مع مزودي الخدمات الضرورية لتشغيل المنصة",
        section4_item2: "للمراقبين القانونيين عند الالتزام بالقوانين",
        section4_item3: "في حالات الاندماج أو الاستحواذ على الشركة",
        section4_item4: "لحماية حقوقنا أو أمن المستخدمين",
        section5_title: "اتصل بنا",
        section5_desc: "لديك أسئلة أو مخاوف بشأن سياسة الخصوصية؟ نحن هنا لمساعدتك.",
        section5_officer_title: "مسؤول الخصوصية",
        section5_officer_email: "privacy.yourcompany.com",
        section5_officer_response: "رد خلال 48 ساعة عمل",
        section5_address_title: "العنوان البريدي",
        section5_address_company: "شركة ناجحون للتسويق",
        section5_address_city: "الرياض، المملكة العربية السعودية",
        section5_address_box: "صندوق بريد: 12345",
        section6_title: "تحديثات السياسة",
        section6_desc: "قد نقوم بتحديث هذه السياسة من وقت لآخر. سنقوم بإعلامك بأي تغييرات جوهرية:",
        section6_item1: "عرض الإشعارات في المنصة",
        section6_item2: "إرسال بريد إلكتروني إلى المسجلين",
        section6_item3: "تحديث تاريخ 'آخر تحديث' في هذه الصفحة",
        section6_item4: "طلب التأكيد للتغييرات الكبيرة",
        final_badge: "نفخر بحماية خصوصيتك",
        final_desc: "نحن ملتزمون بالشفافية الكاملة والحماية القصوى لبياناتك. نعتبرها مسؤولية نأخذها على محمل الجد.",
        final_cta: "تواصل مع مسؤول الخصوصية",
        final_faq: "الأسئلة الشائعة",
      },
      
      bank_select: {
        label_bank_name: "اسم البنك",
        placeholder_bank: "اختر البنك",
      },
      components: {
        homeProducts: {
          loading: "جاري التحميل...",
          no_products: "لا توجد منتجات متاحة",
          commission: "عمولة {commission}MAD",
          earn: "اربح: {earnings}د.م",
          promote_now: "روج الآن",
        },
      },
    },
  },

  activity_logs: {
    title: "سجل النشاطات",
    subtitle: "وحدة مراقبة أنشطة النظام",
    entries: "سجل",
    search: "بحث في السجلات...",
    search_btn: "بحث",
    filters: "فلاتر",
    loading: "جاري تحميل سجلات النشاطات...",
    loading_more: "جاري التحميل...",
    no_logs: "لم يتم العثور على سجلات نشاط",
    end: "نهاية السجلات",
    details: {
      ip_address: 'العنوان IP',
      user_agent: 'المتصفح',
      user_id: 'معرف المستخدم',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      role: 'الدور',
      order_id: 'معرف الطلب',
      client_id: 'معرف العميل',
      cart_id: 'معرف السلة',
      total: 'المجموع',
      changes: 'التغييرات',
      product_id: 'معرف المنتج',
      shopify_product_id: 'معرف Shopify',
      youcan_product_id: 'معرف YouCan',
      category_id: 'معرف الفئة',
      title: 'العنوان',
      variant_id: 'معرف التنويعة',
      fournisseur_id: 'معرف المورد',
      annonce_id: 'معرف الإعلان',
      reclamation_id: 'معرف الشكوى',
      blacklist_id: 'معرف القائمة السوداء',
      invoice_id: 'معرف الفاتورة',
      count: 'العدد',
      status: 'الحالة',
      old_status: 'الحالة القديمة',
      new_status: 'الحالة الجديدة',
      changed_by: 'تم التعديل بواسطة',
      livreur_id: 'معرف المندوب',
      company: 'الشركة',
      order_ids: 'معرفات الطلبات',
      updated_count: 'تم التحديث',
      confirmed_count: 'تم تأكيدها',
      total_count: 'المجموع',
      scan_data: 'بيانات المسح',
      webhook_payload: 'حمولة Webhook',
      success_count: 'النجاح',
      integration_id: 'معرف التكامل',
      app_name: 'التطبيق',
      config_id: 'معرف الإعدادات',
      company_id: 'معرف الشركة',
      payment_id: 'معرف الدفع',
      amount: 'المبلغ',
      phone: 'الهاتف',
      results: 'النتائج',
    },
    actions: {
      user: {
        login: 'تسجيل دخول',
        logout: 'تسجيل خروج',
        password_changed: 'تم تغيير كلمة المرور',
        registered: 'مستخدم مسجل',
        staff_registered: 'موظف مسجل',
        deleted: 'مستخدم محذوف',
        seller_status_changed: 'حالة البائع تغيرت',
        profile_updated: 'تم تحديث الملف الشخصي',
        saller_updated: 'تم تعديل البائع',
        saller_profile_updated: 'تم تحديث ملف البائع',
        admin_profile_updated: 'تم تحديث ملف المشرف',
        confirmator_profile_updated: 'تم تحديث ملف المؤكد',
      },
      order: {
        created: 'طلب تم إنشاؤه',
        cart_created: 'سلة تم إنشاؤها',
        updated: 'طلب تم تعديله',
        deleted: 'طلب تم حذفه',
        confirmed: 'طلب تم تأكيده',
        status_changed: 'حالة الطلب تغيرت',
        scanned: 'طلب تم مسحه',
        imported: 'طلب تم استيراده',
        ozon_status_changed: 'حالة Ozon تغيرت',
        livreur_status_changed: 'حالة المندوب تغيرت',
        sent_to_delivery: 'تم الإرسال للتوصيل',
        delivery_sync: 'مزامنة التوصيل',
        api_created: 'طلب تم إنشاؤه عبر API',
      },
      webhook: {
        turboliv: 'Webhook Turboliv',
        irsaliyat: 'Webhook Irsaliyat',
        sift: 'Webhook Sift',
        nexship: 'Webhook Nexship',
        nexship_v2: 'Webhook Nexship v2',
      },
      product: {
        created: 'منتج تم إنشاؤه',
        updated: 'منتج تم تعديله',
        deleted: 'منتج تم حذفه',
        pin_toggled: 'تبديل تثبيت المنتج',
        shopify_sync: 'مزامنة Shopify',
        youcan_sync: 'مزامنة YouCan',
        shopify_bulk_sync: 'مزامنة Shopify (دفعة)',
        youcan_bulk_sync: 'مزامنة YouCan (دفعة)',
      },
      role: {
        created: 'دور تم إنشاؤه',
        updated: 'دور تم تعديله',
        deleted: 'دور تم حذفه',
      },
      category: {
        created: 'فئة تم إنشاؤها',
        updated: 'فئة تم تعديلها',
        deleted: 'فئة تم حذفها',
      },
      variant: {
        created: 'تنويعة تم إنشاؤها',
        updated: 'تنويعة تم تعديلها',
        deleted: 'تنويعة تم حذفها',
      },
      fournisseur: {
        created: 'مورد تم إنشاؤه',
        updated: 'مورد تم تعديله',
        deleted: 'مورد تم حذفه',
      },
      annonce: {
        created: 'إعلان تم إنشاؤه',
        updated: 'إعلان تم تعديله',
        deleted: 'إعلان تم حذفه',
      },
      reclamation: {
        created: 'شكوى تم إنشاؤها',
        messages_seen: 'رسائل الشكوى تمت مشاهدتها',
      },
      blacklist: {
        added: 'مضاف إلى القائمة السوداء',
        removed: 'تمت الإزالة من القائمة السوداء',
      },
      invoice: {
        saller_paid: 'فاتورة البائع مدفوعة',
        confirmator_paid: 'فاتورة المؤكد مدفوعة',
        livreur_paid: 'فاتورة المندوب مدفوعة',
        saller_auto_generated: 'فاتورة البائع تلقائية',
        confirmator_auto_generated: 'فاتورة المؤكد تلقائية',
        livreur_auto_generated: 'فاتورة المندوب تلقائية',
      },
      config: {
        updated: 'تم تعديل الإعدادات',
      },
      payment_system: {
        updated: 'تم تعديل نظام الدفع',
      },
      delivery_company: {
        updated: 'تم تعديل شركة التوصيل',
      },
      integration: {
        oauth_initiated: 'OAuth تم البدء',
        updated: 'تم تعديل التكامل',
      },
      api_key: {
        generated: 'مفتاح API تم إنشاؤه',
        webhook_url: 'تم تسجيل عنوان Webhook API',
        webhook_status: 'تم تحديث حالة Webhook',
        revoked: 'تم إبطال مفتاح API',
      },
    },
  },
};

export default ar;
